// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.address-auto-complete {
  display: flex;
  flex-direction: column;
}
.address-auto-complete__title {
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 24px;
  color: #1a1e22;
}
.address-auto-complete__input-wrapper {
  position: relative;
  margin-bottom: 24px;
}
.address-auto-complete__input {
  display: flex;
  flex-direction: row;
  color: #1a1e22;
  width: 100%;
  outline: none;
  border: 2px solid #d8d8d8;
  border-radius: 50px;
  padding: 16px 48px;
  background: url('SearchIcon.4f03802dcf81f0abdc27.svg') no-repeat 16px;
}
.address-auto-complete__input:focus {
  border-color: #3d7c54;
}
.address-auto-complete__close-icon {
  position: absolute;
  right: 8px;
  top: 0;
  bottom: 0;
  width: 40px;
  background: url('black-x.ee73895ade137101c481.svg') no-repeat center;
  height: 40px;
  margin: auto 0;
  cursor: pointer;
}
.address-auto-complete__error-text {
  color: #c53d31;
  font-style: italic;
  margin-bottom: 8px;
}
.address-auto-complete__footer {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  color: #5d5d5e;
  justify-content: space-between;
}
.address-auto-complete__google-logo {
  display: inline;
  height: 20px;
  margin-left: 4px;
}
.address-auto-complete__cant-find-address-button {
  text-decoration: underline;
}
.address-auto-complete__cant-find-address-button:hover {
  color: #3d7c54;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.advisor-container {
  display: flex;
  flex-direction: column;
}
.advisor-label {
  font-size: 12px;
}
.advisor-input {
  font-size: 12px;
  padding: 16px;
  margin-bottom: 16px;
  width: 100%;
  height: 54px;
  border: 1px solid #c4c4c4;
  border-radius: 6px;
}
.advisor-input::-moz-placeholder {
  color: #5d5d5e;
}
.advisor-input::placeholder {
  color: #5d5d5e;
}
.advisor-select {
  font-size: 14px;
  padding: 16px;
  margin-bottom: 16px;
  width: 100%;
  height: 54px;
  border: 1px solid #c4c4c4;
  border-radius: 6px;
  cursor: pointer;
}
.advisor-button {
  height: 53px;
  border: 1px solid #c4c4c4;
  border-radius: 100px;
  background-color: #3d7c54;
  color: white;
  align-self: center;
  width: 200px;
}
.disabled-button {
  background-color: lightgray;
}
.advisor-image {
  margin-bottom: 8px;
  width: 150px;
}
.advisor-prompt {
  font-weight: 600;
}
.advisor-info {
  padding-bottom: 8px;
  display: flex;
  justify-content: center;
  text-align: center;
}
.advisor-accept-terms {
  margin-bottom: 16px;
}
.advisor-checkbox {
  margin-left: 4px;
  margin-right: 8px;
  height: 30px;
  width: 100%;
}
.advisor-checkbox-label {
  font-size: 12px;
  display: block;
  text-align: center;
}
.advisor-specify {
  font-style: italic;
}
.advisor-submit-container {
  padding-top: 24px;
  padding-bottom: 24px;
  display: flex;
  justify-content: center;
}
.referrer-last {
  margin-top: 24px;
}
.role-button {
  margin: 0 4px 24px 0;
  height: 40px;
  position: relative;
}
.role-button label,
.role-button input {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
}
.role-button input[type=radio] {
  opacity: 0.011;
  z-index: 100;
}
.role-button label {
  font-size: 12px;
  padding-top: 16px;
  height: 54px;
  text-align: center;
  border: 1px solid #c4c4c4;
  border-radius: 6px;
}
.role-button label:hover {
  border: 1px solid #3d7c54;
}
.role-selected {
  border: 3px solid #3d7c54 !important;
  box-shadow: 0px 0px 3px #3d7c54 inset;
}
.role-checkmark {
  margin-left: 90%;
  margin-top: -5%;
  visibility: hidden;
}
.role-checkmark-selected {
  margin-left: 90%;
  margin-top: -5%;
  visibility: visible;
}
.specify {
  border: 1px solid #3d7c54 !important;
}
.terms-list {
  font-size: 12px;
  padding: 24px 0 24px 32px;
  list-style-type: disc;
}
.accordion__button {
  font-size: 12px;
  background-color: transparent;
}
.accordion__button:hover {
  background-color: transparent;
}
.accordion {
  border: 1px solid #c4c4c4;
  border-radius: 6px;
}
.hide {
  display: none;
}
.advisor-success {
  font-size: 32px;
  margin-top: 50%;
  margin-bottom: 90%;
  text-align: center;
}
.advisor-link {
  font-size: 12px;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  color: #3d7c54;
  text-decoration: underline;
  text-decoration-color: #3d7c54;
}
@media (min-width: 950px) {
  .advisor-container {
    margin-top: -75px;
    width: 50%;
  }
  .form-container {
    display: flex;
    flex-direction: column;
    width: 50%;
  }
  .advisor-row {
    display: flex;
  }
  .advisor-column-left {
    flex: 40%;
  }
  .advisor-column-right {
    margin-left: 10%;
    flex: 40%;
  }
  .advisor-button:hover {
    cursor: pointer;
  }
  .disabled-button:hover {
    cursor: not-allowed;
  }
  .advisor-accept-terms {
    display: flex;
    align-items: center;
  }
  .advisor-checkbox {
    height: 15px !important;
    width: 15px !important;
  }
  .advisor-checkbox:hover {
    cursor: pointer;
  }
  .role-button {
    float: left;
  }
  .role-button label:hover {
    border: 1px solid #3d7c54;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.binary-button {
  width: 50%;
  transition: background-color 0.5s ease;
  padding: 16px;
  font-weight: 600;
  font-size: 14px;
  border: 1px solid #b2b2b2;
  color: #3d7c54;
  text-align: center;
  text-transform: uppercase;
}
.binary-button__title {
  font-weight: 600;
  font-size: 28px;
  margin-top: 24px;
  padding-right: 64px;
}
.binary-button__subtitle {
  margin-top: 30px;
  font-weight: 600;
  font-size: 18px;
}
.binary-button__wrapper {
  display: flex;
  flex-direction: row;
  padding: 24px 0 30px;
  cursor: pointer;
  overflow: hidden;
  width: 200px;
}
.binary-button:hover {
  background-color: #f2f2f2;
}
.binary-button.\\--active {
  background-color: #3d7c54;
  border-color: #3d7c54;
  color: #fff;
}
.binary-button.\\--active:hover {
  background-color: #1b3826;
}
.binary-button.\\--first {
  border-radius: 32px 0 0 32px;
  border-right: 0;
}
.binary-button.\\--last {
  border-radius: 0 32px 32px 0;
  border-left: 0;
}
.binary-button__container.\\--page-bottom .binary-button__wrapper {
  padding: 24px 0 0;
}
.binary-button__container.\\--small-titles .binary-button__title {
  margin-top: 30px;
  font-weight: 600;
  font-size: 18px;
}
.binary-button__container.\\--small-titles .binary-button__subtitle {
  margin-top: 6px;
  font-weight: 400;
  font-size: 14px;
}
.binary-button__container.\\--single-binary .binary-button__title {
  font-weight: 600;
  font-size: 28px;
  color: #1a1e22;
  line-height: 1.3;
  margin-bottom: 8px;
}
.binary-button__container.\\--single-binary .binary-button__subtitle {
  margin-bottom: 30px;
  margin-top: 0;
  font-weight: 400;
  font-size: 16px;
}
.binary-button__container.\\--update-rates {
  margin: 8px;
  width: 183px;
}
.binary-button__container.\\--update-rates .binary-button__subtitle {
  margin-bottom: 8px;
  margin-top: 0;
  font-weight: 400;
  font-size: 12px;
  text-transform: uppercase;
  display: block;
  color: #5d5d5e;
  line-height: 1.15;
}
.binary-button__container.\\--update-rates .binary-button__wrapper {
  padding: 0;
  width: 174px;
  height: 50px;
}
.binary-button__container.\\--update-rates .binary-button.\\--first {
  border-radius: 6px 0 0 6px;
}
.binary-button__container.\\--update-rates .binary-button.\\--last {
  border-radius: 0 6px 6px 0;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.checkbox {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  flex-wrap: wrap;
}
.checkbox__wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
  padding-bottom: 32px;
}
.checkbox__wrapper.\\--tight {
  margin-bottom: 16px;
  padding: 0;
}
.checkbox__wrapper.\\--tight .checkbox {
  font-size: 12px;
  line-height: 1.65;
}
.checkbox__wrapper.\\--error {
  padding-bottom: 8px;
}
.checkbox__wrapper.\\--error .checkbox__title {
  color: #c53d31;
}
.checkbox__wrapper.\\--error .checkbox__checkbox {
  border: 1px solid #c53d31;
}
.checkbox.\\--checked .checkbox__checkbox {
  background-color: #3d7c54;
  border-color: #3d7c54;
}
.checkbox.\\--checked .checkbox__check-mark {
  display: block;
}
.checkbox__title {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 24px;
}
.checkbox__checkbox {
  border: 1px solid #b2b2b2;
  border-radius: 5px;
  flex-shrink: 0;
  height: 28px;
  margin-right: 24px;
  margin-top: 3px;
  width: 28px;
}
.checkbox__checkbox:hover {
  border: 1px solid #3d7c54;
  cursor: pointer;
}
.checkbox__check-mark {
  display: none;
  height: 26px;
  padding: 5px;
  width: 26px;
}
.checkbox__label {
  margin-bottom: 12px;
  width: calc(100% - 52px);
}
.checkbox__label .text-theme-highlight {
  color: #3d7c54;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.checkbox-multi {
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid #dddddd;
}
.checkbox-multi.\\--no-underline {
  border-bottom: none;
  padding-bottom: 0;
}
.checkbox-multi.\\--error {
  padding-bottom: 8px;
}
.checkbox-multi.\\--error .checkbox-multi__title {
  color: #c53d31;
}
.checkbox-multi.\\--error .checkbox-multi__checkbox {
  border: 1px solid #c53d31;
}
.checkbox-multi.\\--error .checkbox-multi__textarea {
  border-color: #c53d31;
}
.checkbox-multi.\\--tight {
  margin-bottom: 16px;
  padding: 0;
}
.checkbox-multi.\\--tight .checkbox-multi__single-option {
  font-size: 12px;
  line-height: 1.65;
}
.checkbox-multi.\\--nested {
  border-bottom: none;
  padding-left: 36px;
  padding-bottom: 0;
  margin-bottom: 0;
}
.checkbox-multi__content {
  font-size: 14px;
  margin-bottom: 24px;
}
.checkbox-multi__bottom-content {
  font-size: 14px;
  margin-bottom: 24px;
}
.checkbox-multi__title {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 24px;
}
.checkbox-multi__single-option {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  flex-wrap: wrap;
}
.checkbox-multi__single-option.\\--checked > .checkbox-multi__checkbox {
  background-color: #3d7c54;
  border-color: #3d7c54;
}
.checkbox-multi__single-option.\\--checked > .checkbox-multi__checkbox .checkbox-multi__check-mark {
  display: block;
}
.checkbox-multi__checkbox {
  border: 1px solid #b2b2b2;
  border-radius: 3px;
  flex-shrink: 0;
  height: 20px;
  margin-right: 16px;
  width: 20px;
}
.checkbox-multi__checkbox:hover {
  border: 1px solid #3d7c54;
  cursor: pointer;
}
.checkbox-multi__check-mark {
  display: none;
  height: 18px;
  padding: 2px;
  width: 18px;
}
.checkbox-multi__checkbox-label {
  margin-bottom: 12px;
  width: calc(100% - 36px);
}
.checkbox-multi__textarea {
  margin-left: 36px;
  min-height: 55px;
  width: 100%;
}
.checkbox-multi--old {
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid #dddddd;
}
.checkbox-multi--old.\\--no-underline {
  border-bottom: none;
  padding-bottom: 0;
}
.checkbox-multi--old.\\--error {
  padding-bottom: 8px;
}
.checkbox-multi--old.\\--error .checkbox-multi__title {
  color: #c53d31;
}
.checkbox-multi--old.\\--error .checkbox-multi__checkbox {
  border: 1px solid #c53d31;
}
.checkbox-multi--old.\\--error .checkbox-multi__textarea {
  border-color: #c53d31;
}
.checkbox-multi--old.\\--tight {
  margin-bottom: 16px;
  padding: 0;
}
.checkbox-multi--old.\\--tight .checkbox-multi__single-option {
  font-size: 12px;
  line-height: 1.65;
}
.checkbox-multi--old .checkbox-multi__title {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 24px;
}
.checkbox-multi--old .checkbox-multi__single-option {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  flex-wrap: wrap;
}
.checkbox-multi--old .checkbox-multi__single-option.\\--checked .checkbox-multi__checkbox {
  background-color: #3d7c54;
  border-color: #3d7c54;
}
.checkbox-multi--old .checkbox-multi__single-option.\\--checked .checkbox-multi__check-mark {
  display: block;
}
.checkbox-multi--old .checkbox-multi__nested-single-option {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  flex-wrap: wrap;
  padding-left: 32px;
}
.checkbox-multi--old .checkbox-multi__nested-single-option.\\--checked .checkbox-multi__nested-checkbox {
  background-color: #3d7c54;
  border-color: #3d7c54;
}
.checkbox-multi--old .checkbox-multi__nested-single-option.\\--checked .checkbox-multi__nested-check-mark {
  display: block;
}
.checkbox-multi--old .checkbox-multi__checkbox {
  border: 1px solid #b2b2b2;
  border-radius: 3px;
  flex-shrink: 0;
  height: 20px;
  margin-right: 16px;
  width: 20px;
}
.checkbox-multi--old .checkbox-multi__checkbox:hover {
  border: 1px solid #3d7c54;
  cursor: pointer;
}
.checkbox-multi--old .checkbox-multi__check-mark {
  display: none;
  height: 18px;
  padding: 2px;
  width: 18px;
}
.checkbox-multi--old .checkbox-multi__nested-checkbox {
  border: 1px solid #b2b2b2;
  border-radius: 3px;
  flex-shrink: 0;
  height: 20px;
  margin-right: 16px;
  width: 20px;
}
.checkbox-multi--old .checkbox-multi__nested-checkbox:hover {
  border: 1px solid #3d7c54;
  cursor: pointer;
}
.checkbox-multi--old .checkbox-multi__nested-check-mark {
  display: none;
  height: 18px;
  padding: 2px;
  width: 18px;
}
.checkbox-multi--old .checkbox-multi__checkbox-label {
  margin-bottom: 12px;
  width: calc(100% - 36px);
}
.checkbox-multi--old .checkbox-multi__textarea {
  border: 1px solid #b2b2b2;
  border-radius: 3px;
  height: 55px;
  margin-bottom: 24px;
  margin-left: 36px;
  min-height: 55px;
  padding: 15px;
  width: 100%;
}
.checkbox-multi--old .checkbox-multi__textarea.\\--nested {
  margin-left: 64px;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.compare-page__heading-group {
  margin-bottom: 32px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  max-width: 750px;
}
@media (min-width: 950px) {
  .compare-page__heading-group {
    padding: 0 24px;
  }
}
.compare-page__title {
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 32px;
  color: #1a1e22;
  line-height: 1.4;
  text-align: center;
}
@media (min-width: 950px) {
  .compare-page__title {
    font-size: 48px;
  }
}
.compare-page__subtitle {
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 1.5px;
  color: #3d7c54;
  text-transform: uppercase;
}
.compare-page__description {
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #1a1e22;
}
@media (min-width: 950px) {
  .compare-page__description {
    font-size: 18px;
  }
}
.compare-page__legal-tooltip {
  margin: -4px 0 0 4px;
}
.compare-page__legal-tooltip:hover {
  cursor: pointer;
}
.compare-page__disclaimer-block {
  font-size: 12px;
  margin: 24px 4px;
  max-width: 800px;
}
@media (min-width: 950px) {
  .compare-page__disclaimer-block {
    margin: 32px 96px;
  }
}
.compare-page__upload-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  max-width: 1000px;
  width: 100%;
}
.compare-page__upload-wrapper.\\--truncated {
  margin-bottom: 0;
}
@media (min-width: 950px) {
  .compare-page__upload-wrapper {
    padding: 0 64px;
  }
}
.compare-page__values-subtitle {
  font-weight: 600;
  font-size: 32px;
  letter-spacing: 0.25px;
  margin-top: 32px;
  color: #1a1e22;
  text-align: center;
}
@media (min-width: 950px) {
  .compare-page__values-subtitle {
    text-align: left;
  }
}
.compare-page__next {
  display: flex;
  margin: 24px 0;
  align-items: center;
  display: flex;
}
.compare-page__next.link {
  text-decoration: none;
}
.compare-page__next.link:hover {
  text-decoration: underline;
}
.compare-page__next-arrow {
  margin-left: 16px;
  height: 20px;
  transform: rotateZ(270deg);
}
.compare-page__button-wrapper {
  margin-top: 16px;
  min-width: 210px;
}
.compare-page__values {
  display: flex;
  flex-direction: column;
  margin: 32px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1000px;
  width: 100%;
}
@media (min-width: 950px) {
  .compare-page__values {
    display: flex;
    flex-direction: row;
    padding: 0 96px;
  }
}
.compare-page__value {
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
  flex-basis: 100%;
  align-items: flex-start;
}
@media (min-width: 950px) {
  .compare-page__value {
    margin: 0 24px 24px;
  }
}
.compare-page__value-subtitle {
  font-weight: 600;
  font-size: 28px;
  color: #1a1e22;
}
.compare-page__value-img {
  margin-right: 16px;
  -o-object-fit: contain;
     object-fit: contain;
  max-width: 55px;
  height: auto;
}
.compare-page__value-text-container {
  display: flex;
  flex-direction: column;
}
.compare-page__footer-img {
  margin-bottom: 24px;
  display: none;
  overflow: hidden;
}
@media (min-width: 950px) {
  .compare-page__footer-img {
    display: block;
    max-width: 100%;
  }
}
.compare-page__footer-img.\\--bankrate {
  margin-top: 48px;
}
.compare-page__disclosure-link {
  margin-bottom: 16px;
  text-decoration: underline;
  color: #3d7c54;
  align-self: center;
  cursor: pointer;
}
@media (min-width: 950px) {
  .compare-page__disclosure-link {
    margin-right: 32px;
    align-self: flex-end;
  }
}
.compare-page__social {
  display: flex;
  align-items: center;
  gap: 16px;
}
.compare-page__social-icon {
  height: 32px;
}
.compare-security-msg {
  display: flex;
  flex-direction: column;
  padding: 32px;
  border: 1px solid #dddddd;
  border-radius: 20px;
  max-width: 500px;
}
.compare-security-msg__wrap {
  display: flex;
  margin-bottom: 64px;
  justify-content: center;
}
.compare-security-msg__blurb {
  font-size: 14px;
  margin-bottom: 16px;
  color: #1a1e22;
}
.compare-security-msg__shield-icon {
  width: 16px;
  margin-right: 8px;
  display: inline;
  height: 18px;
  vertical-align: text-top;
}
.compare-security-msg__disclosure {
  font-size: 11px;
  line-height: 16px;
  text-align: left;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.date-picker > label {
  font-size: 12px;
  color: #5d5d5e;
  left: 0;
  line-height: 1.15;
  position: relative;
  text-transform: uppercase;
  top: -8px;
  transform: none !important;
}
.date-picker > div > input {
  font-size: 14px;
  color: #5d5d5e;
}
.date-picker > div > input::-moz-placeholder {
  color: #5d5d5e;
  opacity: 1;
}
.date-picker > div > input::placeholder {
  color: #5d5d5e;
  opacity: 1;
}
.date-picker > div > fieldset > legend {
  max-width: 0px;
}
.\\--question-label > div > label {
  font-weight: 600;
  font-size: 16px;
  color: #1a1e22;
  text-transform: initial;
}
.input.\\--set-date-half-width .date-picker > label {
  max-width: 170px;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.education-section {
  font-weight: 400;
  font-size: 18px;
  padding: 24px;
  max-width: 1100px;
  margin: 0 auto 16px;
}
.education-section__call-out-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #dddddd;
}
@media (min-width: 950px) {
  .education-section__call-out-container {
    display: flex;
    flex-direction: row;
    padding: 24px;
  }
}
.education-section__title {
  font-weight: 600;
  font-size: 28px;
  letter-spacing: 1px;
  margin-bottom: 16px;
}
.education-section__card {
  display: flex;
  flex-direction: column;
  font-weight: 600;
  font-size: 22px;
  margin: 24px;
}
.education-section__card-subtitle, .education-section__lockin-subtitle {
  font-weight: 600;
  font-size: 22px;
  line-height: 24px;
}
.education-section__card-subhead {
  font-weight: 600;
  font-size: 14px;
}
.education-section__card-body {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
}
.education-section__arrow-container {
  display: flex;
  flex-direction: row;
  margin: 16px 16px 16px 0;
}
.education-section__arrow-container img {
  display: inline;
  height: 38px;
  margin-bottom: 8px;
}
.education-section__arrow:first-child {
  margin-right: 32px;
}
.education-section__divider {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
@media (min-width: 950px) {
  .education-section__divider {
    display: flex;
    flex-direction: column;
  }
}
.education-section__vertical-line {
  flex: 1;
  border-bottom: 1px solid #b2b2b2;
}
@media (min-width: 950px) {
  .education-section__vertical-line {
    border-left: 1px solid #b2b2b2;
  }
}
@media (min-width: 950px) {
  .education-section__vertical-line.\\--top {
    margin-bottom: 8px;
  }
}
@media (min-width: 950px) {
  .education-section__vertical-line.\\--bottom {
    margin-top: 8px;
  }
}
.education-section__circle {
  font-weight: 600;
  font-size: 12px;
  margin: 0 8px;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  color: #fff;
  text-align: center;
  line-height: 32px;
  background: #1a1e22;
}
.education-section__lockin-container {
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
  margin-bottom: 24px;
}
.education-section__lockin-container:not(:last-child) {
  border-bottom: 1px solid #dddddd;
}
@media (min-width: 950px) {
  .education-section__lockin-container {
    display: flex;
    flex-direction: row;
  }
}
.education-section__image-container {
  margin-right: 32px;
  margin-bottom: 16px;
  width: 80px;
}
@media (min-width: 950px) {
  .education-section__image-container {
    margin-bottom: 0;
  }
}
.education-section__lockin-image {
  width: 100%;
}
.education-section__lockin-subtitle {
  margin-bottom: 8px;
}
.education-section__lockin-body {
  font-size: 18px;
}
@media (min-width: 950px) {
  .education-section__lockin-body {
    max-width: 90%;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.footer {
  font-size: 10px;
  color: #5d5d5e;
  text-align: center;
}
.footer__equal-housing-icon {
  display: inline-block;
  fill: #5d5d5e;
  margin: -15px;
  margin-right: -12px;
  position: relative;
  width: 50px;
}
.footer__link {
  color: #3d7c54;
  text-decoration: underline;
}
.footer__compliance-container {
  max-width: 600px;
}
.footer a {
  padding: 4px;
  color: #3d7c54;
  cursor: pointer;
}
.footer span {
  color: #3d7c54;
}
.footer.\\--welcome {
  margin-top: 32px;
  max-width: 415px;
  width: 80%;
}
.main-footer__info-block-link {
  text-decoration: underline;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.hamburger {
  margin: 0 16px;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.hamburger__modal {
  display: flex;
  flex-direction: row;
  color: #1a1e22;
  height: 100%;
  justify-content: center;
  overflow-y: auto;
  padding: 0;
  position: relative;
  width: 100%;
}
.hamburger__modal-content {
  display: flex;
  flex-direction: column;
  padding: 0 32px;
  max-width: 375px;
  text-align: center;
  width: 100%;
}
.hamburger__sage-logo-wrapper {
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;
  height: 75px;
  justify-content: center;
}
.hamburger__sage-logo {
  padding: 16px 32px;
}
.hamburger__loan-officer-header {
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 24px;
  text-align: left;
}
.hamburger__loan-officer-wrapper {
  margin-bottom: 32px;
}
.hamburger__loan-officer {
  display: flex;
  flex-direction: row;
}
.hamburger__loan-officer-headshot-wrapper {
  align-self: flex-start;
  margin-right: 20px;
}
.hamburger__loan-officer-headshot {
  border-radius: 50%;
  height: 50px;
  -o-object-fit: cover;
     object-fit: cover;
  width: 50px;
}
.hamburger__loan-officer-info {
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
  text-align: left;
}
.hamburger__loan-officer-name {
  font-weight: 600;
  font-size: 22px;
}
.hamburger__loan-officer-title {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 8px;
  line-height: 14px;
}
.hamburger__loan-officer-nmls {
  font-weight: 400;
  font-size: 14px;
}
.hamburger__loan-officer-contact-buttons {
  display: flex;
  flex-direction: row;
  margin-bottom: 32px;
}
.hamburger__loan-officer-contact-buttons button {
  margin-right: 4px;
  margin-bottom: 0;
}
.hamburger__loan-officer-contact-buttons button:last-child {
  margin-right: 0;
}
.hamburger__nav-links {
  display: flex;
  flex-direction: column;
  margin: 24px 0 32px;
  justify-content: center;
}
.hamburger__nav-links li {
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 32px;
  color: #1a1e22;
  letter-spacing: 2px;
  text-transform: uppercase;
}
.hamburger__buttons {
  margin-bottom: 32px;
}
.hamburger__buttons button {
  margin: 0 0 24px;
  flex-grow: 0;
  width: 100%;
}
.hamburger__footer-links {
  display: flex;
  flex-direction: column;
  padding: 0 32px 64px;
}
.hamburger__footer-links li {
  margin-bottom: 24px;
}
.hamburger__close-button {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 96px;
  height: 78px;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.income {
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid #dddddd;
}
.income.\\--no-underline {
  border-bottom: none;
  padding-bottom: 0;
}
.income.\\--error {
  padding-bottom: 8px;
}
.income.\\--error .income__title {
  color: #c53d31;
}
.income.\\--error .income__checkbox {
  border: 1px solid #c53d31;
}
.income.\\--error .income__textarea {
  border-color: #c53d31;
}
.income.\\--tight {
  margin-bottom: 16px;
  padding: 0;
}
.income.\\--tight .checkbox-multi__single-option {
  font-size: 12px;
  line-height: 1.65;
}
.income__title {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 24px;
}
.income__subtitle {
  font-size: 12px;
  letter-spacing: 0.75px;
  color: #5d5d5e;
  line-height: 1.15;
  margin-bottom: 4px;
}
.income__single-option {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  border-top: 1px solid #b2b2b2;
  flex-wrap: wrap;
}
.income__single-option:last-child {
  border-bottom: 1px solid #b2b2b2;
}
.income__single-option.\\--checked .income__checkbox {
  background-color: #3d7c54;
  border-color: #3d7c54;
}
.income__single-option.\\--checked .income__check-mark {
  display: block;
}
.income__checkbox {
  border: 1px solid #b2b2b2;
  border-radius: 3px;
  flex-shrink: 0;
  height: 20px;
  margin-top: 12px;
  margin-right: 16px;
  width: 20px;
}
.income__checkbox:hover {
  border: 1px solid #3d7c54;
  cursor: pointer;
}
.income__check-mark {
  display: none;
  height: 18px;
  padding: 2px;
  width: 18px;
}
.income__checkbox-label {
  margin-top: 12px;
  margin-bottom: 12px;
  width: calc(100% - 36px);
}
.income__textarea {
  height: 55px;
  margin-left: 36px;
  min-height: 55px;
  width: 100%;
  margin-bottom: 12px;
}
.income__total {
  font-weight: 600;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.info-block {
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
}
.info-block__title {
  margin-bottom: 8px;
}
.info-block__content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.info-block__text {
  line-height: 20px;
  margin-top: 2px;
  margin-left: 8px;
  font-size: 12px;
  color: #1a1e22;
}
.info-block__error-button {
  padding: 0 4px 0 8px;
  display: flex;
  justify-content: center;
  height: -moz-fit-content;
  height: fit-content;
}
.info-block__error-button-icon {
  width: 20px;
}
.info-block__link {
  font-weight: 600;
  text-decoration: underline;
}
.info-block.--info {
  background-color: #f1f9f1;
}
.info-block.--danger {
  background-color: #ffeaea;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.input {
  margin-bottom: 20px;
}
.input:focus-within .input__subtitle {
  color: #3d7c54;
}
.input.\\--error .input__subtitle {
  color: #c53d31;
}
.input.\\--error .input__field,
.input.\\--error .select__anchor {
  border-color: #c53d31;
}
.input.\\--top-spacing {
  margin-top: 24px;
}
.input.\\--attached-to-radio {
  border-top: 3px solid white;
  margin-top: -3px;
  border-bottom: 1px solid #d8d8d8;
  padding-bottom: 32px;
}
.input.\\--narrow {
  width: 50%;
}
.input.\\--update-rates {
  width: 183px;
  margin: 8px;
}
.input.\\--non-page-header .input__title {
  font-weight: 600;
  font-size: 16px;
}
.input__title {
  font-weight: 600;
  font-size: 28px;
  color: #1a1e22;
  line-height: 1.3;
  margin-bottom: 16px;
}
.input__subtitle {
  margin-bottom: 8px;
  font-size: 12px;
  text-transform: uppercase;
  color: #5d5d5e;
  line-height: 1.15;
}
.input__field {
  border-radius: 6px;
  padding: 16px;
  font-size: 14px;
  border: 1px solid #c4c4c4;
  color: #1a1e22;
  line-height: 1.15;
  outline: none;
  width: 100%;
}
.input__field::-moz-placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #5d5d5e;
  opacity: 1; /* Firefox */
}
.input__field::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #5d5d5e;
  opacity: 1; /* Firefox */
}
.input__field:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #5d5d5e;
}
.input__field::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #5d5d5e;
}
.input__field:focus {
  border: 1px solid #3d7c54;
}
.input__field.\\--currency {
  padding: 16px 16px 16px 32px;
}
.input__field.\\--ssn {
  padding: 16px 16px 16px 56px;
  letter-spacing: 8px;
  background: url('LockIcon.f2ebb00156026b983811.svg') no-repeat 16px;
  margin: 0;
}
.input__field.\\--ssn.\\--hidden {
  -webkit-text-security: disc;
}
.input__currency-wrapper {
  position: relative;
}
.input__currency-indicator {
  font-size: 14px;
  bottom: 30px;
  color: #1a1e22;
  left: 15px;
  position: absolute;
  top: 15px;
}
.input__ssn-input-wrapper, .input__pass-input-wrapper {
  position: relative;
  margin: 4px 0 16px;
}
.input__ssn-show-button, .input__pass-show-button {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto 0;
  padding: 0 16px;
  color: #3d7c54;
}
.input__ssn-security-blurb {
  font-size: 14px;
  color: #1a1e22;
  margin-bottom: 24px;
}
.input__ssn-shield-icon {
  width: 16px;
  display: inline;
  height: 18px;
  margin-right: 8px;
  vertical-align: text-top;
}
.input.\\--hide-ssn-security-blurb .input__ssn-security-blurb {
  display: none;
}
.input__field-wrapper, .input__currency-wrapper, .input__telephone-wrapper, .input__zipcode-wrapper {
  position: relative;
  width: 100%;
}
.input__clear-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #b2b2b2;
  padding: 2px;
}
@media (max-width: 768px) {
  .input__clear-button {
    padding: 4px;
  }
}
@media (min-width: 300px) and (max-width: 600px) {
  .input__field.\\--ssn {
    letter-spacing: 2px;
  }
}
@media (min-width: 300px) {
  .input__ssn-show-button {
    padding: 0 8px;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.link {
  cursor: pointer;
  text-decoration: underline;
  color: #3d7c54;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.content-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 60vh;
  justify-content: center;
}
.content-loading__gif {
  height: 128px;
  margin-bottom: 24px;
  width: 128px;
}
.content-loading__text {
  text-align: center;
}
.content-loading__title {
  font-weight: 700;
  font-size: 22px;
  margin-bottom: 16px;
  line-height: 1;
}
.loading-val-props {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.loading-val-props__gif {
  height: 128px;
  margin-bottom: 24px;
  width: 128px;
}
.loading-val-props__heading {
  font-weight: 600;
  font-size: 32px;
  margin-bottom: 32px;
  line-height: 1.3;
}
.loading-val-props__text {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #dddddd;
}
.loading-val-props__carousel-wrapper {
  height: 234px;
  overflow-x: clip;
}
.loading-val-props__carousel {
  transform-style: preserve-3d;
}
.loading-val-props__carousel-prop {
  bottom: 0;
  margin: 0 auto;
  opacity: 0;
  position: absolute;
  transition: transform 0.5s, opacity 0.5s, z-index 0.5s;
  width: 100%;
  z-index: 4;
}
.loading-val-props__carousel-prop.initial, .loading-val-props__carousel-prop.active {
  opacity: 1;
  position: relative;
  z-index: 3;
}
.loading-val-props__carousel-prop.prev, .loading-val-props__carousel-prop.next {
  z-index: 2;
}
.loading-val-props__carousel-prop.prev {
  transform: translateX(100%);
}
.loading-val-props__carousel-prop.next {
  transform: translateX(-100%);
}
.loading-val-props__carousel-icon {
  margin: 10px auto;
}
.loading-val-props__carousel-heading {
  font-size: 18px;
  display: flex;
  margin-bottom: 8px;
  align-items: center;
  color: #3d7c54;
  font-weight: 500;
  justify-content: center;
}
.loading-val-props__tooltip {
  margin-left: 5px;
}
.loading-val-props__carousel-copy {
  font-size: 13px;
  width: 80%;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.fee-estimate {
  width: 83.3333333333%;
  border-radius: 4px;
  overflow-y: scroll;
  position: relative;
  max-height: 75vh;
  max-width: 620px;
}
.fee-estimate__close-button-wrap {
  padding-right: 16px;
  padding-top: 16px;
  position: absolute;
  top: 0;
  right: 0;
}
@media (min-width: 950px) {
  .fee-estimate__close-button-wrap {
    padding-right: 32px;
    padding-top: 32px;
  }
}
.fee-estimate__close-button {
  height: 24px;
  width: 24px;
  cursor: pointer;
}
.fee-estimate__close-button-icon {
  width: 100%;
  height: 100%;
}
.fee-estimate__main-section {
  padding: 32px;
}
.fee-estimate__main-heading {
  font-weight: 600;
  font-size: 22px;
}
.fee-estimate__tabs {
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
  overflow-y: scroll;
  border-bottom: 1px solid #f2f2f2;
}
@media (min-width: 950px) {
  .fee-estimate__tabs {
    justify-content: space-between;
  }
}
.fee-estimate__tab {
  padding: 8px;
  white-space: nowrap;
}
.fee-estimate__tab.\\--active {
  border-bottom: 3px solid #3d7c54;
  outline: 0;
}
.fee-estimate__tooltip {
  margin-left: 4px;
}
.fee-estimate__main-blurb {
  padding-right: 32px;
  margin-bottom: 16px;
}
.fee-estimate__section:not(:last-child) {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #dddddd;
}
.fee-estimate__section-title {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 16px;
}
.fee-estimate__sub-section {
  margin-bottom: 8px;
}
.fee-estimate__sub-section-title {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 8px;
}
.fee-estimate__sub-section-info .info-block__text {
  display: block;
}
.fee-estimate__cash-info {
  font-weight: 600;
  font-size: 14px;
}
.fee-estimate__line-item, .fee-estimate__section-total {
  display: flex;
  justify-content: space-between;
}
.fee-estimate__section-total {
  font-weight: 600;
  font-size: 22px;
  color: #3d7c54;
}
.fee-estimate__main-section.\\--summary {
  background-color: #e3efe6;
}
.fee-estimate__disclosure {
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 16px;
  color: #5d5d5e;
}
.fee-estimate__disclosure:last-child {
  margin-bottom: 0;
}
.loan-officer-card {
  margin: 24px 0;
}
.loan-officer-card__header {
  margin: 16px 0;
  font-weight: 600;
  font-size: 22px;
}
.loan-officer-card__lo-container {
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-radius: 8px;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #b2b2b2;
}
.loan-officer-card__details {
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  align-self: unset;
}
.loan-officer-card__headshot {
  margin: 8px;
  align-self: center;
  border-radius: 50%;
  height: 68px;
  width: 68px;
  -o-object-fit: cover;
     object-fit: cover;
  -o-object-position: 0 0;
     object-position: 0 0;
}
.loan-officer-card__greeting-container {
  margin: 8px;
  text-align: center;
}
.loan-officer-card__name-heading {
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
}
.loan-officer-card__body {
  font-size: 14px;
  line-height: 24px;
}
.loan-officer-card__contact {
  display: flex;
  flex-direction: column;
  margin-right: 0;
  justify-content: center;
  align-items: center;
}
.loan-officer-card__contact-mobile-container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
}
.loan-officer-card__contact-desktop-container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: left;
}
.loan-officer-card__contact-button {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  margin: 8px;
  padding: 16px;
  border-radius: 64px;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 55px;
  border: 1px solid #1a1e22;
}
.loan-officer-card__contact-button:hover {
  color: #5d5d5e;
}
.loan-officer-card__contact-info {
  display: flex;
  flex-direction: row;
  justify-content: left;
  margin: 8px;
}
.loan-officer-card__contact-icon {
  margin-right: 16px;
  width: 26px;
  color: #3d7c54;
}
.loan-officer-card__schedule-a-call {
  font-size: 14px;
  margin: 8px;
  padding: 16px;
  border-radius: 64px;
  text-align: center;
  width: 200px;
  height: 55px;
  border: 1px solid #1a1e22;
  background-color: #3d7c54;
  color: #fff;
  cursor: pointer;
}
.loan-officer-nav-card {
  font-size: 14px;
  color: #fff;
  position: absolute;
  margin-bottom: 8px;
  bottom: 0;
}
.loan-officer-nav-card__headshot {
  border-radius: 50%;
  height: 40px;
  margin-bottom: 8px;
  -o-object-fit: cover;
     object-fit: cover;
  -o-object-position: 0 0;
     object-position: 0 0;
  width: 40px;
}
.loan-officer-nav-card__name {
  font-weight: 600;
  font-size: 18px;
  line-height: 1.15;
}
.loan-officer-nav-card__title {
  color: #b2b2b2;
}
.loan-officer-nav-card__nmls {
  font-size: 12px;
  border-bottom: 1px solid #b2b2b2;
  color: #b2b2b2;
  margin-bottom: 16px;
  padding-bottom: 16px;
}
.loan-officer-nav-card__contact {
  font-size: 10px;
  margin-bottom: 10px;
}
.loan-officer-nav-card__contact-icon {
  display: inline-block;
  margin-right: 8px;
  position: relative;
  top: -2px;
  width: 14px;
}
.loan-officer-nav-card__calendly {
  text-decoration: underline;
  cursor: pointer;
}
.loan-officer-pricing-card {
  display: flex;
  flex-direction: column;
}
@media (min-width: 950px) {
  .loan-officer-pricing-card {
    display: flex;
    flex-direction: row;
  }
}
.loan-officer-pricing-card.\\--card {
  display: flex;
  flex-direction: column;
  margin: 16px 0;
  padding: 24px;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  background-color: #246464;
  color: #fff;
  width: 300px;
  height: 350px;
  text-align: center;
}
.loan-officer-pricing-card.\\--compare {
  display: flex;
  flex-direction: row;
  margin: 16px 0 32px;
  padding: 24px;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  background-color: #1b3826;
  color: #fff;
  width: 300px;
  height: 80px;
  text-align: center;
}
.loan-officer-pricing-card__headshot {
  margin-bottom: 16px;
  border-radius: 50%;
  height: 64px;
  width: 64px;
  -o-object-fit: cover;
     object-fit: cover;
  -o-object-position: 0 0;
     object-position: 0 0;
}
@media (min-width: 950px) {
  .loan-officer-pricing-card__headshot {
    margin: 0 24px 8px 0;
  }
}
.loan-officer-pricing-card__headshot.\\--card {
  margin: 0;
}
.loan-officer-pricing-card__headshot.\\--compare {
  height: 32px;
  width: 32px;
}
.loan-officer-pricing-card__text {
  flex: 1;
}
.loan-officer-pricing-card__text.\\--card {
  padding: 8px;
  flex: unset;
}
.loan-officer-pricing-card__heading {
  font-weight: 600;
  font-size: 22px;
  margin-bottom: 8px;
  line-height: 24px;
}
.loan-officer-pricing-card__heading.\\--compare {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 0;
  line-height: 16px;
  text-align: left;
}
.loan-officer-pricing-card__body {
  margin-bottom: 16px;
  font-size: 18px;
  line-height: 24px;
}
.loan-officer-pricing-card__body.\\--compare {
  font-size: 14px;
  margin-bottom: 0;
  line-height: 16px;
  text-align: left;
}
@media (min-width: 950px) {
  .loan-officer-pricing-card__body {
    margin-bottom: 0;
  }
}
.loan-officer-pricing-card__cta {
  max-width: -moz-fit-content;
  max-width: fit-content;
  text-transform: none;
}
.loan-officer-pricing-card__cta.\\--skip {
  font-weight: 600;
  font-size: 12px;
}
.loan-officer-pricing-card__cta.\\--card {
  width: 100%;
  max-width: 100%;
  color: #fff;
  flex: unset;
}
.loan-officer-pricing-card__cta.\\--card:hover {
  color: #5d5d5e;
}
.loan-officer-pricing-card__cta.\\--compare {
  margin-left: 8px;
  color: #fff;
  text-decoration: underline;
  flex: unset;
}
.loan-officer-pricing-card__cta.\\--compare:hover {
  color: #f2f2f2;
}
@media (min-width: 950px) {
  .loan-officer-pricing-card__cta.\\--skip {
    padding: 16px 24px;
    font-weight: 400;
    font-size: 18px;
  }
  .loan-officer-pricing-card__cta.\\--card {
    font-weight: 400;
    font-size: 14px;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.multi-button__title {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 24px;
}
.multi-button__outer-wrapper {
  margin-bottom: 32px;
}
.multi-button__outer-wrapper.\\--error .multi-button__title {
  color: #c53d31;
}
.multi-button__outer-wrapper.\\--error .multi-button__option {
  border-color: #c53d31;
  color: #c53d31;
}
.multi-button__outer-wrapper.\\--two-column-options .multi-button__option {
  width: 45%;
}
.multi-button__wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.multi-button__option {
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1.5px;
  transition: background-color 0.5s ease;
  border-radius: 32px;
  padding: 16px;
  margin-bottom: 8px;
  border: 1px solid #b2b2b2;
  cursor: pointer;
  color: #3d7c54;
  text-align: center;
  text-transform: uppercase;
  width: 100%;
}
.multi-button__option.--selected {
  color: #fff;
  background-color: #3d7c54;
}
.multi-button__input {
  display: none;
}
@media (min-width: 400px) {
  .multi-button__wrapper {
    margin-right: -4px;
    margin-left: -4px;
  }
  .multi-button__option {
    margin: 0 4px 8px;
    width: auto;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.navigation-button__container {
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  margin: 64px 0;
  align-self: center;
  justify-content: flex-start;
}
.navigation-button__container.\\--hidden {
  display: none;
}
@media (min-width: 750px) {
  .navigation-button__container {
    display: flex;
    flex-direction: row;
  }
  .navigation-button__container button.\\--hidden {
    display: none;
  }
  .navigation-button__container.\\--isStart {
    width: 67%;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.page.\\--mg-bottom {
  margin-bottom: 96px;
}
.page__heading-group {
  margin-bottom: 30px;
}
.page__title {
  font-weight: 600;
  font-size: 28px;
  color: #1a1e22;
  line-height: 1.3;
  margin-bottom: 8px;
}
.page__subtitle {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #1a1e22;
  margin-bottom: 6px;
}
.page__description {
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #1a1e22;
}
.page__description.\\--mg-bottom {
  margin-bottom: 24px;
}
.page__horizontal-rule {
  border: none;
  height: 2px;
  background-color: #f2f2f2;
  margin: 24px 0 16px;
}
.page__sum-of-fields {
  font-weight: 600;
  font-size: 18px;
  margin-top: 8px;
}
.page__sum-of-fields-title {
  color: #1a1e22;
}
.page__sum-of-fields-amount {
  color: #3d7c54;
  margin-left: 4px;
}
.app-content__wrap.\\--no-heading-underline .page__heading-group {
  border: none;
  margin-bottom: 32px;
  padding-bottom: 0;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.password-requirements {
  background-color: #e6f5ee;
  padding: 16px;
  font-size: 12px;
}
.password-requirements__title {
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 12px;
}
.password-requirements__list {
  display: grid;
  grid-template-rows: repeat(5, 1fr);
  grid-auto-flow: column;
  grid-auto-columns: auto;
  row-gap: 8px;
  -moz-column-gap: 16px;
       column-gap: 16px;
}
.password-requirements .requirement-list-item {
  display: flex;
  align-items: center;
}
.password-requirements .requirement-list-item__image-container {
  margin-right: 8px;
  height: 14px;
  width: 14px;
  border-radius: 100%;
  border-width: 1px;
  border-style: solid;
  border-color: #b2b2b2;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 150ms ease;
}
.password-requirements .requirement-list-item__image {
  width: 8px;
  opacity: 0;
  transition: all 150ms ease;
}
.password-requirements .requirement-list-item.--matches .requirement-list-item__image-container {
  border-width: 1px;
  border-style: solid;
  border-color: #61926b;
  background-color: #61926b;
}
.password-requirements .requirement-list-item.--matches .requirement-list-item__image {
  opacity: 1;
}
@media (min-width: 750px) {
  .password-requirements__list {
    grid-template-rows: repeat(3, 1fr);
    grid-auto-columns: max-content auto;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.question-group__group-wrapper {
  margin-top: 24px;
}
.question-group__group-wrapper.\\--spacing-bottom {
  margin-bottom: 32px;
}
.question-group__group-wrapper.\\--small-titles .questions-list__title {
  font-size: 18px;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.questions-list__title {
  font-weight: 600;
  font-size: 28px;
  color: #1a1e22;
  line-height: 1.3;
  margin-bottom: 8px;
}
.questions-list__subtitle {
  font-size: 12px;
  letter-spacing: 0.75px;
  color: #5d5d5e;
  line-height: 1.15;
  margin-bottom: 4px;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.radio {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.radio__wrapper {
  padding: 20px 0;
  margin-bottom: -1px;
}
.radio__wrapper.\\--last {
  margin-bottom: 24px;
}
.radio__wrapper.\\--error {
  color: #c53d31;
}
.radio__wrapper.\\--error .radio__title {
  color: #c53d31;
}
.radio__wrapper.\\--error .radio__option-button {
  border-color: #c53d31;
}
.radio__wrapper.\\--declaration {
  margin-bottom: -1px;
  border-bottom: 1px solid #d8d8d8;
  border-top: 1px solid #d8d8d8;
}
.radio__title-wrapper {
  padding-right: 24px;
}
.radio__title {
  font-size: 14px;
  color: #1a1e22;
}
.radio__subtitle {
  padding-top: 6px;
  font-size: 14px;
  color: #1a1e22;
}
.radio__options-wrapper {
  display: flex;
  flex-direction: row;
}
.radio__option {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.radio__option-button {
  border-radius: 50%;
  border: 1px solid #b2b2b2;
  cursor: pointer;
  height: 22px;
  margin-right: 8px;
  width: 22px;
  flex-shrink: 0;
}
.radio__option-button.--selected {
  border: 8px solid #3d7c54;
}
.radio__option-text {
  font-weight: 600;
  margin-right: 18px;
}
.radio__option:last-child .radio__option-text {
  margin-right: 0;
}
.radio__error-text {
  font-size: 12px;
  color: #c53d31;
}
.credit-scores-radio-list .radio {
  flex-direction: column;
}
.credit-scores-radio-list .radio__title-wrapper {
  margin-bottom: 16px;
}
.credit-scores-radio-list .radio__options-wrapper {
  flex-direction: column;
}
.credit-scores-radio-list .radio__option {
  cursor: pointer;
  margin-bottom: 16px;
  font-size: 18px;
}
.credit-scores-radio-list .radio__option:last-child {
  margin-bottom: 0;
}
.vertical .radio {
  flex-direction: column;
}
.vertical .radio__title-wrapper {
  margin-bottom: 16px;
}
.vertical .radio__title {
  font-weight: 600;
  font-size: 18px;
}
.vertical .radio__options-wrapper {
  flex-direction: column;
}
.vertical .radio__option {
  margin-bottom: 16px;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #dddddd;
}
.vertical .radio__option-text {
  font-weight: 400;
  font-size: 14px;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.repeatable-group__group-wrapper {
  margin-bottom: 24px;
  padding-top: 24px;
}
.repeatable-group__group-wrapper.\\--first {
  border-top: none;
  margin-bottom: 0;
  padding-top: 0;
}
.repeatable-group__add-button-subtitle {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 24px;
  color: #1a1e22;
  line-height: 1.3;
}
.repeatable-group__remove {
  font-weight: 600;
  font-size: 14px;
  align-items: center;
  color: #3d7c54;
  display: flex;
  margin: 16px 0 32px auto;
}
@media (min-width: 320px) and (max-width: 767px) {
  .repeatable-group__remove {
    margin: 0;
  }
}
.repeatable-group__add {
  padding: 24px 0;
}
.repeatable-group__add-button {
  font-weight: 600;
  color: #3d7c54;
  display: flex;
  align-items: center;
}
.repeatable-group__add-icon {
  margin-right: 8px;
  width: 20px;
}
.repeatable-group__remove-icon {
  margin-right: 8px;
  width: 14px;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.select.\\--horizontal.\\--first-child {
  margin-top: 24px;
}
.select.\\--horizontal .select__subtitle {
  font-size: 14px;
  color: #1a1e22;
  text-transform: none;
  width: 40%;
}
.select.\\--horizontal .select__input-wrapper {
  margin-left: 16px;
  width: 60%;
}
.select.\\--horizontal .input {
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
  margin-top: 24px;
  align-items: center;
}
.select__title {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 24px;
}
.select__subtitle {
  font-size: 12px;
  color: #5d5d5e;
  text-transform: uppercase;
  line-height: 1.15;
}
.select__subtitle.\\--active {
  color: #3d7c54;
}
.select__subtitle.\\--error {
  color: #c53d31;
}
.select__anchor {
  display: flex;
  border-radius: 6px;
  font-size: 14px;
  border: 1px solid #c4c4c4;
  color: #1a1e22;
  line-height: 1.15;
  margin: 4px 0 16px;
  justify-content: space-between;
  outline: none;
  padding: 16px 16px;
  width: 100%;
}
.select__anchor:focus {
  border: 1px solid #3d7c54;
}
.select__anchor.\\--active {
  border: 1px solid #3d7c54;
}
.select__anchor.\\--as-div {
  min-height: 50px;
  margin: 0;
}
.select__input-wrapper {
  position: relative;
}
.select__toggle-button {
  position: absolute;
  bottom: 20px;
  right: 15px;
}
.select__caret.\\--active {
  transform: rotate(180deg);
}
.select__placeholder {
  color: #5d5d5e;
}
.select__popper {
  border-radius: 6px;
  font-size: 14px;
  display: none;
  border: 1px solid #3d7c54;
  background-color: #fff;
  color: #1a1e22;
  line-height: 1.15;
  outline: none;
  overflow-y: auto;
  width: 100%;
  z-index: 1300;
}
.select__popper.\\--open {
  display: block;
}
.select__popper.\\--error, .select__popper.\\--error-active {
  border: 1px solid #c53d31;
}
.select__option {
  padding: 16px;
}
.select__option:not(:last-child) {
  border-bottom: 1px solid #3d7c54;
}
.select__option:hover {
  background-color: #9ec9b6;
}
.select__option:focus, .select__option.\\--active {
  outline: none;
  color: #fff;
  background-color: #3d7c54;
}
.select__option:last-child {
  border-bottom: none;
}
.select__option.\\--none {
  color: #dddddd;
  background-color: #fff;
}
.select__option.\\--error {
  font-weight: 600;
  font-size: 14px;
  color: #c53d31;
  background-color: #ffeaea;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.select__option.\\--error:hover {
  color: #fff;
  background-color: #c53d31;
}
.select__option.\\--error-active {
  font-weight: 600;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  background-color: #c53d31;
}
.select.\\--start-new-group {
  border-top: 1px solid #b2b2b2;
  margin-top: 32px;
  padding-top: 24px;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.multi-select-button {
  display: flex;
  flex-direction: column;
}
.multi-select-button__wrapper {
  margin: 32px 0;
}
.multi-select-button__wrapper.\\--last {
  margin-bottom: 24px;
}
.multi-select-button__wrapper.\\--cash-out {
  margin-top: 8px;
}
.multi-select-button__wrapper.\\--error .multi-select-button__option {
  border-color: #c53d31;
}
.multi-select-button__wrapper.\\--half-width .multi-select-button__options-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
}
.multi-select-button__wrapper.\\--half-width .multi-select-button__option-container {
  margin: 0;
}
.multi-select-button__wrapper.\\--half-width .multi-select-button__option {
  width: -moz-fit-content;
  width: fit-content;
  margin-right: 16px;
  margin-bottom: 16px;
}
@media (min-width: 768px) {
  .multi-select-button__wrapper.\\--half-width .multi-select-button__option {
    width: 190px;
  }
}
@media (min-width: 320px) and (max-width: 767px) {
  .multi-select-button__wrapper.\\--half-width .multi-select-button__options-wrapper {
    display: flex;
    flex-direction: column;
  }
  .multi-select-button__wrapper.\\--half-width .multi-select-button__option {
    width: 100%;
  }
}
.multi-select-button__wrapper.\\--center-content .multi-select-button__options-wrapper {
  justify-content: center;
}
.multi-select-button__title {
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 16px;
  color: #1a1e22;
}
.multi-select-button__subtitle {
  padding-top: 6px;
  font-size: 14px;
  color: #1a1e22;
}
.multi-select-button__options-wrapper {
  flex-direction: column;
}
.multi-select-button__option-container {
  margin: 16px 0;
}
.multi-select-button__option {
  display: flex;
  flex-direction: row;
  padding: 16px;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #dddddd;
  height: 60px;
}
.multi-select-button__option:last-child {
  margin-bottom: 0;
}
.multi-select-button__option:hover {
  border: 1px solid #3d7c54;
  cursor: pointer;
}
.multi-select-button__option.--selected {
  box-shadow: 0px 0px 0px 3px #3d7c54 inset;
  transition: 0.5s;
}
.multi-select-button__option-details {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.multi-select-button__option-text {
  font-weight: 400;
  font-size: 14px;
}
.multi-select-button__option-text.--selected {
  color: #3d7c54;
}
.multi-select-button__option-text-icon {
  font-weight: 400;
  font-size: 14px;
  margin-left: 18px;
}
.multi-select-button__option-text-icon.--selected {
  color: #3d7c54;
}
.multi-select-button__option-text-checkmark {
  visibility: hidden;
  margin-left: auto;
  max-height: 14px;
}
.multi-select-button__option-text-checkmark.--selected {
  visibility: visible;
}
.multi-select-button__option:last-child .multi-select-button__option-text {
  margin-right: 0;
}
.multi-select-button__error-text {
  font-size: 12px;
  color: #c53d31;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.success-card {
  display: grid;
  grid-template-rows: auto auto;
  grid-template-columns: max-content 1fr;
  -moz-column-gap: 16px;
       column-gap: 16px;
  padding: 24px;
  border-radius: 4px;
  border: 1px solid #dddddd;
  margin-bottom: 32px;
}
.success-card__headshot {
  margin-bottom: 8px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  -o-object-fit: cover;
     object-fit: cover;
  -o-object-position: center;
     object-position: center;
}
.success-card__title {
  margin-bottom: 8px;
  color: #1a1e22;
  font-weight: 600;
  font-size: 14px;
}
.success-card__contact-items {
  grid-column: 1/span 2;
}
.success-card__contact {
  font-size: 12px;
}
.success-card__contact:first-of-type {
  margin-bottom: 4px;
}
.success-card__contact-icon {
  margin-right: 8px;
  display: inline-block;
  position: relative;
  width: 16px;
}
.success-card__contact-text {
  display: inline-block;
  text-decoration: underline;
  color: #1a1e22;
}
@media (min-width: 750px) {
  .success-card__contact-items {
    grid-area: 2/2;
  }
}
.success-screen__img {
  margin-bottom: 16px;
  width: 100px;
}
.success-screen__title {
  color: #1a1e22;
}
.success-screen__subtitle {
  color: #1a1e22;
  margin-bottom: 16px;
}
.success-screen__content {
  color: #1a1e22;
  margin-bottom: 32px;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.modal {
  text-align: center;
}
.modal__provider {
  position: relative;
}
.modal__overlay {
  z-index: 150;
  position: fixed;
  background-color: rgba(26, 30, 34, 0.5);
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
}
.modal__container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  overflow: scroll;
}
.modal__content {
  z-index: 1;
  border-radius: 8px;
  margin: 0 24px;
  background-color: #fff;
}
.modal__content.\\--loanofficer {
  align-self: flex-end;
}
.modal__content.\\--loanofficer.\\--open {
  transform: translateY(0);
  transition: transform 1s;
}
.modal__content.\\--loanofficer.\\--closed {
  transform: translateY(100%);
  transition: transform 1s;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.value-props {
  z-index: 150;
  display: flex;
  flex-direction: column;
  padding: 32px;
  border-radius: 4px;
  background-color: #fff;
  position: absolute;
  top: 100px;
  width: 100vw;
}
.value-props__overlay {
  z-index: 100;
  background-color: rgba(26, 30, 34, 0.5);
  height: 100vh;
  left: 0;
  top: 0;
  position: fixed;
  width: 100vw;
}
.value-props__container {
  display: flex;
  flex-direction: column;
  margin-top: 24px;
}
.value-props__close-button {
  right: 16px;
  top: 16px;
  width: 24px;
  padding: 4px;
  cursor: pointer;
  position: absolute;
  background-color: #e5e5e5;
  border-radius: 50%;
}
.value-props__close-button:hover {
  background-color: #1a1e22;
}
.value-props__heading {
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 28px;
  color: #1a1e22;
  line-height: 1.3;
}
.value-props__tagline {
  margin-bottom: 24px;
}
.value-props__list {
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.value-props-item {
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
}
.value-props-item__icon-wrap {
  flex-shrink: 0;
  width: 50px;
}
.value-props-item__subhead {
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 18px;
  color: #1a1e22;
  line-height: 1.3;
}
.value-props-item__blurb {
  font-size: 14px;
  color: #5d5d5e;
}
.value-props__cta {
  letter-spacing: 2.5px;
  border-radius: 4px;
  display: inline-block;
  padding: 16px 32px;
  background-color: #3d7c54;
  color: #fff;
  border: none;
  font-size: 14px;
  border-radius: 32px;
  margin-bottom: 24px;
  padding: 16px 16px;
  letter-spacing: 1px;
  align-self: center;
  width: 280px;
}
.value-props__cta:hover {
  background-color: #356b48;
}
@media (min-width: 600px) {
  .value-props {
    padding: 32px 64px;
  }
  .value-props-item {
    width: 50%;
    flex-shrink: 0;
  }
}
@media (min-width: 750px) {
  .value-props {
    padding: 32px 64px;
    max-width: 750px;
    left: calc(50% - 375px);
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.rate-selections__header {
  font-weight: 600;
  font-size: 32px;
  margin: 0 auto 24px;
  max-width: 1100px;
}
.rate-selections__sub-header {
  font-size: 18px;
  margin: auto;
  max-width: 1100px;
}
.rate-selections__update-wrapper {
  display: flex;
  flex-direction: column;
  margin: 24px auto;
  margin-bottom: 0;
  align-items: center;
  max-width: 1100px;
}
.rate-selections__update-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  overflow-x: scroll;
  width: 100%;
}
.rate-selections__update-container-terms {
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 1000px;
  margin: 0 auto;
}
.rate-selections__update-container-terms-buttons {
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
}
.rate-selections__terms-definition {
  display: none;
}
.rate-selections__question-mark-icon {
  margin: 8px;
  display: inline;
  align-self: center;
}
.rate-selections__refresh-info-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: auto;
}
.rate-selections__flex-gap {
  display: flex;
  gap: 12px;
}
.rate-selections__refresh-info-block {
  display: flex;
  flex-direction: row;
  padding: 16px;
  border-radius: 8px;
  font-size: 18px;
  align-items: flex-start;
  color: #1a1e22;
  background-color: #f1f9f1;
}
.rate-selections__refresh-info-block img {
  margin: 0 8px 0 16px;
  width: 16px;
  cursor: pointer;
}
.rate-selections .rate-terms {
  display: flex;
  flex-direction: row;
  text-align: center;
  overflow: scroll;
}
.rate-selections .rate-terms__term {
  font-size: 12px;
  margin: 16px 4px;
  padding: 12px 24px;
  border-radius: 4px;
  align-self: center;
  background-color: #f4f4f4;
  color: #1a1e22;
  flex: none;
  justify-content: center;
  -webkit-appearance: button;
  max-width: 130px;
}
.rate-selections .rate-terms__term:first-child {
  margin-left: 0;
}
.rate-selections .rate-terms__term.\\--active {
  background-color: #246464;
  color: #fff;
}
.rate-selections .rate-terms__term.\\--pricing-recommendation {
  border-radius: 32px;
}
.rate-selections__options-list {
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  align-items: center;
}
.rate-selections__options-list.\\--row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  margin: 0;
}
.rate-selections__options-list.\\--align-center {
  align-items: center;
}
.rate-selections__options-list.\\--wrap-content {
  flex-wrap: wrap;
}
.rate-selections__info {
  font-size: 12px;
  margin-top: 32px;
  color: #5d5d5e;
}
.rate-selections__info-block {
  margin-bottom: 16px;
}
.rate-selections__info-block-heading {
  font-weight: 600;
}
.rate-selections.\\--compare {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.rate-selections.\\--compare .rate-selections__header {
  font-weight: 600;
  font-size: 28px;
  color: #3d7c54;
  text-align: center;
  max-width: 700px;
}
.rate-selections.\\--compare .rate-selections__sub-header {
  font-weight: 600;
  font-size: 32px;
  text-align: center;
}
.rate-selections.\\--compare .rate-selections__options-list {
  display: flex;
  flex-direction: column-reverse;
}
.rate-selections.\\--compare .rate-selections__options-list.\\--bankrate {
  display: flex;
  flex-direction: column;
}
.rate-selections__robinhood-banner-container {
  max-width: 700px;
  margin: 24px auto;
  padding: 0 16px;
}
@media (min-width: 950px) {
  .rate-selections__robinhood-banner-container {
    padding: 0;
    max-width: none;
    margin: 32px auto 24px;
  }
}
@media (min-width: 950px) {
  .rate-selections__sub-header {
    margin-bottom: 48px;
  }
  .rate-selections.\\--compare .rate-selections__header {
    font-weight: 600;
    font-size: 32px;
    color: #3d7c54;
  }
  .rate-selections.\\--compare .rate-selections__sub-header {
    font-weight: 600;
    font-size: 48px;
  }
  .rate-selections.\\--compare .rate-selections__options-list {
    display: flex;
    flex-direction: row;
  }
  .rate-selections.\\--compare .rate-selections__options-list.\\--bankrate {
    display: flex;
    flex-direction: row;
  }
  .rate-selections.\\--ojo-demo {
    margin-left: auto;
    margin-right: auto;
    max-width: 600px;
  }
}
@media (min-width: 1100px) {
  .rate-selections {
    align-items: flex-start;
  }
  .rate-selections__options-list {
    width: 100%;
  }
}
@media (min-width: 1300px) {
  .rate-selections__button-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 1100px;
  }
  .rate-selections__button-container {
    display: unset;
    width: unset;
  }
  .rate-selections__terms-definition {
    display: flex;
    color: #3d7c54;
    cursor: pointer;
    align-items: center;
    margin-right: 17px;
  }
  .rate-selections__refresh-info-block {
    align-items: center;
  }
  .rate-selections__update-container-terms {
    justify-content: space-between;
  }
}
@media (min-width: 1650px) {
  .rate-selections__options-list {
    width: 91.6666666667%;
  }
}
@media (min-width: 1900px) {
  .rate-selections__info {
    max-width: 1100px;
    margin: 32px auto 0;
  }
}
.rate-selection-value-props {
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: 100%;
  max-width: 1100px;
  margin: 24px auto;
  align-items: center;
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
}
.rate-selection-value-props__title {
  width: 60%;
  font-weight: 600;
  font-size: 28px;
  text-align: center;
  padding-bottom: 8px;
}
@media (min-width: 950px) {
  .rate-selection-value-props__title {
    padding: 64px;
    font-weight: 600;
    font-size: 48px;
  }
}
.rate-selection-value-props__props {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-around;
}
@media (min-width: 950px) {
  .rate-selection-value-props__props {
    display: flex;
    flex-direction: row;
    width: 60%;
  }
}
.rate-selection-value-props__prop-box {
  display: flex;
  flex-direction: column;
  margin: 16px 0;
  padding: 24px 32px;
  border-radius: 8px;
  align-items: center;
  width: 100%;
}
.rate-selection-value-props__prop-box.\\--dark {
  background-color: #1c4546;
}
.rate-selection-value-props__prop-box.\\--light {
  background-color: #316a69;
}
@media (min-width: 950px) {
  .rate-selection-value-props__prop-box {
    margin: 16px;
  }
}
.rate-selection-value-props__prop-subtitle {
  color: #fff;
  font-weight: 600;
  font-size: 32px;
  letter-spacing: 0.75px;
}
.rate-selection-value-props__prop-callout {
  color: #fff;
  font-size: 14px;
  letter-spacing: 1px;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.talk-to-expert {
  font-size: 18px;
  display: flex;
  flex-direction: column;
  margin: 24px 0;
  padding: 32px 24px;
  align-items: center;
  border-bottom: 1px solid #dadada;
  font-weight: 400;
  justify-content: center;
  gap: 8px;
}
.talk-to-expert__img {
  margin-bottom: 8px;
  max-width: 48px;
  max-height: 48px;
}
.talk-to-expert__copy {
  margin-bottom: 24px;
  font-size: 16px;
  max-width: 430px;
  text-align: center;
}
.talk-to-expert__btn {
  padding: 12px 24px;
  border-radius: 96px;
  border: 1px solid #000;
  font-size: 13px;
}
.talk-to-expert__btn:hover {
  background-color: #000;
  color: #fff;
}
@media (min-width: 950px) {
  .talk-to-expert {
    display: flex;
    flex-direction: row;
    align-items: center;
    max-width: 1100px;
    margin: auto;
  }
  .talk-to-expert__img {
    display: flex;
    flex-direction: row;
    margin-bottom: 0;
    border-radius: 50%;
    flex-basis: 6%;
    justify-content: center;
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: 0 0;
       object-position: 0 0;
  }
  .talk-to-expert__copy {
    margin-bottom: 0;
    flex-basis: 77%;
    font-size: 18px;
    max-width: unset;
    text-align: left;
  }
  .talk-to-expert__btn {
    flex-basis: 19%;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.tooltip__button {
  vertical-align: middle;
  display: inline-block;
}
.tooltip__button.\\--value-props {
  margin-left: 8px;
  margin-top: -4px;
  vertical-align: top;
}
.tooltip__body.\\--value-props {
  padding: 16px;
}
.tooltip__body.\\--value-props .tooltip__description {
  font-weight: 400;
  font-size: 12px;
}
.tooltip__button {
  vertical-align: middle;
  display: inline-block;
}
.tooltip__icon {
  vertical-align: middle;
  display: inline;
}
.tooltip__icon.--bankrate {
  filter: invert(28%) sepia(100%) saturate(6926%) hue-rotate(219deg) brightness(106%) contrast(105%);
}
.tooltip__body {
  z-index: 20;
  padding: 24px 16px;
  border-radius: 8px;
  color: #fff;
  background: #1a1e22;
  max-width: 230px;
}
.tooltip__close-button-wrapper {
  padding-right: 16px;
  line-height: 1;
  position: absolute;
  top: 0;
  right: 0;
  padding-top: 12px;
}
.tooltip__close-button {
  color: #fff;
  cursor: pointer;
}
.tooltip__title {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 8px;
}
.tooltip__description {
  font-weight: 400;
  font-size: 14px;
  white-space: normal;
}
@media (min-width: 950px) {
  .tooltip__body {
    max-width: 350px;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.loan-officer-modal {
  display: flex;
  flex-direction: column;
  padding: 32px;
  padding-top: 0;
  justify-content: center;
  align-items: center;
  color: #1a1e22;
  width: 100vw;
}
.loan-officer-modal__header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: #3d7c54;
}
.loan-officer-modal__tagline {
  margin: 64px;
  font-weight: 600;
  font-size: 16px;
  color: #fff;
  position: absolute;
}
.loan-officer-modal__phone-icon-svg {
  margin: 16px;
  padding: 4px;
  background-color: #fff;
  display: flex;
  align-self: flex-end;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #dddddd;
}
.loan-officer-modal__close-button {
  text-align: right;
  padding-right: 16px;
  padding-top: 16px;
}
.loan-officer-modal__close-button-icon {
  right: 16px;
  top: 16px;
  width: 24px;
  padding: 4px;
  background-color: #e5e5e5;
  border-radius: 50%;
}
.loan-officer-modal__close-button-icon:hover {
  background-color: #1a1e22;
}
.loan-officer-modal__caret-icon {
  margin-bottom: 6px;
}
.loan-officer-modal__introduction {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 6px;
  max-width: 260px;
  text-align: center;
}
.loan-officer-modal__title {
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 4px;
  max-width: 370px;
  text-align: center;
  line-height: 1.45;
}
.loan-officer-modal__headshot {
  margin: 16px;
  border-radius: 50%;
  height: 48px;
  -o-object-fit: cover;
     object-fit: cover;
  -o-object-position: 0 0;
     object-position: 0 0;
  width: 48px;
}
.loan-officer-modal__nmls {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.45;
}
.loan-officer-modal__phone, .loan-officer-modal__email {
  letter-spacing: 2.5px;
  border-radius: 4px;
  display: inline-block;
  padding: 16px 32px;
  background-color: #fff;
  color: #1a1e22;
  border: none;
  margin-top: 20px;
  font-size: 14px;
  letter-spacing: 1px;
  border: 1px solid #3d7c54;
  color: #3d7c54;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  border-radius: 32px;
}
.loan-officer-modal__phone:hover, .loan-officer-modal__email:hover {
  background-color: #f2f2f2;
}
.loan-officer-modal__phone-icon, .loan-officer-modal__email-icon {
  margin-right: 12px;
}
.loan-officer-modal__schedule-a-call {
  font-size: 14px;
  margin: 20px;
  padding: 16px;
  border-radius: 64px;
  text-align: center;
  width: 200px;
  height: 55px;
  border: 1px solid #1a1e22;
  background-color: #3d7c54;
  color: #fff;
  cursor: pointer;
}
.lo-pricing__container {
  display: flex;
  flex-direction: column;
  margin: 24px;
  align-items: center;
}
.lo-pricing__back-to-rates {
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 1.5px;
  align-self: flex-start;
  cursor: pointer;
  text-transform: uppercase;
}
.lo-pricing__back-icon {
  margin-right: 2px;
  position: relative;
  top: -2px;
  display: inline-block;
  transform: rotate(90deg);
}
.lo-pricing__heading {
  font-weight: 600;
  font-size: 28px;
  margin: 8px 0;
}
.lo-pricing__cards {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.lo-pricing__cards > * {
  display: flex;
  flex-direction: column;
  margin: 24px 0;
  padding: 32px;
  border-radius: 4px;
  align-items: center;
  justify-content: space-around;
  gap: 16px;
  max-width: 470px;
  text-align: center;
  border: 1px solid #dddddd;
}
.lo-pricing__headshot {
  border-radius: 50%;
  height: 64px;
  -o-object-fit: cover;
     object-fit: cover;
  width: 64px;
}
.lo-pricing__name {
  font-weight: 600;
  font-size: 22px;
}
.lo-pricing__email {
  padding-bottom: 16px;
  border-bottom: 1px solid #dddddd;
  width: 100%;
}
.lo-pricing__email-icon, .lo-pricing__phone-icon {
  margin-right: 8px;
  display: inline-block;
  width: 20px;
}
.lo-pricing__steps-heading {
  font-weight: 600;
  font-size: 22px;
}
.lo-pricing__steps-icon {
  padding: 8px;
  border-radius: 50%;
  font-weight: 600;
  font-size: 18px;
  width: 44px;
  border: 1px solid #9ec9b6;
  background-color: #c6eadb;
  color: #3d7c54;
}
@media (min-width: 1100px) {
  .lo-pricing__cards {
    flex-direction: row;
    align-items: normal;
  }
  .lo-pricing__cards > * {
    margin: 24px;
  }
  .lo-pricing__cards-lo {
    margin-left: 0;
  }
}
.property-value-modal {
  display: flex;
  flex-direction: column;
  padding: 32px;
  background-color: #fff;
  position: absolute;
  top: 50px;
  margin-left: calc(50vw - 185px);
  max-height: 80vh;
  overflow-y: scroll;
  gap: 2px;
  max-width: 310px;
  text-align: center;
}
.property-value-modal__heading {
  font-weight: 600;
  font-size: 28px;
}
.property-value-modal__sub-heading {
  font-size: 18px;
}
.property-value-modal__input-container {
  display: flex;
  flex-direction: column;
  margin: 8px 0;
}
.property-value-modal__label {
  letter-spacing: 0.75px;
  margin-bottom: 8px;
  font-size: 12px;
  display: block;
  color: #5d5d5e;
  line-height: 1.15;
  text-align: left;
}
.property-value-modal__error {
  margin-bottom: 4px;
  font-size: 12px;
  color: #c53d31;
}
.property-value-modal__lock-button {
  width: 100%;
  margin-right: 0;
}
.property-value-modal__footer-container {
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #dddddd;
  align-items: center;
}
.property-value-modal__footer-description {
  margin-top: 16px;
  font-size: 14px;
}
@media (min-width: 400px) {
  .property-value-modal {
    max-width: 350px;
    margin-left: calc(50vw - 212px);
  }
}
@media (min-width: 600px) {
  .property-value-modal {
    max-width: 500px;
    margin-left: calc(50vw - 275px);
  }
}
@media (min-width: 950px) {
  .property-value-modal {
    max-width: 550px;
    gap: 8px;
    top: 100px;
    margin-left: calc(50vw - 550px);
  }
  .property-value-modal__input-container {
    margin: 24px 0;
  }
}
.ssn-modal {
  display: flex;
  flex-direction: column;
  padding: 32px;
  background-color: #fff;
  border-radius: 20px;
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  max-height: 80vh;
  overflow-y: auto;
  gap: 8px;
  width: 100%;
  max-width: 310px;
}
.ssn-modal__heading {
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 4px;
  line-height: 38px;
  text-align: center;
}
.ssn-modal__borrower-name {
  font-size: 22px;
  margin-top: 8px;
  margin-bottom: 8px;
  text-transform: none;
  color: #1a1e22;
}
.ssn-modal__security-blurb {
  font-size: 14px;
  margin-bottom: 16px;
  color: #1a1e22;
}
.ssn-modal__shield-icon {
  width: 16px;
  margin-right: 8px;
  display: inline;
  height: 18px;
  vertical-align: text-top;
}
.ssn-modal__disclosure {
  margin-bottom: 16px;
  font-size: 11px;
  line-height: 16px;
}
.ssn-modal__lock-button {
  margin: 8px 0 16px 0;
  width: 100%;
}
.ssn-modal__back-button {
  margin: 0 auto !important;
  width: auto;
}
.ssn-modal .checkbox__wrapper.--tight {
  margin-bottom: 0;
}
.ssn-modal .checkbox__wrapper .checkbox__label {
  font-size: 11px;
}
.ssn-modal__success {
  display: flex;
  flex-direction: column;
  padding: 32px;
  text-align: center;
  align-items: center;
  gap: 8px;
}
.ssn-modal__success-heading {
  font-weight: 600;
  font-size: 28px;
}
.ssn-modal__success-text {
  font-size: 14px;
  color: #1a1e22;
}
.ssn-modal.mini-modal {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
  max-height: 100vh;
  transform: none;
  border-radius: 0px;
  margin: 0px;
}
@media (min-width: 300px) {
  .ssn-modal {
    left: 42.5%;
  }
}
@media (min-width: 400px) {
  .ssn-modal {
    max-width: 350px;
    left: 45%;
  }
}
@media (min-width: 600px) {
  .ssn-modal {
    max-width: 500px;
  }
}
@media (min-width: 950px) {
  .ssn-modal {
    padding: 36px 54px;
    max-width: 520px;
    gap: 20px;
    top: 100px;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.ntl-rate-selection__update-wrapper {
  display: flex;
  flex-direction: column;
  margin: 24px auto;
  margin-bottom: 0;
  align-items: center;
  max-width: 1100px;
}
.ntl-rate-selection__update-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  overflow-x: scroll;
  width: 100%;
}
.ntl-rate-selection__update-container-terms {
  display: flex;
  justify-content: center;
  max-width: 1000px;
  margin: 0 auto;
}
.ntl-rate-selection__update-container-terms-buttons {
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
  text-align: center;
}
.ntl-rate-selection__terms-definition {
  display: none;
}
.ntl-rate-selection__question-mark-icon {
  margin: 8px;
  display: inline;
  align-self: center;
}
.ntl-rate-selection__button {
  font-weight: 400;
  font-size: 12px;
  border-radius: 24px;
  padding: 8px 24px;
  margin: 16px 4px;
  max-width: 130px;
  background-color: #f4f4f4;
  color: #1a1e22;
  flex-shrink: 0;
}
.ntl-rate-selection__button:hover {
  background-color: #246464;
  color: #fff;
}
.ntl-rate-selection__button:focus {
  outline: 0;
}
.ntl-rate-selection__button.\\--selected {
  background-color: #246464;
  color: #fff;
}
.ntl-rate-selection__refresh-info-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.ntl-rate-selection__refresh-info-block {
  display: flex;
  flex-direction: row;
  padding: 16px;
  border-radius: 8px;
  font-size: 18px;
  align-items: flex-start;
  color: #1a1e22;
  background-color: #f1f9f1;
}
.ntl-rate-selection__refresh-info-block img {
  margin: 0 8px 0 16px;
  width: 16px;
  cursor: pointer;
}
@media (min-width: 1300px) {
  .ntl-rate-selection__button-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 1100px;
  }
  .ntl-rate-selection__button-container {
    display: unset;
    width: 100%;
  }
  .ntl-rate-selection__terms-definition {
    display: flex;
    color: #3d7c54;
    cursor: pointer;
    align-items: center;
    margin-right: 17px;
  }
  .ntl-rate-selection__refresh-info-block {
    align-items: center;
  }
  .ntl-rate-selection__update-container-terms {
    justify-content: space-between;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.accordion__container {
  margin-bottom: 64px;
  border-top: 1px solid #dddddd;
}
.accordion__item {
  display: flex;
  flex-direction: column;
}
.accordion__title {
  margin: 16px 0;
  font-weight: 600;
  font-size: 22px;
  display: flex;
  cursor: pointer;
  color: #1a1e22;
  justify-content: space-between;
  align-items: flex-start;
}
.accordion__title:after {
  content: "";
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIgMTMuMjM3Mkw4IDcuMjM3MTVMMiAxLjIzNzE1IiBzdHJva2U9IiM0RTdCNTciIHN0cm9rZS13aWR0aD0iMi4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==");
  background-repeat: no-repeat;
  background-position: 50% 50%;
  display: block;
  width: 30px;
  height: 30px;
  margin-left: 12px;
  transition: margin 700ms;
  transform: rotate(90deg);
}
.accordion__title.\\--open:after {
  transform: rotate(270deg);
}
.accordion__collapse-box {
  border-bottom: 1px solid #dddddd;
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(1, 0, 1, 0);
  height: auto;
  max-height: 9999px;
}
.accordion__collapse-box.\\--collapsed {
  max-height: 0;
  transition: max-height 0.3s cubic-bezier(0, 1, 0, 1);
}
.accordion__content {
  margin-bottom: 16px;
  margin-right: 32px;
  font-size: 14px;
}
.accordion__content > p {
  margin-bottom: 16px;
}
.accordion__content > ul {
  margin: 0 0 32px 32px;
  list-style: disc;
}
.accordion__content > ul > li {
  margin-bottom: 4px;
}
.accordion__content > ul > li::marker {
  color: #3d7c54;
}
.accordion__content > ul > li > ul {
  margin-left: 32px;
  margin-top: 4px;
  list-style: circle;
}
.accordion__content > ol {
  margin: 0 0 32px 32px;
  list-style: decimal;
}
.accordion__content > ol > li {
  margin-bottom: 4px;
}
.accordion__content > ol > li::marker {
  color: #3d7c54;
  margin: 0 auto;
}
@media (min-width: 950px) {
  .accordion__container {
    display: flex;
    flex-direction: column;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.pricing-accordion-container {
  max-width: 1100px;
  margin: 0 auto;
}
.pricing-label {
  font-weight: 600;
  font-size: 28px;
  padding: 32px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  text-align: center;
  justify-content: center;
  color: #1a1e22;
  line-height: 48px;
}
.pricing-label__mobile-container {
  padding: 0 8px;
}
.pricing-section {
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  min-height: 40vh;
}
.pricing-section__text-container {
  display: flex;
  flex-direction: column;
  padding-left: 4px;
  align-items: center;
  flex: 1;
  cursor: pointer;
}
.pricing-section__screen {
  max-width: 30%;
  padding: 2%;
  max-width: calc(100% - 20px);
  max-height: calc(100% - 50px);
}
@media (min-width: 950px) {
  .pricing-label {
    display: flex;
    font-size: 28px;
    justify-content: flex-start;
  }
  .pricing-section__text-container {
    cursor: unset;
    align-items: flex-end;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.info-accordion-container {
  max-width: 460px;
  margin: 0 auto;
}
.info-accordion-label {
  font-weight: 600;
  font-size: 28px;
  padding: 32px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  text-align: center;
  justify-content: center;
  color: #1a1e22;
  line-height: 48px;
}
.info-accordion-section {
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  min-height: 40vh;
}
.info-accordion-section__text-container {
  display: flex;
  flex-direction: column;
  padding-left: 4px;
  align-items: center;
  flex: 1;
  cursor: pointer;
}
.info-accordion-section__screen {
  max-width: 30%;
  padding: 2%;
  max-width: calc(100% - 20px);
  max-height: calc(100% - 50px);
}
@media (min-width: 950px) {
  .info-accordion-container {
    max-width: 1000px;
  }
  .info-accordion-label {
    display: flex;
    font-size: 28px;
    justify-content: flex-start;
  }
  .info-accordion-section__text-container {
    cursor: unset;
    align-items: flex-end;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.complete-application {
  max-width: 480px;
}
.complete-application__img {
  height: 92px;
  margin-bottom: 32px;
}
.complete-application__heading-group {
  border: none;
  color: #1a1e22;
}
.complete-application__button-group {
  display: flex;
  flex-direction: column;
}
.complete-application__button {
  flex-grow: 3;
  margin-left: 0;
  margin-right: 0;
  padding: 16px 30px;
  width: 100%;
}
.complete-application__button.\\--logout {
  letter-spacing: 2.5px;
  border-radius: 4px;
  display: inline-block;
  padding: 16px 32px;
  background-color: transparent;
  color: #000;
  border: 2px solid #000;
  flex-grow: 1;
  padding-top: 12px;
  padding-bottom: 12px;
  border-radius: 32px;
}
.complete-application__button.\\--logout:hover {
  background-color: #000;
  color: #fff;
}
@media (min-width: 750px) {
  .complete-application__button-group {
    display: flex;
    flex-direction: row;
  }
  .complete-application__button {
    margin-left: 8px;
    margin-right: 8px;
    width: auto;
  }
  .complete-application__button:first-of-type {
    margin-left: 0;
  }
  .complete-application__button:last-of-type {
    margin-right: 0;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.info-modal {
  display: flex;
  flex-direction: column;
  padding: 32px;
  padding-top: 0;
  color: #1a1e22;
  max-height: 80vh;
  max-width: 350px;
  overflow-y: scroll;
}
.info-modal__close-button {
  padding-right: 8px;
  padding-top: 8px;
  text-align: right;
  cursor: pointer;
}
.info-modal__close-button-icon {
  right: 16px;
  top: 16px;
  width: 24px;
  padding: 4px;
  background-color: #e5e5e5;
  border-radius: 50%;
}
.info-modal__close-button-icon:hover {
  background-color: #1a1e22;
}
.info-modal__heading {
  font-weight: 600;
  font-size: 22px;
  margin-bottom: 4px;
}
.info-modal__blurb {
  margin-bottom: 24px;
}
.info-modal__details {
  font-size: 14px;
  margin-bottom: 8px;
}
@media (min-width: 750px) {
  .info-modal {
    max-width: 450px;
  }
}
@media (min-width: 950px) {
  .info-modal {
    max-width: 550px;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.address-fields-auto-complete__title {
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 24px;
  color: #1a1e22;
}
.address-fields-auto-complete__input {
  position: relative;
}
.address-fields-auto-complete__close-icon {
  position: absolute;
  right: 8px;
  bottom: 5px;
  right: 28px;
  width: 40px;
  background: url('black-x.ee73895ade137101c481.svg') no-repeat center;
  height: 40px;
  cursor: pointer;
}
.address-fields-auto-complete__address-not-found {
  margin-bottom: 16px;
}
.address-fields-auto-complete__error-text {
  color: #c53d31;
  font-style: italic;
  margin-bottom: 8px;
}
.address-fields-auto-complete__footer {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;
  color: #5d5d5e;
  justify-content: flex-end;
}
.address-fields-auto-complete__google-logo {
  display: inline;
  height: 20px;
  margin-left: 4px;
}
.address-fields-auto-complete__cant-find-address-button {
  font-weight: 600;
  font-size: 14px;
  text-decoration: underline;
}
.address-fields-auto-complete__cant-find-address-button:hover {
  color: #ffeaea;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.acknowledgement-disclosure {
  padding: 32px 0 32px 0;
  margin-bottom: 32px;
  border-bottom: 1px solid #dadada;
}
.acknowledgement-disclosure p {
  font-size: 12px;
  line-height: 1.65;
}
@media (min-width: 1900px) {
  .acknowledgement-disclosure {
    max-width: 1100px;
    margin: 0 auto 32px;
  }
}
.amazon-benefits {
  margin-bottom: 32px;
}
.amazon-benefits__trait-container {
  margin-bottom: 24px;
}
.amazon-benefits__trait-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.amazon-benefits__trait-item {
  display: flex;
  gap: 16px;
}
.amazon-benefits__cta-container {
  display: inline-flex;
}
.amazon-benefits__trait-icon {
  height: 24px;
}
.amazon-benefits__trait-label {
  font-size: 14px;
  line-height: 1.5;
}
.amazon-benefits__cta-button {
  display: inline-flex;
  text-transform: none;
  width: unset;
  font-size: 14px;
  padding: 16px;
}
.amazon-benefits__skip-button {
  display: inline-flex;
  text-transform: none;
  width: unset;
  font-size: 14px;
  padding: 16px;
  margin-left: 0px;
}
.amazon-benefits__disclaimer {
  font-size: 12px;
  line-height: 1.5;
}
.amazon-benefits__horizontal-divider {
  border-bottom: 1px solid #dddddd;
  margin: 32px 0;
}
.amazon-to-sage-loader {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.amazon-to-sage-loader__container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px;
  position: relative;
}
.amazon-to-sage-loader__logo {
  width: 128px;
  height: auto;
  opacity: 0.7;
  transition: opacity 0.3s ease;
  position: relative;
  z-index: 2;
}
.is-animating .amazon-to-sage-loader__logo--amazon {
  opacity: 1;
  animation: pulse 1s ease-in-out infinite;
}
.amazon-to-sage-loader__logo--sage {
  margin-top: auto;
}
.is-animating .amazon-to-sage-loader__logo--sage {
  opacity: 1;
  animation: pulse 1s ease-in-out infinite;
}
.amazon-to-sage-loader__transfer-dots {
  width: 4px;
  height: 48px;
  position: relative;
  margin: 0 auto;
}
.is-animating .amazon-to-sage-loader__transfer-dots::after {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: transferDot 1.5s ease-in-out infinite;
}
.is-animating .amazon-to-sage-loader__transfer-dots.\\--first::after {
  opacity: 0;
}
.is-animating .amazon-to-sage-loader__transfer-dots.\\--second::after {
  animation-delay: 0.3s;
  opacity: 0;
}
.is-animating .amazon-to-sage-loader__transfer-dots.\\--third::after {
  animation-delay: 0.5s;
  opacity: 0;
}
.is-animating .amazon-to-sage-loader__transfer-dots.\\--fourth::after {
  animation-delay: 0.8s;
  opacity: 0;
}
.is-animating .amazon-to-sage-loader__transfer-dots.\\--fifth::after {
  animation-delay: 0.1s;
  opacity: 0;
}
@keyframes transferDot {
  0% {
    top: 0;
    opacity: 0;
    background-color: #1270a1;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 0.8;
  }
  100% {
    top: 100%;
    background-color: #3d7c54;
    opacity: 0.1;
  }
}
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.amazon-demo-header {
  padding: 24px;
  margin-bottom: 32px;
  background-color: #f0f9f1;
  border-radius: 24px;
}
.amazon-demo-header__content {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}
.amazon-demo-header__logos {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.amazon-demo-header__sage-logo {
  height: 60px;
}
.amazon-demo-header__amazon-logo {
  margin-top: 4px;
  height: 48px;
}
.amazon-demo-header__plus {
  font-size: 28px;
  color: #518965;
}
.amazon-demo-header__description {
  font-size: 12px;
  margin-top: 24px;
  color: #5d5d5e;
  line-height: 1.6;
  text-align: justify;
}
.amazon-demo-header__separator {
  display: none;
}
@media (min-width: 1100px) {
  .amazon-demo-header__separator {
    border-right: 2px solid #5d5d5e;
    height: 24px;
    margin: 0 8px;
    display: inline-block;
    vertical-align: middle;
    border-radius: 8px;
  }
}
.amazon-demo-header__savings {
  font-size: 14px;
  margin: 0;
}
.amazon-demo-header__savings-amount {
  font-weight: 700;
  font-size: 22px;
  display: inline;
  color: #1270a1;
}
.amazon-demo-header--no-card {
  background-color: transparent;
  padding: 0;
  margin: 0;
  border-radius: 0;
}
.amazon-demo-header--compact .amazon-demo-header__content {
  flex-direction: column;
  gap: 24px;
  margin-bottom: 32px;
}
@media (min-width: 1100px) {
  .amazon-demo-header--compact .amazon-demo-header__content {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: left;
    gap: 8px;
  }
}
.amazon-demo-header--compact .amazon-demo-header__logos {
  margin-bottom: 0;
}
.amazon-demo-header--compact .amazon-demo-header__logos--compact {
  margin-bottom: 8px;
}
.amazon-demo-header--compact .amazon-demo-header__savings {
  flex-shrink: 0;
  white-space: nowrap;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
/* Replace the specific ID selector with an attribute selector that matches all iframe IDs */
[id^=plaid-link-iframe-] {
  left: 130px !important;
}
@media (max-width: 767px) {
  [id^=plaid-link-iframe-] {
    top: -80px !important;
    left: 0px !important;
  }
}
.plaid-assets {
  min-height: 500px;
}
@media (min-width: 768px) {
  .plaid-assets {
    min-width: unset;
  }
}
.plaid-assets__divider {
  height: 1px;
  background-color: #3d7c54;
  margin: 48px 0 32px 0;
}
.plaid-assets__header {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}
.plaid-assets__logo {
  justify-items: center;
  margin-bottom: 36px;
}
.plaid-assets__title {
  font-size: 14px;
  color: #246464;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.15em;
}
.plaid-assets__center {
  text-align: center;
  align-self: center;
}
.plaid-assets__subtitle {
  font-size: 16px;
  font-weight: 600;
}
.plaid-assets__bullet-item {
  font-size: 16px;
  font-weight: 500;
  list-style-type: disc;
  margin-left: 16px;
  margin-bottom: 16px;
}
.plaid-assets__heading {
  font-size: 26px;
  font-weight: 600;
}
.plaid-assets__description {
  font-size: 16px;
  font-weight: 200;
}
.plaid-assets__benefits {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
}
.plaid-assets__benefit {
  display: flex;
  align-items: center;
  gap: 16px;
}
.plaid-assets__benefit img {
  height: 24px;
  width: 24px;
}
.plaid-assets__cta-start-plaid, .plaid-assets__cta-button {
  width: 100%;
  text-transform: none;
}
.plaid-assets__cta-start-plaid:hover, .plaid-assets__cta-button:hover {
  cursor: pointer;
}
.plaid-assets__cta-start-plaid:disabled, .plaid-assets__cta-button:disabled {
  cursor: not-allowed;
}
.plaid-assets__cta-link {
  color: #3d7c54;
}
.plaid-assets__cta-link:hover {
  text-decoration: underline;
  cursor: pointer;
}
.plaid-assets__cta-link:focus {
  outline-color: transparent;
  text-decoration: underline;
}
.plaid-assets__cta-link:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}
.plaid-assets__disclaimer {
  font-size: 12px;
  font-weight: 200;
}
.plaid-assets__page-continue-hidden .button.--continue {
  display: none;
}
.plaid-assets__mt-16 {
  margin-top: 16px;
}
.plaid-assets__mt-24 {
  margin-top: 24px;
}
.plaid-assets__mb-16 {
  margin-bottom: 16px;
}
.plaid-assets__mb-24 {
  margin-bottom: 24px;
}
.plaid-assets__primary-color {
  color: #3d7c54;
}
.plaid-assets__accounts-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
}
.plaid-assets__account {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.plaid-assets__success-finish {
  min-width: 260px;
  text-transform: none;
}
.plaid-assets__success-finish:hover {
  cursor: pointer;
}
.plaid-assets__success-finish:disabled {
  cursor: not-allowed;
}
.plaid-assets__flex-column {
  display: flex;
  flex-direction: column;
}
.plaid-assets__loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.plaid-assets__loading-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #3d7c54;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.plaid-assets__hidden {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
}
.plaid-assets__failure-cta-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
  align-items: baseline;
}
@media (min-width: 768px) {
  .plaid-assets__failure-cta-container {
    flex-direction: row;
  }
}
.plaid-assets__retry-btn {
  min-width: 180px;
  text-align: center;
}
@media (max-width: 768px) {
  .plaid-assets__retry-btn {
    width: 100%;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.rate-card-container {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-content: space-evenly;
  align-items: center;
  margin: 16px auto;
  margin-top: 6px;
}
@media (min-width: 750px) {
  .rate-card-container {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 950px) {
  .rate-card-container {
    grid-template-columns: repeat(2, 1fr);
    max-width: 800px;
  }
}
@media (min-width: 1300px) {
  .rate-card-container {
    grid-template-columns: repeat(3, 1fr);
    max-width: 1100px;
  }
}
@media (min-width: 1900px) {
  .rate-card-container {
    max-width: 1200px;
  }
}
.rate-card-container__show-more-container {
  display: flex;
  flex-direction: row;
  margin: 8px 0 24px;
  justify-content: center;
  width: 100%;
}
.rate-card-container__show-more-btn {
  margin: 0 auto;
  background-color: transparent;
  flex: unset;
  text-transform: none;
  outline: none;
  color: #3d7c54;
  border: 1px solid #3d7c54;
}
.rate-card-container__show-more-btn:hover {
  color: #fff;
}
.rate-card-masonry {
  font-weight: 400;
  font-size: 18px;
  margin: 16px 16px;
  padding: 24px;
  border-radius: 8px;
  width: 300px;
  border: 1px solid #dddddd;
}
.rate-card-masonry.\\--simple {
  height: 350px;
}
.rate-card-masonry.\\--robinhood {
  height: auto;
}
.rate-card-masonry__description {
  color: #1a1e22;
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 16px;
}
.rate-card-masonry__description__header {
  color: #246464;
  text-transform: uppercase;
}
.rate-card-masonry__superlatives-container {
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
}
.rate-card-masonry__superlatives-text {
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  margin: auto 8px;
}
.rate-card-masonry__monthly-amount {
  font-weight: 600;
  font-size: 48px;
  line-height: 1;
}
.rate-card-masonry__points-tooltip {
  margin: auto 2px;
}
.rate-card-masonry__details-container {
  margin: 16px 0;
  padding-bottom: 16px;
  border-bottom: 1px solid #dddddd;
}
.rate-card-masonry__details {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.rate-card-masonry__rh-details {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 16px;
  padding: 10px 0 10px 0;
}
.rate-card-masonry__details-tooltip {
  margin: 0 auto 0 4px;
}
.rate-card-masonry__details-value {
  font-weight: 600;
  font-size: 18px;
}
.rate-card-masonry__gold-rate {
  font-weight: 600;
  font-size: 18px;
  color: #9d800a;
}
.rate-card-masonry__why-match-heading {
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  color: #246464;
}
.rate-card-masonry__why-match-description {
  margin-bottom: 16px;
  font-weight: 400;
  font-size: 14px;
}
.rate-card-masonry__why-match-description > span {
  color: #246464;
}
.rate-card-masonry__lock-button {
  background-color: #3d7c54;
  width: 100%;
  text-transform: unset;
}
.rate-card-masonry__fee-breakdown {
  color: #3d7c54;
  text-decoration: underline;
  cursor: pointer;
  text-align: center;
  font-size: 14px;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.rate-card-compare {
  font-weight: 400;
  font-size: 18px;
  margin: 16px;
  padding: 24px;
  border-radius: 8px;
  width: 330px;
  border: 1px solid #dddddd;
}
.rate-card-compare__logo-container {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #dddddd;
}
.rate-card-compare__superlatives-container {
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
}
.rate-card-compare__superlatives-text {
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin: auto 8px;
}
.rate-card-compare__superlatives-text .tooltip__body {
  font-weight: 400;
  font-size: 14px;
  letter-spacing: normal;
  text-transform: none;
}
.rate-card-compare__superlatives-icon {
  height: 21px;
}
.rate-card-compare__monthly-amount {
  font-weight: 600;
  font-size: 48px;
  line-height: 1;
}
.rate-card-compare__details-container {
  margin: 16px 0;
  padding-bottom: 16px;
  border-bottom: 1px solid #dddddd;
}
.rate-card-compare__rate-container, .rate-card-compare__apr-container, .rate-card-compare__points-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.rate-card-compare__details-tooltip {
  margin: 0 auto 0 4px;
}
.rate-card-compare__details-value {
  font-weight: 600;
  font-size: 18px;
}
.rate-card-compare__why-match-heading {
  font-weight: 600;
  font-size: 18px;
  text-transform: uppercase;
  color: #3d7c54;
}
.rate-card-compare__why-match-description {
  margin-bottom: 16px;
  font-weight: 400;
  font-size: 18px;
}
.rate-card-compare__why-match-description > span {
  color: #246464;
}
.rate-card-compare__lock-button {
  margin-bottom: 0;
  background-color: #3d7c54;
  width: 100%;
  text-transform: unset;
}
.rate-card-compare__fee-breakdown {
  color: #3d7c54;
  text-decoration: underline;
  cursor: pointer;
  text-align: center;
}
.rate-card-compare.\\--other-lender {
  color: #5d5d5e;
}
.rate-card-compare.\\--other-lender .rate-card-compare__details-container {
  padding-bottom: 0;
  border: none;
}
.br-compare.\\--other-lender {
  background-color: #f3f4f8;
}
.br-compare__lock-button {
  border-radius: 5px;
}
.br-compare__logo-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-height: 80px;
}
.br-compare__lender-logo {
  width: 100px;
}
.br-compare__brand-border {
  border-color: #3d7c54;
  border-width: 2px;
}
.br-compare__nmls {
  margin-top: 4px;
  margin-left: 4px;
  font-size: 12px;
  letter-spacing: 1.1px;
  color: #5d5d5e;
}
.br-compare__value-props-container {
  margin: 16px 0;
}
.br-compare__value-props-heading {
  font-weight: 600;
  font-size: 18px;
  color: #3d7c54;
}
.br-compare__value-props-list {
  margin-left: 16px;
  font-size: 14px;
  list-style: initial;
}
.br-compare__value-props-item {
  margin: 5px 0;
}
@media (min-width: 950px) {
  .br-compare.\\--other-lender {
    margin-top: 112px;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.file-upload {
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-radius: 32px;
  position: relative;
  border: 1px dashed #1a1e22;
  align-items: center;
  align-content: center;
  width: 100%;
}
@media (min-width: 950px) {
  .file-upload {
    padding: 32px 64px;
  }
}
.file-upload.success {
  border-color: #3d7c54;
  background-color: #9ec9b6;
}
.file-upload.failure {
  border-color: #c53d31;
  background-color: #ffeaea;
}
.file-upload__body {
  margin-top: 8px;
  margin-bottom: 24px;
  font-size: 18px;
  letter-spacing: 0.25px;
  color: #1a1e22;
  text-align: center;
}
.file-upload__image {
  width: 72px;
}
.file-upload__button {
  letter-spacing: 2.5px;
  border-radius: 4px;
  display: inline-block;
  padding: 16px 32px;
  background-color: transparent;
  color: #3d7c54;
  border: 2px solid #3d7c54;
  font-weight: 600;
  font-size: 14px;
  border-radius: 32px;
  text-transform: uppercase;
}
.file-upload__button:hover {
  background-color: #3d7c54;
  color: #fff;
}
.file-upload__button.--margin-top {
  margin-top: 32px;
}
.file-upload__fake-link {
  cursor: pointer;
  color: #3d7c54;
  text-decoration: underline;
}
.file-upload input[type=file] {
  height: 100%;
  width: 100%;
  visibility: hidden;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.loan-officer-popup__container {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.loan-officer-popup__headshot {
  margin-right: 16px;
  border-radius: 50%;
  height: 64px;
  -o-object-fit: cover;
     object-fit: cover;
  width: 64px;
}
.loan-officer-popup__text-container {
  font-weight: 400;
  font-size: 14px;
  color: #fff;
}
.loan-officer-popup__name {
  font-weight: 600;
  font-size: 18px;
}
.loan-officer-popup__phone {
  font-weight: 600;
  font-size: 14px;
}
.loan-officer-popup__hyperlink {
  font-weight: 600;
  font-size: 14px;
  color: #fff;
  text-decoration: underline;
}
.Toastify__toast {
  background-color: #246464 !important;
}
.Toastify__toast-container--bottom-right {
  right: 10em !important;
}
@media (min-width: 480px) {
  .Toastify__toast {
    border-radius: 10px !important;
    width: 430px;
  }
}
.Toastify__close-button--light {
  color: #fff !important;
  border: 1px solid #fff !important;
  border-radius: 50%;
  padding: 5px 5px 6px 6px !important;
  opacity: 1 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.br-file-upload__container.\\--desktop {
  display: none;
}
.br-file-upload__container {
  display: flex;
  flex-direction: column;
  margin: 32px 0;
  align-items: center;
}
.br-file-upload__file-drop-container {
  display: flex;
  flex-direction: column;
  max-width: 100%;
}
.br-file-upload__cta {
  display: flex;
  flex-direction: column;
  padding: 32px;
  border-radius: 8px;
  padding-left: 40px;
  padding-right: 40px;
  background-color: #eaf2fd;
  align-items: center;
  justify-content: center;
  max-width: 460px;
  box-shadow: 0px 0px 1px rgba(21, 21, 21, 0.1), 0px 2px 8px -1px rgba(21, 21, 21, 0.2);
}
.br-file-upload__cta.success {
  border-color: #3d7c54;
  background-color: #9ec9b6;
}
.br-file-upload__cta.failure {
  border-color: #c53d31;
  background-color: #ffeaea;
}
.br-file-upload__cta input[type=file] {
  visibility: hidden;
  height: 10px;
}
.br-file-upload__cta-title {
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: #3d7c54;
}
.br-file-upload__cta-body {
  margin-top: 8px;
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.25px;
  font-size: 20px;
  color: #1a1e22;
  text-align: center;
}
.br-file-upload__cta-subtitle {
  font-size: 14px;
  margin-bottom: 24px;
  text-align: center;
}
.br-file-upload__cta-button {
  letter-spacing: 2.5px;
  border-radius: 4px;
  display: inline-block;
  padding: 16px 32px;
  background-color: #3d7c54;
  color: #fff;
  border: none;
  font-weight: 600;
  font-size: 18px;
  padding: 16px 32px;
  margin: 0 0 8px;
  width: 100%;
}
.br-file-upload__cta-button:hover {
  background-color: #356b48;
}
.br-file-upload__cta-next {
  display: flex;
  align-items: center;
}
.br-file-upload__cta-next-arrow {
  margin-left: 8px;
}
.br-file-upload__file-types {
  margin-bottom: 8px;
  font-size: 12px;
}
.br-file-upload__or-separator {
  margin-bottom: 8px;
}
@media (min-width: 950px) {
  .br-file-upload__or-separator {
    margin: 0 8px;
  }
}
.br-file-upload__cta-button-inverted {
  padding: 16px 32px;
  letter-spacing: 2.5px;
  border-radius: 4px;
  display: inline-block;
  padding: 16px 32px;
  background-color: #fff;
  color: #1a1e22;
  border: none;
  font-weight: 600;
  font-size: 18px;
  width: 100%;
  border: 2px solid #3d7c54;
  border-radius: 4px;
  color: #3d7c54;
}
.br-file-upload__cta-button-inverted:hover {
  background-color: #f2f2f2;
}
.br-compare-page__upload-wrapper {
  margin-left: auto;
  margin-right: auto;
  max-width: 900px;
}
.br-compare-page__heading-group {
  margin-bottom: 32px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  max-width: 920px;
}
.br-compare-page__title {
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 32px;
  line-height: 1.3;
  color: #1a1e22;
}
@media (min-width: 950px) {
  .br-compare-page__title {
    font-size: 42px;
    letter-spacing: 1.3px;
  }
}
.br-compare-page__button {
  border-radius: 5px;
}
@media (min-width: 750px) {
  .br-compare-page__heading-group {
    padding: 0 32px;
  }
}
@media (min-width: 950px) {
  .br-compare-page__heading-group {
    padding: 0 24px;
  }
  .br-file-upload__container.\\--mobile {
    display: none;
  }
  .br-file-upload__container.\\--desktop {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .br-file-upload__container.\\--desktop .br-file-upload__cta {
    min-height: 225px;
    min-width: 415px;
    justify-content: flex-start;
    border: 1px dashed #868a9a;
    background-color: transparent;
    box-shadow: none;
  }
  .br-file-upload__container.\\--desktop .br-file-upload__cta.\\--manual-address {
    border-style: solid;
    border-radius: 10px;
  }
  .br-file-upload__container.\\--desktop .br-file-upload__cta-image {
    max-height: 32px;
  }
  .br-file-upload__container.\\--desktop .br-file-upload__cta-button {
    font-weight: 600;
    font-size: 14px;
  }
  .br-file-upload__container.\\--desktop .br-file-upload__file-types {
    margin-bottom: 0;
  }
}
@media (min-width: 1100px) {
  .br-file-upload__container.\\--desktop .br-file-upload__cta {
    padding: 32px 64px;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.bankrate-social-footer {
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #dddddd;
  align-items: center;
  justify-content: center;
  position: relative;
}
.bankrate-social-footer__title {
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1.5px;
  padding-right: 16px;
  color: #1a1e22;
  text-transform: uppercase;
}
.bankrate-social-footer__icon {
  max-width: 36px;
  height: auto;
  -o-object-fit: contain;
     object-fit: contain;
  padding-right: 16px;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.br-value-props__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  text-align: center;
  max-width: 1100px;
}
.br-value-props__heading {
  font-weight: 600;
  font-size: 32px;
  margin-bottom: 64px;
}
.br-value-props__list {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.br-value-props__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 32px;
}
.br-value-props__item:last-of-type {
  margin-bottom: 0;
}
.br-value-props__item-heading {
  font-weight: 600;
  font-size: 22px;
  margin-bottom: 24px;
}
.br-value-props__item-blurb {
  padding: 24px;
}
.br-value-props__icon-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 75px;
  margin-bottom: 32px;
  width: 100%;
}
.br-value-props__icon {
  display: block;
  height: 100%;
}
@media (min-width: 400px) {
  .br-value-props__wrapper {
    padding: 32px;
  }
  .br-value-props__item {
    margin-bottom: 64px;
  }
  .br-value-props__item-blurb {
    padding: 0 64px;
  }
}
@media (min-width: 750px) {
  .br-value-props__list {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }
  .br-value-props__item {
    margin-left: 32px;
    margin-right: 32px;
    margin-bottom: 0;
  }
  .br-value-props__item:first-of-type {
    margin-left: 0;
  }
  .br-value-props__item:last-of-type {
    margin-right: 0;
  }
  .br-value-props__item-blurb {
    padding: 0;
  }
}
@media (min-width: 1100px) {
  .br-value-props__wrapper {
    padding: 32px 96px 64px 96px;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.br-rates-variation__container {
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  align-items: center;
  justify-content: center;
  max-width: 1100px;
}
.br-rates-variation__icon {
  margin-bottom: 24px;
  height: 50px;
}
.br-rates-variation__title {
  font-size: 28px;
  text-align: center;
}
.br-rates-variation__description-container {
  margin-bottom: 32px;
  max-width: 400px;
}
.br-rates-variation__description-container p {
  text-align: center;
}
.br-rates-variation__button-wrapper {
  min-width: 200px;
}
.br-rates-variation__cashout-heading {
  font-weight: 600;
  font-size: 18px;
  color: #3d7c54;
}
.br-rates-variation__cashout-amount {
  margin: 24px 0;
  font-size: 22px;
  text-align: center;
}
.br-rates-variation__cashout-amount span {
  color: #3d7c54;
}
@media (min-width: 600px) {
  .br-norates__description-container {
    max-width: 600px;
  }
  .br-norates__description-container p span {
    display: block;
  }
}
@media (min-width: 750px) {
  .br-norates__container {
    min-height: 400px;
  }
  .br-norates__title {
    font-size: 32px;
  }
}
@media (min-width: 950px) {
  .br-norates__container {
    min-height: 500px;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.br-checks-vp__container {
  display: flex;
  flex-direction: column;
  padding: 16px;
  font-weight: 600;
  font-size: 14px;
  justify-content: space-between;
  margin: 24px auto;
  max-width: 320px;
  border: 1px solid #b2b2b2;
  border-radius: 10px;
}
.br-checks-vp__checks-container {
  display: flex;
  margin: 16px 0;
  padding-left: 8px;
}
.br-checks-vp__image {
  margin-right: 16px;
  width: 18px;
}
.br-checks-vp__vertical-line {
  display: none;
}
@media (min-width: 950px) {
  .br-checks-vp__container {
    display: flex;
    flex-direction: row;
    padding: 16px 24px;
    margin-top: 32px;
    font-size: 18px;
    max-width: 1000px;
  }
  .br-checks-vp__vertical-line {
    display: block;
    width: 2px;
    background-color: #dadada;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.br-how-it-works__container {
  display: flex;
  flex-direction: column;
  margin: 24px;
  text-align: center;
  align-items: center;
}
@media (min-width: 950px) {
  .br-how-it-works__container {
    margin: 32px;
    flex-direction: row;
    text-align: left;
    align-items: unset;
    justify-content: center;
  }
}
@media (min-width: 950px) {
  .br-how-it-works__blurb-container {
    max-width: 600px;
  }
}
.br-how-it-works__heading {
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 22px;
}
.br-how-it-works__description {
  font-size: 14px;
}
@media (min-width: 950px) {
  .br-how-it-works__description {
    margin-right: 64px;
  }
}
.br-how-it-works__sub-heading {
  font-size: 18px;
  margin-bottom: 16px;
}
@media (min-width: 950px) {
  .br-how-it-works__sub-heading {
    margin-bottom: 0;
  }
}
.br-how-it-works__rate-table-image {
  width: 100%;
  max-width: 400px;
}
.br-how-it-works__promise-heading {
  font-weight: 600;
  font-size: 18px;
  color: #3d7c54;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.br-cards-vp__container {
  margin: 64px 4px;
  text-align: center;
}
@media (min-width: 950px) {
  .br-cards-vp__bg-container {
    display: flex;
    justify-content: center;
    background: url('BR_Dashed_Line.38713f113b9cb5cf1193.svg') no-repeat;
    background-size: contain;
    background-position: center;
  }
}
@media (min-width: 950px) {
  .br-cards-vp__cards-container {
    display: flex;
    justify-content: space-between;
    max-width: 1000px;
    width: 100%;
  }
}
.br-cards-vp__heading {
  font-weight: 600;
  font-size: 22px;
  margin-bottom: 16px;
}
.br-cards-vp__card-container {
  display: flex;
  flex-direction: column;
  margin: 32px 0;
  background-color: #fff;
  align-items: center;
}
@media (min-width: 950px) {
  .br-cards-vp__card-container {
    margin: 16px 16px 0;
    padding: 16px;
    gap: 8px;
    width: 300px;
    min-height: 165px;
    justify-content: center;
    border-radius: 8px;
    box-shadow: 0px 0px 3px rgba(21, 21, 21, 0.1), 0px 8px 16px -3px rgba(21, 21, 21, 0.2);
  }
  .br-cards-vp__card-container:first-of-type {
    margin-left: 0;
  }
  .br-cards-vp__card-container:last-of-type {
    margin-right: 0;
  }
}
.br-cards-vp__card-image {
  width: 32px;
}
@media (min-width: 950px) {
  .br-cards-vp__card-image {
    width: 48px;
  }
}
.br-cards-vp__card-heading {
  font-weight: 600;
  font-size: 14px;
}
@media (min-width: 950px) {
  .br-cards-vp__card-description {
    max-width: 88%;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.review-page__container {
  margin: 32px 0;
  display: grid;
  grid-template-areas: "text" "rate" "button";
}
@media (min-width: 950px) {
  .review-page__container {
    margin: 32px 24px;
    grid-template-areas: "text text rate" "button . rate";
  }
  .review-page__container.\\--no-grid {
    display: unset;
  }
}
.review-page__container .loan-officer-popup__container {
  padding: 16px;
  margin: 16px 0 8px;
  border: 1px solid #3d7c54;
  border-radius: 8px;
}
.review-page__container .loan-officer-popup__text-container,
.review-page__container .loan-officer-popup__hyperlink {
  color: #1a1e22;
  cursor: pointer;
}
.review-page__details-container {
  grid-area: text;
}
.review-page__details-step-heading {
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1.5px;
  color: #3d7c54;
  text-transform: uppercase;
}
.review-page__details-section-container {
  margin-bottom: 32px;
}
.review-page__details-section-title {
  padding: 8px 0;
  margin: 16px 0;
  font-weight: 600;
  font-size: 22px;
  letter-spacing: 1px;
  border-bottom: 1px solid #b2b2b2;
  word-break: break-word;
}
.review-page__details-section-content {
  margin: 16px 0;
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 16px 32px;
}
.review-page__details-section-content-heading {
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
}
@media (min-width: 750px) {
  .review-page__details-section-content-heading {
    font-size: 18px;
  }
}
.review-page__details-section-content-body {
  font-size: 14px;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}
@media (min-width: 750px) {
  .review-page__details-section-content-body {
    font-size: 18px;
  }
}
.review-page__rate-lo-info-container {
  grid-area: rate;
}
.review-page__rate-lo-info-container.\\--phone-app {
  max-width: 400px;
  margin: 32px auto 0;
}
@media (min-width: 950px) {
  .review-page__rate-lo-info-container {
    margin: 0 0 24px 32px;
  }
}
@media (min-width: 1100px) {
  .review-page__rate-lo-info-container {
    margin: 0 0 24px 64px;
  }
}
.review-page__rate-container {
  margin: 24px auto;
  max-width: 300px;
  background-color: #246464;
  border-radius: 8px;
}
.review-page__rate-screenshot {
  padding: 2px 16px 16px;
}
.review-page__rate-screenshot .rate-card-masonry {
  padding: 16px;
  margin: 8px auto;
  background-color: #fff;
  width: 265px;
}
.review-page__rate-heading {
  font-size: 22px;
  padding: 16px 24px 2px;
  color: #fff;
}
.review-page__continue-button {
  grid-area: button;
  margin: 24px 0;
}
.review-page__continue-button button {
  padding: 16px 32px;
  width: 100%;
}
.review-page__continue-link {
  margin-bottom: 24px;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  display: block;
}
.review-page__continue-description {
  margin: 24px 0 16px;
  max-width: 600px;
}
.review-page__continue-list {
  display: flex;
  flex-direction: row;
  margin: 16px 0;
  gap: 16px;
}
.review-page__continue-list-image {
  width: 20px;
  height: 22px;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.update-rates__form {
  margin: 24px;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: space-around;
  flex-flow: wrap;
  min-width: 200px;
  max-width: 300px;
  border-bottom: 1px solid #dddddd;
}
.update-rates__form.\\--modal {
  flex-flow: wrap;
  justify-content: space-around;
}
.update-rates__button-container {
  margin: 24px;
}
.update-rates__button-wrapper {
  display: flex;
  flex-direction: row;
  padding: 0;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  width: 183px;
  height: 50px;
}
.update-rates__submit-button {
  border-radius: 24px;
  padding: 16px;
  text-transform: none;
  height: 50px;
  max-width: 300px;
  color: #fff;
  background-color: #3d7c54;
}
.update-rates__submit-button:disabled {
  background-color: #dddddd;
  color: #fff;
}
@media (min-width: 450px) {
  .update-rates__form {
    min-width: 400px;
    max-width: 550px;
  }
  .update-rates__button-wrapper {
    width: 300px;
  }
}
@media (min-width: 1300px) {
  .update-rates__form {
    display: flex;
    flex-direction: row;
    border: none;
    max-width: 100%;
    flex-flow: nowrap;
  }
  .update-rates__submit-button {
    min-width: 165px;
    max-width: 165px;
    margin-top: 22px !important;
  }
  .update-rates__button-container {
    margin: 8px;
  }
  .update-rates__button-wrapper {
    width: 188px;
  }
}
.success-confetti-screen__container {
  display: flex;
  flex-direction: column;
  margin: 0 24px 24px 24px;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  text-align: center;
  background-color: #f1f9f1;
  border-radius: 50%;
  min-height: 480px;
  width: calc(100% + 64px);
  max-width: 500px;
}
@media (min-width: 950px) {
  .success-confetti-screen__container {
    max-width: 800px;
  }
}
.success-confetti-screen__title {
  font-weight: 600;
  font-size: 28px;
}
@media (min-width: 950px) {
  .success-confetti-screen__title {
    font-size: 32px;
  }
}
.success-confetti-screen__subtitle {
  margin: 8px 0;
  font-size: 18px;
  max-width: 80%;
}
@media (min-width: 950px) {
  .success-confetti-screen__subtitle {
    font-size: 22px;
  }
}
.success-confetti-screen__description {
  margin: 8px 0;
  max-width: 90%;
}
.success-confetti-screen__button {
  margin: 24px 0;
  text-transform: inherit;
  flex-grow: 0;
  width: 75%;
}
@media (min-width: 950px) {
  .success-confetti-screen__button {
    width: 50%;
  }
}
.success-confetti-screen__animation {
  position: fixed;
  pointer-events: none;
  width: 100%;
  height: 100%;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.list-content__title {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 4px;
}
.list-content__option {
  display: flex;
  flex-direction: row;
  padding: 4px;
}
.list-content__option-checkmark-wrapper {
  display: flex;
  align-items: center;
}
.list-content__option-text {
  font-weight: 400;
  font-size: 12px;
  margin-left: 8px;
}
.bankrate-modal {
  text-align: center;
  padding: 32px;
}
@media (min-width: 950px) {
  .bankrate-modal {
    width: 600px;
  }
}
.bankrate-modal__pre-header {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 8px;
  color: #3d7c54;
}
.bankrate-modal__header {
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 16px;
}
.bankrate-modal__body {
  font-size: 14px;
  margin-bottom: 16px;
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.robinhood-banner {
  width: 100%;
  max-width: 425px;
  background: #fffbee;
  border-radius: 8px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
  padding: 16px;
  margin-bottom: 16px;
  margin-top: -20px;
}
.robinhood-banner__content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.robinhood-banner__title {
  color: var(--Secondary-Slate, #5d5d5e);
  font-family: "Rh-phonic";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}
.robinhood-banner__icon {
  width: 14px;
  height: 18px;
  margin-left: 0;
  vertical-align: middle;
  position: relative;
  top: -1px;
}
.robinhood-banner__gold {
  color: #000000;
}
.robinhood-banner__description {
  font-size: 14px;
  line-height: 1.4;
  color: #333333;
  font-family: "poppins", -apple-system, BlinkMacSystemFont, sans-serif;
  margin-top: 2px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.1px;
}
.robinhood-banner__highlight {
  font-weight: 600;
}
.robinhood-banner__learn-more {
  font-size: 14px;
  font-weight: 600;
  color: #000;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  padding-left: 6px;
}
.robinhood-banner__learn-more:hover {
  text-decoration: underline;
}
.robinhood-banner__learn-more:focus {
  outline: none;
}
.robinhood-banner__arrow {
  margin-left: 4px;
  font-size: 18px;
}
@media (min-width: 950px) {
  .robinhood-banner {
    padding: 20px;
    max-width: none;
  }
  .robinhood-banner__content {
    gap: 12px;
  }
  .robinhood-banner__title {
    font-size: 14px;
    line-height: 24px;
  }
  .robinhood-banner__gold {
    font-size: 14px;
  }
  .robinhood-banner__icon {
    width: 16px;
    height: 20px;
  }
  .robinhood-banner__description {
    font-size: 16px;
    letter-spacing: -0.2px;
  }
}
@media (min-width: 1100px) {
  .robinhood-banner {
    padding: 24px;
  }
  .robinhood-banner__content {
    gap: 14px;
  }
  .robinhood-banner__title {
    font-size: 15px;
  }
  .robinhood-banner__gold {
    font-size: 15px;
  }
  .robinhood-banner__description {
    font-size: 18px;
    line-height: 170%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/dist/sage-home-loans/components.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,qEAAwE;AAC1E;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;EACT,WAAW;EACX,oEAAuE;EACvE,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;AACxB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AAFA;EACE,cAAc;AAChB;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AAEA;EACE,2BAA2B;AAC7B;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;AACzB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AAEA;EACE,oCAAoC;AACtC;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;AAEA;EACE,6BAA6B;AAC/B;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AAEA;EACE,aAAa;AACf;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,8BAA8B;AAChC;AAEA;EACE;IACE,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,UAAU;EACV,sCAAsC;EACtC,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,sBAAmB;KAAnB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;AACd;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,eAAe;EACf,cAAc;EACd,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,UAAU;AACZ;AAHA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;AAEA;EACE,gBAAgB;AAClB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;EACf;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;AACA;EACE,OAAO;EACP,gCAAgC;AAClC;AACA;EACE;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,cAAc;EAChB;AACF;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;AAEA;EACE,0BAA0B;AAC5B;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,cAAc;EACd,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,wBAAmB;EAAnB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,WAAW;AACb;AACA;EACE,yCAAyC;EACzC,cAAc;EACd,UAAU,EAAE,YAAY;AAC1B;AAJA;EACE,yCAAyC;EACzC,cAAc;EACd,UAAU,EAAE,YAAY;AAC1B;AACA;EACE,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,mEAAsE;EACtE,SAAS;AACX;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,SAAS;EACT,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,sDAAsD;EACtD,WAAW;EACX,UAAU;AACZ;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,UAAU;AACZ;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;AACA;EACE;IACE,mBAAmB;IACnB,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE;IACE,8BAA8B;EAChC;AACF;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,oBAAiB;KAAjB,iBAAiB;EACjB,uBAAoB;KAApB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,oBAAiB;KAAjB,iBAAiB;EACjB,uBAAoB;KAApB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,oBAAiB;KAAjB,iBAAiB;EACjB,uBAAoB;KAApB,oBAAoB;AACtB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,OAAO;AACT;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,2BAAsB;EAAtB,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,qBAAgB;OAAhB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AAEA;EACE;IACE,kCAAkC;IAClC,mCAAmC;EACrC;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,SAAS;AACX;AACA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,yCAAyC;EACzC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,6BAA6B;EAC7B,sCAAsC;EACtC,qBAAgB;OAAhB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,oBAAiB;KAAjB,iBAAiB;EACjB,0BAAuB;KAAvB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;AAChB;AAEA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,MAAM;EACN,OAAO;AACT;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;AACA;EACE,YAAY;EACZ,uCAAuC;EACvC,aAAa;EACb,OAAO;EACP,MAAM;EACN,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,cAAc;EAChB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE;IACE,UAAU;IACV,eAAe;IACf,sBAAsB;EACxB;AACF;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,YAAY;EACd;EACA;IACE,aAAa;IACb,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,oBAAiB;OAAjB,iBAAiB;IACjB,uBAAoB;OAApB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,kGAAkG;AACpG;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;EACjB,uBAAoB;KAApB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AAEA;EACE;IACE,gBAAgB;IAChB,+BAA+B;EACjC;AACF;AACA;EACE;IACE,gBAAgB;IAChB,+BAA+B;EACjC;AACF;AACA;EACE;IACE,gBAAgB;IAChB,QAAQ;IACR,UAAU;IACV,+BAA+B;EACjC;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;AAEA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,gBAAgB;IAChB,SAAS;EACX;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,UAAU;EACZ;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;AACjB;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,aAAa;IACb,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,8BAA8B;EAChC;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,uWAAuW;EACvW,4BAA4B;EAC5B,4BAA4B;EAC5B,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,oDAAoD;EACpD,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,iBAAiB;EACjB,cAAc;AAChB;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,OAAO;EACP,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;AAC/B;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,qBAAqB;EACvB;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,gBAAgB;EAChB,cAAc;AAChB;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,OAAO;EACP,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;AAC/B;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,eAAe;IACf,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,qBAAqB;EACvB;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,WAAW;EACX,oEAAuE;EACvE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,cAAc;AAChB;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;EACV,wCAAwC;AAC1C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,wCAAwC;AAC1C;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,gDAAgD;AAClD;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;AAEA;EACE;IACE,MAAM;IACN,UAAU;IACV,yBAAyB;EAC3B;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,SAAS;IACT,yBAAyB;IACzB,YAAY;EACd;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;EACpB;AACF;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;EACV;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF,4FAA4F;AAC5F;EACE,sBAAsB;AACxB;AACA;EACE;IACE,qBAAqB;IACrB,oBAAoB;EACtB;AACF;AAEA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;EACb;AACF;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;IACrC,gBAAgB;EAClB;AACF;AACA;EACE;IACE,qCAAqC;IACrC,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,0BAA0B;AAC5B;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,8BAA8B;IAC9B,YAAY;EACd;AACF;AACA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,mCAAmC;EACnC,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,qFAAqF;AACvF;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE;IACE,eAAe;IACf,qBAAqB;EACvB;AACF;AACA;EACE,kBAAkB;AACpB;AAEA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,0BAA0B;IAC1B,6BAA6B;IAC7B,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;EACnB,mBAAmB;AACrB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,cAAc;EACd,YAAY;AACd;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;AACf;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,UAAU;IACV,yBAAyB;EAC3B;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,oEAAgF;IAChF,wBAAwB;IACxB,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,WAAW;EACb;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,sFAAsF;EACxF;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,cAAc;EAChB;AACF;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,cAAc;EACd,aAAa;EACb,2CAA2C;AAC7C;AACA;EACE;IACE,iBAAiB;IACjB,qDAAqD;EACvD;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;AACd;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;EAC7B;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qEAAqE;EACrE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AAEA;EACE;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,sBAAsB;EACxB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.address-auto-complete {\n  display: flex;\n  flex-direction: column;\n}\n.address-auto-complete__title {\n  font-weight: 600;\n  font-size: 28px;\n  margin-bottom: 24px;\n  color: #1a1e22;\n}\n.address-auto-complete__input-wrapper {\n  position: relative;\n  margin-bottom: 24px;\n}\n.address-auto-complete__input {\n  display: flex;\n  flex-direction: row;\n  color: #1a1e22;\n  width: 100%;\n  outline: none;\n  border: 2px solid #d8d8d8;\n  border-radius: 50px;\n  padding: 16px 48px;\n  background: url(\"@mortgage-pos/ui/assets/SearchIcon.svg\") no-repeat 16px;\n}\n.address-auto-complete__input:focus {\n  border-color: #3d7c54;\n}\n.address-auto-complete__close-icon {\n  position: absolute;\n  right: 8px;\n  top: 0;\n  bottom: 0;\n  width: 40px;\n  background: url(\"@mortgage-pos/ui/assets/black-x.svg\") no-repeat center;\n  height: 40px;\n  margin: auto 0;\n  cursor: pointer;\n}\n.address-auto-complete__error-text {\n  color: #c53d31;\n  font-style: italic;\n  margin-bottom: 8px;\n}\n.address-auto-complete__footer {\n  font-size: 14px;\n  display: flex;\n  flex-direction: row;\n  color: #5d5d5e;\n  justify-content: space-between;\n}\n.address-auto-complete__google-logo {\n  display: inline;\n  height: 20px;\n  margin-left: 4px;\n}\n.address-auto-complete__cant-find-address-button {\n  text-decoration: underline;\n}\n.address-auto-complete__cant-find-address-button:hover {\n  color: #3d7c54;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.advisor-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.advisor-label {\n  font-size: 12px;\n}\n\n.advisor-input {\n  font-size: 12px;\n  padding: 16px;\n  margin-bottom: 16px;\n  width: 100%;\n  height: 54px;\n  border: 1px solid #c4c4c4;\n  border-radius: 6px;\n}\n.advisor-input::placeholder {\n  color: #5d5d5e;\n}\n\n.advisor-select {\n  font-size: 14px;\n  padding: 16px;\n  margin-bottom: 16px;\n  width: 100%;\n  height: 54px;\n  border: 1px solid #c4c4c4;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.advisor-button {\n  height: 53px;\n  border: 1px solid #c4c4c4;\n  border-radius: 100px;\n  background-color: #3d7c54;\n  color: white;\n  align-self: center;\n  width: 200px;\n}\n\n.disabled-button {\n  background-color: lightgray;\n}\n\n.advisor-image {\n  margin-bottom: 8px;\n  width: 150px;\n}\n\n.advisor-prompt {\n  font-weight: 600;\n}\n\n.advisor-info {\n  padding-bottom: 8px;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n}\n\n.advisor-accept-terms {\n  margin-bottom: 16px;\n}\n\n.advisor-checkbox {\n  margin-left: 4px;\n  margin-right: 8px;\n  height: 30px;\n  width: 100%;\n}\n\n.advisor-checkbox-label {\n  font-size: 12px;\n  display: block;\n  text-align: center;\n}\n\n.advisor-specify {\n  font-style: italic;\n}\n\n.advisor-submit-container {\n  padding-top: 24px;\n  padding-bottom: 24px;\n  display: flex;\n  justify-content: center;\n}\n\n.referrer-last {\n  margin-top: 24px;\n}\n\n.role-button {\n  margin: 0 4px 24px 0;\n  height: 40px;\n  position: relative;\n}\n.role-button label,\n.role-button input {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  cursor: pointer;\n}\n.role-button input[type=radio] {\n  opacity: 0.011;\n  z-index: 100;\n}\n.role-button label {\n  font-size: 12px;\n  padding-top: 16px;\n  height: 54px;\n  text-align: center;\n  border: 1px solid #c4c4c4;\n  border-radius: 6px;\n}\n.role-button label:hover {\n  border: 1px solid #3d7c54;\n}\n\n.role-selected {\n  border: 3px solid #3d7c54 !important;\n  box-shadow: 0px 0px 3px #3d7c54 inset;\n}\n\n.role-checkmark {\n  margin-left: 90%;\n  margin-top: -5%;\n  visibility: hidden;\n}\n\n.role-checkmark-selected {\n  margin-left: 90%;\n  margin-top: -5%;\n  visibility: visible;\n}\n\n.specify {\n  border: 1px solid #3d7c54 !important;\n}\n\n.terms-list {\n  font-size: 12px;\n  padding: 24px 0 24px 32px;\n  list-style-type: disc;\n}\n\n.accordion__button {\n  font-size: 12px;\n  background-color: transparent;\n}\n\n.accordion__button:hover {\n  background-color: transparent;\n}\n\n.accordion {\n  border: 1px solid #c4c4c4;\n  border-radius: 6px;\n}\n\n.hide {\n  display: none;\n}\n\n.advisor-success {\n  font-size: 32px;\n  margin-top: 50%;\n  margin-bottom: 90%;\n  text-align: center;\n}\n\n.advisor-link {\n  font-size: 12px;\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: center;\n  color: #3d7c54;\n  text-decoration: underline;\n  text-decoration-color: #3d7c54;\n}\n\n@media (min-width: 950px) {\n  .advisor-container {\n    margin-top: -75px;\n    width: 50%;\n  }\n  .form-container {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n  }\n  .advisor-row {\n    display: flex;\n  }\n  .advisor-column-left {\n    flex: 40%;\n  }\n  .advisor-column-right {\n    margin-left: 10%;\n    flex: 40%;\n  }\n  .advisor-button:hover {\n    cursor: pointer;\n  }\n  .disabled-button:hover {\n    cursor: not-allowed;\n  }\n  .advisor-accept-terms {\n    display: flex;\n    align-items: center;\n  }\n  .advisor-checkbox {\n    height: 15px !important;\n    width: 15px !important;\n  }\n  .advisor-checkbox:hover {\n    cursor: pointer;\n  }\n  .role-button {\n    float: left;\n  }\n  .role-button label:hover {\n    border: 1px solid #3d7c54;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.binary-button {\n  width: 50%;\n  transition: background-color 0.5s ease;\n  padding: 16px;\n  font-weight: 600;\n  font-size: 14px;\n  border: 1px solid #b2b2b2;\n  color: #3d7c54;\n  text-align: center;\n  text-transform: uppercase;\n}\n.binary-button__title {\n  font-weight: 600;\n  font-size: 28px;\n  margin-top: 24px;\n  padding-right: 64px;\n}\n.binary-button__subtitle {\n  margin-top: 30px;\n  font-weight: 600;\n  font-size: 18px;\n}\n.binary-button__wrapper {\n  display: flex;\n  flex-direction: row;\n  padding: 24px 0 30px;\n  cursor: pointer;\n  overflow: hidden;\n  width: 200px;\n}\n.binary-button:hover {\n  background-color: #f2f2f2;\n}\n.binary-button.\\--active {\n  background-color: #3d7c54;\n  border-color: #3d7c54;\n  color: #fff;\n}\n.binary-button.\\--active:hover {\n  background-color: #1b3826;\n}\n.binary-button.\\--first {\n  border-radius: 32px 0 0 32px;\n  border-right: 0;\n}\n.binary-button.\\--last {\n  border-radius: 0 32px 32px 0;\n  border-left: 0;\n}\n.binary-button__container.\\--page-bottom .binary-button__wrapper {\n  padding: 24px 0 0;\n}\n.binary-button__container.\\--small-titles .binary-button__title {\n  margin-top: 30px;\n  font-weight: 600;\n  font-size: 18px;\n}\n.binary-button__container.\\--small-titles .binary-button__subtitle {\n  margin-top: 6px;\n  font-weight: 400;\n  font-size: 14px;\n}\n.binary-button__container.\\--single-binary .binary-button__title {\n  font-weight: 600;\n  font-size: 28px;\n  color: #1a1e22;\n  line-height: 1.3;\n  margin-bottom: 8px;\n}\n.binary-button__container.\\--single-binary .binary-button__subtitle {\n  margin-bottom: 30px;\n  margin-top: 0;\n  font-weight: 400;\n  font-size: 16px;\n}\n.binary-button__container.\\--update-rates {\n  margin: 8px;\n  width: 183px;\n}\n.binary-button__container.\\--update-rates .binary-button__subtitle {\n  margin-bottom: 8px;\n  margin-top: 0;\n  font-weight: 400;\n  font-size: 12px;\n  text-transform: uppercase;\n  display: block;\n  color: #5d5d5e;\n  line-height: 1.15;\n}\n.binary-button__container.\\--update-rates .binary-button__wrapper {\n  padding: 0;\n  width: 174px;\n  height: 50px;\n}\n.binary-button__container.\\--update-rates .binary-button.\\--first {\n  border-radius: 6px 0 0 6px;\n}\n.binary-button__container.\\--update-rates .binary-button.\\--last {\n  border-radius: 0 6px 6px 0;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.checkbox {\n  display: flex;\n  flex-direction: row;\n  font-size: 14px;\n  flex-wrap: wrap;\n}\n.checkbox__wrapper {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 32px;\n  padding-bottom: 32px;\n}\n.checkbox__wrapper.\\--tight {\n  margin-bottom: 16px;\n  padding: 0;\n}\n.checkbox__wrapper.\\--tight .checkbox {\n  font-size: 12px;\n  line-height: 1.65;\n}\n.checkbox__wrapper.\\--error {\n  padding-bottom: 8px;\n}\n.checkbox__wrapper.\\--error .checkbox__title {\n  color: #c53d31;\n}\n.checkbox__wrapper.\\--error .checkbox__checkbox {\n  border: 1px solid #c53d31;\n}\n.checkbox.\\--checked .checkbox__checkbox {\n  background-color: #3d7c54;\n  border-color: #3d7c54;\n}\n.checkbox.\\--checked .checkbox__check-mark {\n  display: block;\n}\n.checkbox__title {\n  font-weight: 600;\n  font-size: 18px;\n  margin-bottom: 24px;\n}\n.checkbox__checkbox {\n  border: 1px solid #b2b2b2;\n  border-radius: 5px;\n  flex-shrink: 0;\n  height: 28px;\n  margin-right: 24px;\n  margin-top: 3px;\n  width: 28px;\n}\n.checkbox__checkbox:hover {\n  border: 1px solid #3d7c54;\n  cursor: pointer;\n}\n.checkbox__check-mark {\n  display: none;\n  height: 26px;\n  padding: 5px;\n  width: 26px;\n}\n.checkbox__label {\n  margin-bottom: 12px;\n  width: calc(100% - 52px);\n}\n.checkbox__label .text-theme-highlight {\n  color: #3d7c54;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.checkbox-multi {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 32px;\n  padding-bottom: 32px;\n  border-bottom: 1px solid #dddddd;\n}\n.checkbox-multi.\\--no-underline {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n.checkbox-multi.\\--error {\n  padding-bottom: 8px;\n}\n.checkbox-multi.\\--error .checkbox-multi__title {\n  color: #c53d31;\n}\n.checkbox-multi.\\--error .checkbox-multi__checkbox {\n  border: 1px solid #c53d31;\n}\n.checkbox-multi.\\--error .checkbox-multi__textarea {\n  border-color: #c53d31;\n}\n.checkbox-multi.\\--tight {\n  margin-bottom: 16px;\n  padding: 0;\n}\n.checkbox-multi.\\--tight .checkbox-multi__single-option {\n  font-size: 12px;\n  line-height: 1.65;\n}\n.checkbox-multi.\\--nested {\n  border-bottom: none;\n  padding-left: 36px;\n  padding-bottom: 0;\n  margin-bottom: 0;\n}\n.checkbox-multi__content {\n  font-size: 14px;\n  margin-bottom: 24px;\n}\n.checkbox-multi__bottom-content {\n  font-size: 14px;\n  margin-bottom: 24px;\n}\n.checkbox-multi__title {\n  font-weight: 600;\n  font-size: 18px;\n  margin-bottom: 24px;\n}\n.checkbox-multi__single-option {\n  display: flex;\n  flex-direction: row;\n  font-size: 14px;\n  flex-wrap: wrap;\n}\n.checkbox-multi__single-option.\\--checked > .checkbox-multi__checkbox {\n  background-color: #3d7c54;\n  border-color: #3d7c54;\n}\n.checkbox-multi__single-option.\\--checked > .checkbox-multi__checkbox .checkbox-multi__check-mark {\n  display: block;\n}\n.checkbox-multi__checkbox {\n  border: 1px solid #b2b2b2;\n  border-radius: 3px;\n  flex-shrink: 0;\n  height: 20px;\n  margin-right: 16px;\n  width: 20px;\n}\n.checkbox-multi__checkbox:hover {\n  border: 1px solid #3d7c54;\n  cursor: pointer;\n}\n.checkbox-multi__check-mark {\n  display: none;\n  height: 18px;\n  padding: 2px;\n  width: 18px;\n}\n.checkbox-multi__checkbox-label {\n  margin-bottom: 12px;\n  width: calc(100% - 36px);\n}\n.checkbox-multi__textarea {\n  margin-left: 36px;\n  min-height: 55px;\n  width: 100%;\n}\n\n.checkbox-multi--old {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 32px;\n  padding-bottom: 32px;\n  border-bottom: 1px solid #dddddd;\n}\n.checkbox-multi--old.\\--no-underline {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n.checkbox-multi--old.\\--error {\n  padding-bottom: 8px;\n}\n.checkbox-multi--old.\\--error .checkbox-multi__title {\n  color: #c53d31;\n}\n.checkbox-multi--old.\\--error .checkbox-multi__checkbox {\n  border: 1px solid #c53d31;\n}\n.checkbox-multi--old.\\--error .checkbox-multi__textarea {\n  border-color: #c53d31;\n}\n.checkbox-multi--old.\\--tight {\n  margin-bottom: 16px;\n  padding: 0;\n}\n.checkbox-multi--old.\\--tight .checkbox-multi__single-option {\n  font-size: 12px;\n  line-height: 1.65;\n}\n.checkbox-multi--old .checkbox-multi__title {\n  font-weight: 600;\n  font-size: 18px;\n  margin-bottom: 24px;\n}\n.checkbox-multi--old .checkbox-multi__single-option {\n  display: flex;\n  flex-direction: row;\n  font-size: 14px;\n  flex-wrap: wrap;\n}\n.checkbox-multi--old .checkbox-multi__single-option.\\--checked .checkbox-multi__checkbox {\n  background-color: #3d7c54;\n  border-color: #3d7c54;\n}\n.checkbox-multi--old .checkbox-multi__single-option.\\--checked .checkbox-multi__check-mark {\n  display: block;\n}\n.checkbox-multi--old .checkbox-multi__nested-single-option {\n  display: flex;\n  flex-direction: row;\n  font-size: 14px;\n  flex-wrap: wrap;\n  padding-left: 32px;\n}\n.checkbox-multi--old .checkbox-multi__nested-single-option.\\--checked .checkbox-multi__nested-checkbox {\n  background-color: #3d7c54;\n  border-color: #3d7c54;\n}\n.checkbox-multi--old .checkbox-multi__nested-single-option.\\--checked .checkbox-multi__nested-check-mark {\n  display: block;\n}\n.checkbox-multi--old .checkbox-multi__checkbox {\n  border: 1px solid #b2b2b2;\n  border-radius: 3px;\n  flex-shrink: 0;\n  height: 20px;\n  margin-right: 16px;\n  width: 20px;\n}\n.checkbox-multi--old .checkbox-multi__checkbox:hover {\n  border: 1px solid #3d7c54;\n  cursor: pointer;\n}\n.checkbox-multi--old .checkbox-multi__check-mark {\n  display: none;\n  height: 18px;\n  padding: 2px;\n  width: 18px;\n}\n.checkbox-multi--old .checkbox-multi__nested-checkbox {\n  border: 1px solid #b2b2b2;\n  border-radius: 3px;\n  flex-shrink: 0;\n  height: 20px;\n  margin-right: 16px;\n  width: 20px;\n}\n.checkbox-multi--old .checkbox-multi__nested-checkbox:hover {\n  border: 1px solid #3d7c54;\n  cursor: pointer;\n}\n.checkbox-multi--old .checkbox-multi__nested-check-mark {\n  display: none;\n  height: 18px;\n  padding: 2px;\n  width: 18px;\n}\n.checkbox-multi--old .checkbox-multi__checkbox-label {\n  margin-bottom: 12px;\n  width: calc(100% - 36px);\n}\n.checkbox-multi--old .checkbox-multi__textarea {\n  border: 1px solid #b2b2b2;\n  border-radius: 3px;\n  height: 55px;\n  margin-bottom: 24px;\n  margin-left: 36px;\n  min-height: 55px;\n  padding: 15px;\n  width: 100%;\n}\n.checkbox-multi--old .checkbox-multi__textarea.\\--nested {\n  margin-left: 64px;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.compare-page__heading-group {\n  margin-bottom: 32px;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n  max-width: 750px;\n}\n@media (min-width: 950px) {\n  .compare-page__heading-group {\n    padding: 0 24px;\n  }\n}\n.compare-page__title {\n  margin-bottom: 16px;\n  font-weight: 600;\n  font-size: 32px;\n  color: #1a1e22;\n  line-height: 1.4;\n  text-align: center;\n}\n@media (min-width: 950px) {\n  .compare-page__title {\n    font-size: 48px;\n  }\n}\n.compare-page__subtitle {\n  margin-bottom: 8px;\n  font-weight: 600;\n  font-size: 18px;\n  letter-spacing: 1.5px;\n  color: #3d7c54;\n  text-transform: uppercase;\n}\n.compare-page__description {\n  font-size: 14px;\n  letter-spacing: 0.25px;\n  color: #1a1e22;\n}\n@media (min-width: 950px) {\n  .compare-page__description {\n    font-size: 18px;\n  }\n}\n.compare-page__legal-tooltip {\n  margin: -4px 0 0 4px;\n}\n.compare-page__legal-tooltip:hover {\n  cursor: pointer;\n}\n.compare-page__disclaimer-block {\n  font-size: 12px;\n  margin: 24px 4px;\n  max-width: 800px;\n}\n@media (min-width: 950px) {\n  .compare-page__disclaimer-block {\n    margin: 32px 96px;\n  }\n}\n.compare-page__upload-wrapper {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 16px;\n  margin-left: auto;\n  margin-right: auto;\n  align-items: center;\n  max-width: 1000px;\n  width: 100%;\n}\n.compare-page__upload-wrapper.\\--truncated {\n  margin-bottom: 0;\n}\n@media (min-width: 950px) {\n  .compare-page__upload-wrapper {\n    padding: 0 64px;\n  }\n}\n.compare-page__values-subtitle {\n  font-weight: 600;\n  font-size: 32px;\n  letter-spacing: 0.25px;\n  margin-top: 32px;\n  color: #1a1e22;\n  text-align: center;\n}\n@media (min-width: 950px) {\n  .compare-page__values-subtitle {\n    text-align: left;\n  }\n}\n.compare-page__next {\n  display: flex;\n  margin: 24px 0;\n  align-items: center;\n  display: flex;\n}\n.compare-page__next.link {\n  text-decoration: none;\n}\n.compare-page__next.link:hover {\n  text-decoration: underline;\n}\n.compare-page__next-arrow {\n  margin-left: 16px;\n  height: 20px;\n  transform: rotateZ(270deg);\n}\n.compare-page__button-wrapper {\n  margin-top: 16px;\n  min-width: 210px;\n}\n.compare-page__values {\n  display: flex;\n  flex-direction: column;\n  margin: 32px;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1000px;\n  width: 100%;\n}\n@media (min-width: 950px) {\n  .compare-page__values {\n    display: flex;\n    flex-direction: row;\n    padding: 0 96px;\n  }\n}\n.compare-page__value {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 24px;\n  flex-basis: 100%;\n  align-items: flex-start;\n}\n@media (min-width: 950px) {\n  .compare-page__value {\n    margin: 0 24px 24px;\n  }\n}\n.compare-page__value-subtitle {\n  font-weight: 600;\n  font-size: 28px;\n  color: #1a1e22;\n}\n.compare-page__value-img {\n  margin-right: 16px;\n  object-fit: contain;\n  max-width: 55px;\n  height: auto;\n}\n.compare-page__value-text-container {\n  display: flex;\n  flex-direction: column;\n}\n.compare-page__footer-img {\n  margin-bottom: 24px;\n  display: none;\n  overflow: hidden;\n}\n@media (min-width: 950px) {\n  .compare-page__footer-img {\n    display: block;\n    max-width: 100%;\n  }\n}\n.compare-page__footer-img.\\--bankrate {\n  margin-top: 48px;\n}\n.compare-page__disclosure-link {\n  margin-bottom: 16px;\n  text-decoration: underline;\n  color: #3d7c54;\n  align-self: center;\n  cursor: pointer;\n}\n@media (min-width: 950px) {\n  .compare-page__disclosure-link {\n    margin-right: 32px;\n    align-self: flex-end;\n  }\n}\n.compare-page__social {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.compare-page__social-icon {\n  height: 32px;\n}\n\n.compare-security-msg {\n  display: flex;\n  flex-direction: column;\n  padding: 32px;\n  border: 1px solid #dddddd;\n  border-radius: 20px;\n  max-width: 500px;\n}\n.compare-security-msg__wrap {\n  display: flex;\n  margin-bottom: 64px;\n  justify-content: center;\n}\n.compare-security-msg__blurb {\n  font-size: 14px;\n  margin-bottom: 16px;\n  color: #1a1e22;\n}\n.compare-security-msg__shield-icon {\n  width: 16px;\n  margin-right: 8px;\n  display: inline;\n  height: 18px;\n  vertical-align: text-top;\n}\n.compare-security-msg__disclosure {\n  font-size: 11px;\n  line-height: 16px;\n  text-align: left;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.date-picker > label {\n  font-size: 12px;\n  color: #5d5d5e;\n  left: 0;\n  line-height: 1.15;\n  position: relative;\n  text-transform: uppercase;\n  top: -8px;\n  transform: none !important;\n}\n.date-picker > div > input {\n  font-size: 14px;\n  color: #5d5d5e;\n}\n.date-picker > div > input::placeholder {\n  color: #5d5d5e;\n  opacity: 1;\n}\n.date-picker > div > fieldset > legend {\n  max-width: 0px;\n}\n\n.\\--question-label > div > label {\n  font-weight: 600;\n  font-size: 16px;\n  color: #1a1e22;\n  text-transform: initial;\n}\n\n.input.\\--set-date-half-width .date-picker > label {\n  max-width: 170px;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.education-section {\n  font-weight: 400;\n  font-size: 18px;\n  padding: 24px;\n  max-width: 1100px;\n  margin: 0 auto 16px;\n}\n.education-section__call-out-container {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 16px;\n  padding: 8px;\n  border-radius: 8px;\n  border: 1px solid #dddddd;\n}\n@media (min-width: 950px) {\n  .education-section__call-out-container {\n    display: flex;\n    flex-direction: row;\n    padding: 24px;\n  }\n}\n.education-section__title {\n  font-weight: 600;\n  font-size: 28px;\n  letter-spacing: 1px;\n  margin-bottom: 16px;\n}\n.education-section__card {\n  display: flex;\n  flex-direction: column;\n  font-weight: 600;\n  font-size: 22px;\n  margin: 24px;\n}\n.education-section__card-subtitle, .education-section__lockin-subtitle {\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 24px;\n}\n.education-section__card-subhead {\n  font-weight: 600;\n  font-size: 14px;\n}\n.education-section__card-body {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n.education-section__arrow-container {\n  display: flex;\n  flex-direction: row;\n  margin: 16px 16px 16px 0;\n}\n.education-section__arrow-container img {\n  display: inline;\n  height: 38px;\n  margin-bottom: 8px;\n}\n.education-section__arrow:first-child {\n  margin-right: 32px;\n}\n.education-section__divider {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n@media (min-width: 950px) {\n  .education-section__divider {\n    display: flex;\n    flex-direction: column;\n  }\n}\n.education-section__vertical-line {\n  flex: 1;\n  border-bottom: 1px solid #b2b2b2;\n}\n@media (min-width: 950px) {\n  .education-section__vertical-line {\n    border-left: 1px solid #b2b2b2;\n  }\n}\n@media (min-width: 950px) {\n  .education-section__vertical-line.\\--top {\n    margin-bottom: 8px;\n  }\n}\n@media (min-width: 950px) {\n  .education-section__vertical-line.\\--bottom {\n    margin-top: 8px;\n  }\n}\n.education-section__circle {\n  font-weight: 600;\n  font-size: 12px;\n  margin: 0 8px;\n  width: 32px;\n  height: 32px;\n  border-radius: 16px;\n  color: #fff;\n  text-align: center;\n  line-height: 32px;\n  background: #1a1e22;\n}\n.education-section__lockin-container {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 24px;\n  margin-bottom: 24px;\n}\n.education-section__lockin-container:not(:last-child) {\n  border-bottom: 1px solid #dddddd;\n}\n@media (min-width: 950px) {\n  .education-section__lockin-container {\n    display: flex;\n    flex-direction: row;\n  }\n}\n.education-section__image-container {\n  margin-right: 32px;\n  margin-bottom: 16px;\n  width: 80px;\n}\n@media (min-width: 950px) {\n  .education-section__image-container {\n    margin-bottom: 0;\n  }\n}\n.education-section__lockin-image {\n  width: 100%;\n}\n.education-section__lockin-subtitle {\n  margin-bottom: 8px;\n}\n.education-section__lockin-body {\n  font-size: 18px;\n}\n@media (min-width: 950px) {\n  .education-section__lockin-body {\n    max-width: 90%;\n  }\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.footer {\n  font-size: 10px;\n  color: #5d5d5e;\n  text-align: center;\n}\n.footer__equal-housing-icon {\n  display: inline-block;\n  fill: #5d5d5e;\n  margin: -15px;\n  margin-right: -12px;\n  position: relative;\n  width: 50px;\n}\n.footer__link {\n  color: #3d7c54;\n  text-decoration: underline;\n}\n.footer__compliance-container {\n  max-width: 600px;\n}\n.footer a {\n  padding: 4px;\n  color: #3d7c54;\n  cursor: pointer;\n}\n.footer span {\n  color: #3d7c54;\n}\n.footer.\\--welcome {\n  margin-top: 32px;\n  max-width: 415px;\n  width: 80%;\n}\n\n.main-footer__info-block-link {\n  text-decoration: underline;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.hamburger {\n  margin: 0 16px;\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n.hamburger__modal {\n  display: flex;\n  flex-direction: row;\n  color: #1a1e22;\n  height: 100%;\n  justify-content: center;\n  overflow-y: auto;\n  padding: 0;\n  position: relative;\n  width: 100%;\n}\n.hamburger__modal-content {\n  display: flex;\n  flex-direction: column;\n  padding: 0 32px;\n  max-width: 375px;\n  text-align: center;\n  width: 100%;\n}\n.hamburger__sage-logo-wrapper {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 8px;\n  height: 75px;\n  justify-content: center;\n}\n.hamburger__sage-logo {\n  padding: 16px 32px;\n}\n.hamburger__loan-officer-header {\n  font-weight: 600;\n  font-size: 28px;\n  margin-bottom: 24px;\n  text-align: left;\n}\n.hamburger__loan-officer-wrapper {\n  margin-bottom: 32px;\n}\n.hamburger__loan-officer {\n  display: flex;\n  flex-direction: row;\n}\n.hamburger__loan-officer-headshot-wrapper {\n  align-self: flex-start;\n  margin-right: 20px;\n}\n.hamburger__loan-officer-headshot {\n  border-radius: 50%;\n  height: 50px;\n  object-fit: cover;\n  width: 50px;\n}\n.hamburger__loan-officer-info {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 32px;\n  text-align: left;\n}\n.hamburger__loan-officer-name {\n  font-weight: 600;\n  font-size: 22px;\n}\n.hamburger__loan-officer-title {\n  font-weight: 600;\n  font-size: 14px;\n  margin-bottom: 8px;\n  line-height: 14px;\n}\n.hamburger__loan-officer-nmls {\n  font-weight: 400;\n  font-size: 14px;\n}\n.hamburger__loan-officer-contact-buttons {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 32px;\n}\n.hamburger__loan-officer-contact-buttons button {\n  margin-right: 4px;\n  margin-bottom: 0;\n}\n.hamburger__loan-officer-contact-buttons button:last-child {\n  margin-right: 0;\n}\n.hamburger__nav-links {\n  display: flex;\n  flex-direction: column;\n  margin: 24px 0 32px;\n  justify-content: center;\n}\n.hamburger__nav-links li {\n  font-weight: 600;\n  font-size: 28px;\n  margin-bottom: 32px;\n  color: #1a1e22;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n}\n.hamburger__buttons {\n  margin-bottom: 32px;\n}\n.hamburger__buttons button {\n  margin: 0 0 24px;\n  flex-grow: 0;\n  width: 100%;\n}\n.hamburger__footer-links {\n  display: flex;\n  flex-direction: column;\n  padding: 0 32px 64px;\n}\n.hamburger__footer-links li {\n  margin-bottom: 24px;\n}\n.hamburger__close-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 96px;\n  height: 78px;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.income {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 32px;\n  padding-bottom: 32px;\n  border-bottom: 1px solid #dddddd;\n}\n.income.\\--no-underline {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n.income.\\--error {\n  padding-bottom: 8px;\n}\n.income.\\--error .income__title {\n  color: #c53d31;\n}\n.income.\\--error .income__checkbox {\n  border: 1px solid #c53d31;\n}\n.income.\\--error .income__textarea {\n  border-color: #c53d31;\n}\n.income.\\--tight {\n  margin-bottom: 16px;\n  padding: 0;\n}\n.income.\\--tight .checkbox-multi__single-option {\n  font-size: 12px;\n  line-height: 1.65;\n}\n.income__title {\n  font-weight: 600;\n  font-size: 18px;\n  margin-bottom: 24px;\n}\n.income__subtitle {\n  font-size: 12px;\n  letter-spacing: 0.75px;\n  color: #5d5d5e;\n  line-height: 1.15;\n  margin-bottom: 4px;\n}\n.income__single-option {\n  display: flex;\n  flex-direction: row;\n  font-size: 14px;\n  border-top: 1px solid #b2b2b2;\n  flex-wrap: wrap;\n}\n.income__single-option:last-child {\n  border-bottom: 1px solid #b2b2b2;\n}\n.income__single-option.\\--checked .income__checkbox {\n  background-color: #3d7c54;\n  border-color: #3d7c54;\n}\n.income__single-option.\\--checked .income__check-mark {\n  display: block;\n}\n.income__checkbox {\n  border: 1px solid #b2b2b2;\n  border-radius: 3px;\n  flex-shrink: 0;\n  height: 20px;\n  margin-top: 12px;\n  margin-right: 16px;\n  width: 20px;\n}\n.income__checkbox:hover {\n  border: 1px solid #3d7c54;\n  cursor: pointer;\n}\n.income__check-mark {\n  display: none;\n  height: 18px;\n  padding: 2px;\n  width: 18px;\n}\n.income__checkbox-label {\n  margin-top: 12px;\n  margin-bottom: 12px;\n  width: calc(100% - 36px);\n}\n.income__textarea {\n  height: 55px;\n  margin-left: 36px;\n  min-height: 55px;\n  width: 100%;\n  margin-bottom: 12px;\n}\n.income__total {\n  font-weight: 600;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.info-block {\n  display: flex;\n  flex-direction: column;\n  border-radius: 20px;\n  padding: 16px;\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n.info-block__title {\n  margin-bottom: 8px;\n}\n.info-block__content {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.info-block__text {\n  line-height: 20px;\n  margin-top: 2px;\n  margin-left: 8px;\n  font-size: 12px;\n  color: #1a1e22;\n}\n.info-block__error-button {\n  padding: 0 4px 0 8px;\n  display: flex;\n  justify-content: center;\n  height: fit-content;\n}\n.info-block__error-button-icon {\n  width: 20px;\n}\n.info-block__link {\n  font-weight: 600;\n  text-decoration: underline;\n}\n.info-block.--info {\n  background-color: #f1f9f1;\n}\n.info-block.--danger {\n  background-color: #ffeaea;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.input {\n  margin-bottom: 20px;\n}\n.input:focus-within .input__subtitle {\n  color: #3d7c54;\n}\n.input.\\--error .input__subtitle {\n  color: #c53d31;\n}\n.input.\\--error .input__field,\n.input.\\--error .select__anchor {\n  border-color: #c53d31;\n}\n.input.\\--top-spacing {\n  margin-top: 24px;\n}\n.input.\\--attached-to-radio {\n  border-top: 3px solid white;\n  margin-top: -3px;\n  border-bottom: 1px solid #d8d8d8;\n  padding-bottom: 32px;\n}\n.input.\\--narrow {\n  width: 50%;\n}\n.input.\\--update-rates {\n  width: 183px;\n  margin: 8px;\n}\n.input.\\--non-page-header .input__title {\n  font-weight: 600;\n  font-size: 16px;\n}\n.input__title {\n  font-weight: 600;\n  font-size: 28px;\n  color: #1a1e22;\n  line-height: 1.3;\n  margin-bottom: 16px;\n}\n.input__subtitle {\n  margin-bottom: 8px;\n  font-size: 12px;\n  text-transform: uppercase;\n  color: #5d5d5e;\n  line-height: 1.15;\n}\n.input__field {\n  border-radius: 6px;\n  padding: 16px;\n  font-size: 14px;\n  border: 1px solid #c4c4c4;\n  color: #1a1e22;\n  line-height: 1.15;\n  outline: none;\n  width: 100%;\n}\n.input__field::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  color: #5d5d5e;\n  opacity: 1; /* Firefox */\n}\n.input__field:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #5d5d5e;\n}\n.input__field::-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #5d5d5e;\n}\n.input__field:focus {\n  border: 1px solid #3d7c54;\n}\n.input__field.\\--currency {\n  padding: 16px 16px 16px 32px;\n}\n.input__field.\\--ssn {\n  padding: 16px 16px 16px 56px;\n  letter-spacing: 8px;\n  background: url(\"@mortgage-pos/ui/assets/LockIcon.svg\") no-repeat 16px;\n  margin: 0;\n}\n.input__field.\\--ssn.\\--hidden {\n  -webkit-text-security: disc;\n}\n.input__currency-wrapper {\n  position: relative;\n}\n.input__currency-indicator {\n  font-size: 14px;\n  bottom: 30px;\n  color: #1a1e22;\n  left: 15px;\n  position: absolute;\n  top: 15px;\n}\n.input__ssn-input-wrapper, .input__pass-input-wrapper {\n  position: relative;\n  margin: 4px 0 16px;\n}\n.input__ssn-show-button, .input__pass-show-button {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  margin: auto 0;\n  padding: 0 16px;\n  color: #3d7c54;\n}\n.input__ssn-security-blurb {\n  font-size: 14px;\n  color: #1a1e22;\n  margin-bottom: 24px;\n}\n.input__ssn-shield-icon {\n  width: 16px;\n  display: inline;\n  height: 18px;\n  margin-right: 8px;\n  vertical-align: text-top;\n}\n.input.\\--hide-ssn-security-blurb .input__ssn-security-blurb {\n  display: none;\n}\n.input__field-wrapper, .input__currency-wrapper, .input__telephone-wrapper, .input__zipcode-wrapper {\n  position: relative;\n  width: 100%;\n}\n.input__clear-button {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  color: #b2b2b2;\n  padding: 2px;\n}\n@media (max-width: 768px) {\n  .input__clear-button {\n    padding: 4px;\n  }\n}\n@media (min-width: 300px) and (max-width: 600px) {\n  .input__field.\\--ssn {\n    letter-spacing: 2px;\n  }\n}\n@media (min-width: 300px) {\n  .input__ssn-show-button {\n    padding: 0 8px;\n  }\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.link {\n  cursor: pointer;\n  text-decoration: underline;\n  color: #3d7c54;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.content-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 60vh;\n  justify-content: center;\n}\n.content-loading__gif {\n  height: 128px;\n  margin-bottom: 24px;\n  width: 128px;\n}\n.content-loading__text {\n  text-align: center;\n}\n.content-loading__title {\n  font-weight: 700;\n  font-size: 22px;\n  margin-bottom: 16px;\n  line-height: 1;\n}\n\n.loading-val-props {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n.loading-val-props__gif {\n  height: 128px;\n  margin-bottom: 24px;\n  width: 128px;\n}\n.loading-val-props__heading {\n  font-weight: 600;\n  font-size: 32px;\n  margin-bottom: 32px;\n  line-height: 1.3;\n}\n.loading-val-props__text {\n  margin-bottom: 24px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #dddddd;\n}\n.loading-val-props__carousel-wrapper {\n  height: 234px;\n  overflow-x: clip;\n}\n.loading-val-props__carousel {\n  transform-style: preserve-3d;\n}\n.loading-val-props__carousel-prop {\n  bottom: 0;\n  margin: 0 auto;\n  opacity: 0;\n  position: absolute;\n  transition: transform 0.5s, opacity 0.5s, z-index 0.5s;\n  width: 100%;\n  z-index: 4;\n}\n.loading-val-props__carousel-prop.initial, .loading-val-props__carousel-prop.active {\n  opacity: 1;\n  position: relative;\n  z-index: 3;\n}\n.loading-val-props__carousel-prop.prev, .loading-val-props__carousel-prop.next {\n  z-index: 2;\n}\n.loading-val-props__carousel-prop.prev {\n  transform: translateX(100%);\n}\n.loading-val-props__carousel-prop.next {\n  transform: translateX(-100%);\n}\n.loading-val-props__carousel-icon {\n  margin: 10px auto;\n}\n.loading-val-props__carousel-heading {\n  font-size: 18px;\n  display: flex;\n  margin-bottom: 8px;\n  align-items: center;\n  color: #3d7c54;\n  font-weight: 500;\n  justify-content: center;\n}\n.loading-val-props__tooltip {\n  margin-left: 5px;\n}\n.loading-val-props__carousel-copy {\n  font-size: 13px;\n  width: 80%;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.fee-estimate {\n  width: 83.3333333333%;\n  border-radius: 4px;\n  overflow-y: scroll;\n  position: relative;\n  max-height: 75vh;\n  max-width: 620px;\n}\n.fee-estimate__close-button-wrap {\n  padding-right: 16px;\n  padding-top: 16px;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n@media (min-width: 950px) {\n  .fee-estimate__close-button-wrap {\n    padding-right: 32px;\n    padding-top: 32px;\n  }\n}\n.fee-estimate__close-button {\n  height: 24px;\n  width: 24px;\n  cursor: pointer;\n}\n.fee-estimate__close-button-icon {\n  width: 100%;\n  height: 100%;\n}\n.fee-estimate__main-section {\n  padding: 32px;\n}\n.fee-estimate__main-heading {\n  font-weight: 600;\n  font-size: 22px;\n}\n.fee-estimate__tabs {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 24px;\n  overflow-y: scroll;\n  border-bottom: 1px solid #f2f2f2;\n}\n@media (min-width: 950px) {\n  .fee-estimate__tabs {\n    justify-content: space-between;\n  }\n}\n.fee-estimate__tab {\n  padding: 8px;\n  white-space: nowrap;\n}\n.fee-estimate__tab.\\--active {\n  border-bottom: 3px solid #3d7c54;\n  outline: 0;\n}\n.fee-estimate__tooltip {\n  margin-left: 4px;\n}\n.fee-estimate__main-blurb {\n  padding-right: 32px;\n  margin-bottom: 16px;\n}\n.fee-estimate__section:not(:last-child) {\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #dddddd;\n}\n.fee-estimate__section-title {\n  font-weight: 600;\n  font-size: 18px;\n  margin-bottom: 16px;\n}\n.fee-estimate__sub-section {\n  margin-bottom: 8px;\n}\n.fee-estimate__sub-section-title {\n  font-weight: 600;\n  font-size: 18px;\n  margin-bottom: 8px;\n}\n.fee-estimate__sub-section-info .info-block__text {\n  display: block;\n}\n.fee-estimate__cash-info {\n  font-weight: 600;\n  font-size: 14px;\n}\n.fee-estimate__line-item, .fee-estimate__section-total {\n  display: flex;\n  justify-content: space-between;\n}\n.fee-estimate__section-total {\n  font-weight: 600;\n  font-size: 22px;\n  color: #3d7c54;\n}\n.fee-estimate__main-section.\\--summary {\n  background-color: #e3efe6;\n}\n.fee-estimate__disclosure {\n  font-weight: 400;\n  font-size: 12px;\n  margin-bottom: 16px;\n  color: #5d5d5e;\n}\n.fee-estimate__disclosure:last-child {\n  margin-bottom: 0;\n}\n\n.loan-officer-card {\n  margin: 24px 0;\n}\n.loan-officer-card__header {\n  margin: 16px 0;\n  font-weight: 600;\n  font-size: 22px;\n}\n.loan-officer-card__lo-container {\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n  border-radius: 8px;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid #b2b2b2;\n}\n.loan-officer-card__details {\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n  align-self: unset;\n}\n.loan-officer-card__headshot {\n  margin: 8px;\n  align-self: center;\n  border-radius: 50%;\n  height: 68px;\n  width: 68px;\n  object-fit: cover;\n  object-position: 0 0;\n}\n.loan-officer-card__greeting-container {\n  margin: 8px;\n  text-align: center;\n}\n.loan-officer-card__name-heading {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 24px;\n}\n.loan-officer-card__body {\n  font-size: 14px;\n  line-height: 24px;\n}\n.loan-officer-card__contact {\n  display: flex;\n  flex-direction: column;\n  margin-right: 0;\n  justify-content: center;\n  align-items: center;\n}\n.loan-officer-card__contact-mobile-container {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.loan-officer-card__contact-desktop-container {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: left;\n}\n.loan-officer-card__contact-button {\n  font-size: 14px;\n  display: flex;\n  flex-direction: row;\n  margin: 8px;\n  padding: 16px;\n  border-radius: 64px;\n  align-items: center;\n  justify-content: center;\n  width: 200px;\n  height: 55px;\n  border: 1px solid #1a1e22;\n}\n.loan-officer-card__contact-button:hover {\n  color: #5d5d5e;\n}\n.loan-officer-card__contact-info {\n  display: flex;\n  flex-direction: row;\n  justify-content: left;\n  margin: 8px;\n}\n.loan-officer-card__contact-icon {\n  margin-right: 16px;\n  width: 26px;\n  color: #3d7c54;\n}\n.loan-officer-card__schedule-a-call {\n  font-size: 14px;\n  margin: 8px;\n  padding: 16px;\n  border-radius: 64px;\n  text-align: center;\n  width: 200px;\n  height: 55px;\n  border: 1px solid #1a1e22;\n  background-color: #3d7c54;\n  color: #fff;\n  cursor: pointer;\n}\n\n.loan-officer-nav-card {\n  font-size: 14px;\n  color: #fff;\n  position: absolute;\n  margin-bottom: 8px;\n  bottom: 0;\n}\n.loan-officer-nav-card__headshot {\n  border-radius: 50%;\n  height: 40px;\n  margin-bottom: 8px;\n  object-fit: cover;\n  object-position: 0 0;\n  width: 40px;\n}\n.loan-officer-nav-card__name {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 1.15;\n}\n.loan-officer-nav-card__title {\n  color: #b2b2b2;\n}\n.loan-officer-nav-card__nmls {\n  font-size: 12px;\n  border-bottom: 1px solid #b2b2b2;\n  color: #b2b2b2;\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n}\n.loan-officer-nav-card__contact {\n  font-size: 10px;\n  margin-bottom: 10px;\n}\n.loan-officer-nav-card__contact-icon {\n  display: inline-block;\n  margin-right: 8px;\n  position: relative;\n  top: -2px;\n  width: 14px;\n}\n.loan-officer-nav-card__calendly {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.loan-officer-pricing-card {\n  display: flex;\n  flex-direction: column;\n}\n@media (min-width: 950px) {\n  .loan-officer-pricing-card {\n    display: flex;\n    flex-direction: row;\n  }\n}\n.loan-officer-pricing-card.\\--card {\n  display: flex;\n  flex-direction: column;\n  margin: 16px 0;\n  padding: 24px;\n  border-radius: 8px;\n  justify-content: center;\n  align-items: center;\n  background-color: #246464;\n  color: #fff;\n  width: 300px;\n  height: 350px;\n  text-align: center;\n}\n.loan-officer-pricing-card.\\--compare {\n  display: flex;\n  flex-direction: row;\n  margin: 16px 0 32px;\n  padding: 24px;\n  border-radius: 8px;\n  justify-content: center;\n  align-items: center;\n  background-color: #1b3826;\n  color: #fff;\n  width: 300px;\n  height: 80px;\n  text-align: center;\n}\n.loan-officer-pricing-card__headshot {\n  margin-bottom: 16px;\n  border-radius: 50%;\n  height: 64px;\n  width: 64px;\n  object-fit: cover;\n  object-position: 0 0;\n}\n@media (min-width: 950px) {\n  .loan-officer-pricing-card__headshot {\n    margin: 0 24px 8px 0;\n  }\n}\n.loan-officer-pricing-card__headshot.\\--card {\n  margin: 0;\n}\n.loan-officer-pricing-card__headshot.\\--compare {\n  height: 32px;\n  width: 32px;\n}\n.loan-officer-pricing-card__text {\n  flex: 1;\n}\n.loan-officer-pricing-card__text.\\--card {\n  padding: 8px;\n  flex: unset;\n}\n.loan-officer-pricing-card__heading {\n  font-weight: 600;\n  font-size: 22px;\n  margin-bottom: 8px;\n  line-height: 24px;\n}\n.loan-officer-pricing-card__heading.\\--compare {\n  font-weight: 600;\n  font-size: 18px;\n  margin-bottom: 0;\n  line-height: 16px;\n  text-align: left;\n}\n.loan-officer-pricing-card__body {\n  margin-bottom: 16px;\n  font-size: 18px;\n  line-height: 24px;\n}\n.loan-officer-pricing-card__body.\\--compare {\n  font-size: 14px;\n  margin-bottom: 0;\n  line-height: 16px;\n  text-align: left;\n}\n@media (min-width: 950px) {\n  .loan-officer-pricing-card__body {\n    margin-bottom: 0;\n  }\n}\n.loan-officer-pricing-card__cta {\n  max-width: fit-content;\n  text-transform: none;\n}\n.loan-officer-pricing-card__cta.\\--skip {\n  font-weight: 600;\n  font-size: 12px;\n}\n.loan-officer-pricing-card__cta.\\--card {\n  width: 100%;\n  max-width: 100%;\n  color: #fff;\n  flex: unset;\n}\n.loan-officer-pricing-card__cta.\\--card:hover {\n  color: #5d5d5e;\n}\n.loan-officer-pricing-card__cta.\\--compare {\n  margin-left: 8px;\n  color: #fff;\n  text-decoration: underline;\n  flex: unset;\n}\n.loan-officer-pricing-card__cta.\\--compare:hover {\n  color: #f2f2f2;\n}\n@media (min-width: 950px) {\n  .loan-officer-pricing-card__cta.\\--skip {\n    padding: 16px 24px;\n    font-weight: 400;\n    font-size: 18px;\n  }\n  .loan-officer-pricing-card__cta.\\--card {\n    font-weight: 400;\n    font-size: 14px;\n  }\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.multi-button__title {\n  font-weight: 600;\n  font-size: 18px;\n  margin-bottom: 24px;\n}\n.multi-button__outer-wrapper {\n  margin-bottom: 32px;\n}\n.multi-button__outer-wrapper.\\--error .multi-button__title {\n  color: #c53d31;\n}\n.multi-button__outer-wrapper.\\--error .multi-button__option {\n  border-color: #c53d31;\n  color: #c53d31;\n}\n.multi-button__outer-wrapper.\\--two-column-options .multi-button__option {\n  width: 45%;\n}\n.multi-button__wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n.multi-button__option {\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 1.5px;\n  transition: background-color 0.5s ease;\n  border-radius: 32px;\n  padding: 16px;\n  margin-bottom: 8px;\n  border: 1px solid #b2b2b2;\n  cursor: pointer;\n  color: #3d7c54;\n  text-align: center;\n  text-transform: uppercase;\n  width: 100%;\n}\n.multi-button__option.--selected {\n  color: #fff;\n  background-color: #3d7c54;\n}\n.multi-button__input {\n  display: none;\n}\n\n@media (min-width: 400px) {\n  .multi-button__wrapper {\n    margin-right: -4px;\n    margin-left: -4px;\n  }\n  .multi-button__option {\n    margin: 0 4px 8px;\n    width: auto;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.navigation-button__container {\n  display: flex;\n  flex-direction: column-reverse;\n  width: 100%;\n  margin: 64px 0;\n  align-self: center;\n  justify-content: flex-start;\n}\n.navigation-button__container.\\--hidden {\n  display: none;\n}\n\n@media (min-width: 750px) {\n  .navigation-button__container {\n    display: flex;\n    flex-direction: row;\n  }\n  .navigation-button__container button.\\--hidden {\n    display: none;\n  }\n  .navigation-button__container.\\--isStart {\n    width: 67%;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.page.\\--mg-bottom {\n  margin-bottom: 96px;\n}\n.page__heading-group {\n  margin-bottom: 30px;\n}\n.page__title {\n  font-weight: 600;\n  font-size: 28px;\n  color: #1a1e22;\n  line-height: 1.3;\n  margin-bottom: 8px;\n}\n.page__subtitle {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: #1a1e22;\n  margin-bottom: 6px;\n}\n.page__description {\n  font-size: 14px;\n  letter-spacing: 0.25px;\n  color: #1a1e22;\n}\n.page__description.\\--mg-bottom {\n  margin-bottom: 24px;\n}\n.page__horizontal-rule {\n  border: none;\n  height: 2px;\n  background-color: #f2f2f2;\n  margin: 24px 0 16px;\n}\n.page__sum-of-fields {\n  font-weight: 600;\n  font-size: 18px;\n  margin-top: 8px;\n}\n.page__sum-of-fields-title {\n  color: #1a1e22;\n}\n.page__sum-of-fields-amount {\n  color: #3d7c54;\n  margin-left: 4px;\n}\n\n.app-content__wrap.\\--no-heading-underline .page__heading-group {\n  border: none;\n  margin-bottom: 32px;\n  padding-bottom: 0;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.password-requirements {\n  background-color: #e6f5ee;\n  padding: 16px;\n  font-size: 12px;\n}\n.password-requirements__title {\n  margin-bottom: 8px;\n  font-weight: 600;\n  font-size: 12px;\n}\n.password-requirements__list {\n  display: grid;\n  grid-template-rows: repeat(5, 1fr);\n  grid-auto-flow: column;\n  grid-auto-columns: auto;\n  row-gap: 8px;\n  column-gap: 16px;\n}\n.password-requirements .requirement-list-item {\n  display: flex;\n  align-items: center;\n}\n.password-requirements .requirement-list-item__image-container {\n  margin-right: 8px;\n  height: 14px;\n  width: 14px;\n  border-radius: 100%;\n  border-width: 1px;\n  border-style: solid;\n  border-color: #b2b2b2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 150ms ease;\n}\n.password-requirements .requirement-list-item__image {\n  width: 8px;\n  opacity: 0;\n  transition: all 150ms ease;\n}\n.password-requirements .requirement-list-item.--matches .requirement-list-item__image-container {\n  border-width: 1px;\n  border-style: solid;\n  border-color: #61926b;\n  background-color: #61926b;\n}\n.password-requirements .requirement-list-item.--matches .requirement-list-item__image {\n  opacity: 1;\n}\n\n@media (min-width: 750px) {\n  .password-requirements__list {\n    grid-template-rows: repeat(3, 1fr);\n    grid-auto-columns: max-content auto;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.question-group__group-wrapper {\n  margin-top: 24px;\n}\n.question-group__group-wrapper.\\--spacing-bottom {\n  margin-bottom: 32px;\n}\n.question-group__group-wrapper.\\--small-titles .questions-list__title {\n  font-size: 18px;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.questions-list__title {\n  font-weight: 600;\n  font-size: 28px;\n  color: #1a1e22;\n  line-height: 1.3;\n  margin-bottom: 8px;\n}\n.questions-list__subtitle {\n  font-size: 12px;\n  letter-spacing: 0.75px;\n  color: #5d5d5e;\n  line-height: 1.15;\n  margin-bottom: 4px;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.radio {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.radio__wrapper {\n  padding: 20px 0;\n  margin-bottom: -1px;\n}\n.radio__wrapper.\\--last {\n  margin-bottom: 24px;\n}\n.radio__wrapper.\\--error {\n  color: #c53d31;\n}\n.radio__wrapper.\\--error .radio__title {\n  color: #c53d31;\n}\n.radio__wrapper.\\--error .radio__option-button {\n  border-color: #c53d31;\n}\n.radio__wrapper.\\--declaration {\n  margin-bottom: -1px;\n  border-bottom: 1px solid #d8d8d8;\n  border-top: 1px solid #d8d8d8;\n}\n.radio__title-wrapper {\n  padding-right: 24px;\n}\n.radio__title {\n  font-size: 14px;\n  color: #1a1e22;\n}\n.radio__subtitle {\n  padding-top: 6px;\n  font-size: 14px;\n  color: #1a1e22;\n}\n.radio__options-wrapper {\n  display: flex;\n  flex-direction: row;\n}\n.radio__option {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.radio__option-button {\n  border-radius: 50%;\n  border: 1px solid #b2b2b2;\n  cursor: pointer;\n  height: 22px;\n  margin-right: 8px;\n  width: 22px;\n  flex-shrink: 0;\n}\n.radio__option-button.--selected {\n  border: 8px solid #3d7c54;\n}\n.radio__option-text {\n  font-weight: 600;\n  margin-right: 18px;\n}\n.radio__option:last-child .radio__option-text {\n  margin-right: 0;\n}\n.radio__error-text {\n  font-size: 12px;\n  color: #c53d31;\n}\n\n.credit-scores-radio-list .radio {\n  flex-direction: column;\n}\n.credit-scores-radio-list .radio__title-wrapper {\n  margin-bottom: 16px;\n}\n.credit-scores-radio-list .radio__options-wrapper {\n  flex-direction: column;\n}\n.credit-scores-radio-list .radio__option {\n  cursor: pointer;\n  margin-bottom: 16px;\n  font-size: 18px;\n}\n.credit-scores-radio-list .radio__option:last-child {\n  margin-bottom: 0;\n}\n\n.vertical .radio {\n  flex-direction: column;\n}\n.vertical .radio__title-wrapper {\n  margin-bottom: 16px;\n}\n.vertical .radio__title {\n  font-weight: 600;\n  font-size: 18px;\n}\n.vertical .radio__options-wrapper {\n  flex-direction: column;\n}\n.vertical .radio__option {\n  margin-bottom: 16px;\n  padding: 16px;\n  border-radius: 4px;\n  border: 1px solid #dddddd;\n}\n.vertical .radio__option-text {\n  font-weight: 400;\n  font-size: 14px;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.repeatable-group__group-wrapper {\n  margin-bottom: 24px;\n  padding-top: 24px;\n}\n.repeatable-group__group-wrapper.\\--first {\n  border-top: none;\n  margin-bottom: 0;\n  padding-top: 0;\n}\n.repeatable-group__add-button-subtitle {\n  font-weight: 600;\n  font-size: 18px;\n  margin-bottom: 24px;\n  color: #1a1e22;\n  line-height: 1.3;\n}\n.repeatable-group__remove {\n  font-weight: 600;\n  font-size: 14px;\n  align-items: center;\n  color: #3d7c54;\n  display: flex;\n  margin: 16px 0 32px auto;\n}\n@media (min-width: 320px) and (max-width: 767px) {\n  .repeatable-group__remove {\n    margin: 0;\n  }\n}\n.repeatable-group__add {\n  padding: 24px 0;\n}\n.repeatable-group__add-button {\n  font-weight: 600;\n  color: #3d7c54;\n  display: flex;\n  align-items: center;\n}\n.repeatable-group__add-icon {\n  margin-right: 8px;\n  width: 20px;\n}\n.repeatable-group__remove-icon {\n  margin-right: 8px;\n  width: 14px;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.select.\\--horizontal.\\--first-child {\n  margin-top: 24px;\n}\n.select.\\--horizontal .select__subtitle {\n  font-size: 14px;\n  color: #1a1e22;\n  text-transform: none;\n  width: 40%;\n}\n.select.\\--horizontal .select__input-wrapper {\n  margin-left: 16px;\n  width: 60%;\n}\n.select.\\--horizontal .input {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 24px;\n  margin-top: 24px;\n  align-items: center;\n}\n.select__title {\n  font-weight: 600;\n  font-size: 18px;\n  margin-bottom: 24px;\n}\n.select__subtitle {\n  font-size: 12px;\n  color: #5d5d5e;\n  text-transform: uppercase;\n  line-height: 1.15;\n}\n.select__subtitle.\\--active {\n  color: #3d7c54;\n}\n.select__subtitle.\\--error {\n  color: #c53d31;\n}\n.select__anchor {\n  display: flex;\n  border-radius: 6px;\n  font-size: 14px;\n  border: 1px solid #c4c4c4;\n  color: #1a1e22;\n  line-height: 1.15;\n  margin: 4px 0 16px;\n  justify-content: space-between;\n  outline: none;\n  padding: 16px 16px;\n  width: 100%;\n}\n.select__anchor:focus {\n  border: 1px solid #3d7c54;\n}\n.select__anchor.\\--active {\n  border: 1px solid #3d7c54;\n}\n.select__anchor.\\--as-div {\n  min-height: 50px;\n  margin: 0;\n}\n.select__input-wrapper {\n  position: relative;\n}\n.select__toggle-button {\n  position: absolute;\n  bottom: 20px;\n  right: 15px;\n}\n.select__caret.\\--active {\n  transform: rotate(180deg);\n}\n.select__placeholder {\n  color: #5d5d5e;\n}\n.select__popper {\n  border-radius: 6px;\n  font-size: 14px;\n  display: none;\n  border: 1px solid #3d7c54;\n  background-color: #fff;\n  color: #1a1e22;\n  line-height: 1.15;\n  outline: none;\n  overflow-y: auto;\n  width: 100%;\n  z-index: 1300;\n}\n.select__popper.\\--open {\n  display: block;\n}\n.select__popper.\\--error, .select__popper.\\--error-active {\n  border: 1px solid #c53d31;\n}\n.select__option {\n  padding: 16px;\n}\n.select__option:not(:last-child) {\n  border-bottom: 1px solid #3d7c54;\n}\n.select__option:hover {\n  background-color: #9ec9b6;\n}\n.select__option:focus, .select__option.\\--active {\n  outline: none;\n  color: #fff;\n  background-color: #3d7c54;\n}\n.select__option:last-child {\n  border-bottom: none;\n}\n.select__option.\\--none {\n  color: #dddddd;\n  background-color: #fff;\n}\n.select__option.\\--error {\n  font-weight: 600;\n  font-size: 14px;\n  color: #c53d31;\n  background-color: #ffeaea;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.select__option.\\--error:hover {\n  color: #fff;\n  background-color: #c53d31;\n}\n.select__option.\\--error-active {\n  font-weight: 600;\n  font-size: 14px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #fff;\n  background-color: #c53d31;\n}\n.select.\\--start-new-group {\n  border-top: 1px solid #b2b2b2;\n  margin-top: 32px;\n  padding-top: 24px;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.multi-select-button {\n  display: flex;\n  flex-direction: column;\n}\n.multi-select-button__wrapper {\n  margin: 32px 0;\n}\n.multi-select-button__wrapper.\\--last {\n  margin-bottom: 24px;\n}\n.multi-select-button__wrapper.\\--cash-out {\n  margin-top: 8px;\n}\n.multi-select-button__wrapper.\\--error .multi-select-button__option {\n  border-color: #c53d31;\n}\n.multi-select-button__wrapper.\\--half-width .multi-select-button__options-wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: left;\n}\n.multi-select-button__wrapper.\\--half-width .multi-select-button__option-container {\n  margin: 0;\n}\n.multi-select-button__wrapper.\\--half-width .multi-select-button__option {\n  width: fit-content;\n  margin-right: 16px;\n  margin-bottom: 16px;\n}\n@media (min-width: 768px) {\n  .multi-select-button__wrapper.\\--half-width .multi-select-button__option {\n    width: 190px;\n  }\n}\n@media (min-width: 320px) and (max-width: 767px) {\n  .multi-select-button__wrapper.\\--half-width .multi-select-button__options-wrapper {\n    display: flex;\n    flex-direction: column;\n  }\n  .multi-select-button__wrapper.\\--half-width .multi-select-button__option {\n    width: 100%;\n  }\n}\n.multi-select-button__wrapper.\\--center-content .multi-select-button__options-wrapper {\n  justify-content: center;\n}\n.multi-select-button__title {\n  margin-bottom: 16px;\n  font-weight: 600;\n  font-size: 16px;\n  color: #1a1e22;\n}\n.multi-select-button__subtitle {\n  padding-top: 6px;\n  font-size: 14px;\n  color: #1a1e22;\n}\n.multi-select-button__options-wrapper {\n  flex-direction: column;\n}\n.multi-select-button__option-container {\n  margin: 16px 0;\n}\n.multi-select-button__option {\n  display: flex;\n  flex-direction: row;\n  padding: 16px;\n  border-radius: 4px;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #dddddd;\n  height: 60px;\n}\n.multi-select-button__option:last-child {\n  margin-bottom: 0;\n}\n.multi-select-button__option:hover {\n  border: 1px solid #3d7c54;\n  cursor: pointer;\n}\n.multi-select-button__option.--selected {\n  box-shadow: 0px 0px 0px 3px #3d7c54 inset;\n  transition: 0.5s;\n}\n.multi-select-button__option-details {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.multi-select-button__option-text {\n  font-weight: 400;\n  font-size: 14px;\n}\n.multi-select-button__option-text.--selected {\n  color: #3d7c54;\n}\n.multi-select-button__option-text-icon {\n  font-weight: 400;\n  font-size: 14px;\n  margin-left: 18px;\n}\n.multi-select-button__option-text-icon.--selected {\n  color: #3d7c54;\n}\n.multi-select-button__option-text-checkmark {\n  visibility: hidden;\n  margin-left: auto;\n  max-height: 14px;\n}\n.multi-select-button__option-text-checkmark.--selected {\n  visibility: visible;\n}\n.multi-select-button__option:last-child .multi-select-button__option-text {\n  margin-right: 0;\n}\n.multi-select-button__error-text {\n  font-size: 12px;\n  color: #c53d31;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.success-card {\n  display: grid;\n  grid-template-rows: auto auto;\n  grid-template-columns: max-content 1fr;\n  column-gap: 16px;\n  padding: 24px;\n  border-radius: 4px;\n  border: 1px solid #dddddd;\n  margin-bottom: 32px;\n}\n.success-card__headshot {\n  margin-bottom: 8px;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n  object-position: center;\n}\n.success-card__title {\n  margin-bottom: 8px;\n  color: #1a1e22;\n  font-weight: 600;\n  font-size: 14px;\n}\n.success-card__contact-items {\n  grid-column: 1/span 2;\n}\n.success-card__contact {\n  font-size: 12px;\n}\n.success-card__contact:first-of-type {\n  margin-bottom: 4px;\n}\n.success-card__contact-icon {\n  margin-right: 8px;\n  display: inline-block;\n  position: relative;\n  width: 16px;\n}\n.success-card__contact-text {\n  display: inline-block;\n  text-decoration: underline;\n  color: #1a1e22;\n}\n\n@media (min-width: 750px) {\n  .success-card__contact-items {\n    grid-area: 2/2;\n  }\n}\n.success-screen__img {\n  margin-bottom: 16px;\n  width: 100px;\n}\n.success-screen__title {\n  color: #1a1e22;\n}\n.success-screen__subtitle {\n  color: #1a1e22;\n  margin-bottom: 16px;\n}\n.success-screen__content {\n  color: #1a1e22;\n  margin-bottom: 32px;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.modal {\n  text-align: center;\n}\n.modal__provider {\n  position: relative;\n}\n.modal__overlay {\n  z-index: 150;\n  position: fixed;\n  background-color: rgba(26, 30, 34, 0.5);\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n}\n.modal__container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100vw;\n  height: 100vh;\n  overflow: scroll;\n}\n.modal__content {\n  z-index: 1;\n  border-radius: 8px;\n  margin: 0 24px;\n  background-color: #fff;\n}\n.modal__content.\\--loanofficer {\n  align-self: flex-end;\n}\n.modal__content.\\--loanofficer.\\--open {\n  transform: translateY(0);\n  transition: transform 1s;\n}\n.modal__content.\\--loanofficer.\\--closed {\n  transform: translateY(100%);\n  transition: transform 1s;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.value-props {\n  z-index: 150;\n  display: flex;\n  flex-direction: column;\n  padding: 32px;\n  border-radius: 4px;\n  background-color: #fff;\n  position: absolute;\n  top: 100px;\n  width: 100vw;\n}\n.value-props__overlay {\n  z-index: 100;\n  background-color: rgba(26, 30, 34, 0.5);\n  height: 100vh;\n  left: 0;\n  top: 0;\n  position: fixed;\n  width: 100vw;\n}\n.value-props__container {\n  display: flex;\n  flex-direction: column;\n  margin-top: 24px;\n}\n.value-props__close-button {\n  right: 16px;\n  top: 16px;\n  width: 24px;\n  padding: 4px;\n  cursor: pointer;\n  position: absolute;\n  background-color: #e5e5e5;\n  border-radius: 50%;\n}\n.value-props__close-button:hover {\n  background-color: #1a1e22;\n}\n.value-props__heading {\n  margin-bottom: 16px;\n  font-weight: 600;\n  font-size: 28px;\n  color: #1a1e22;\n  line-height: 1.3;\n}\n.value-props__tagline {\n  margin-bottom: 24px;\n}\n.value-props__list {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n.value-props-item {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 24px;\n}\n.value-props-item__icon-wrap {\n  flex-shrink: 0;\n  width: 50px;\n}\n.value-props-item__subhead {\n  margin-bottom: 8px;\n  font-weight: 600;\n  font-size: 18px;\n  color: #1a1e22;\n  line-height: 1.3;\n}\n.value-props-item__blurb {\n  font-size: 14px;\n  color: #5d5d5e;\n}\n.value-props__cta {\n  letter-spacing: 2.5px;\n  border-radius: 4px;\n  display: inline-block;\n  padding: 16px 32px;\n  background-color: #3d7c54;\n  color: #fff;\n  border: none;\n  font-size: 14px;\n  border-radius: 32px;\n  margin-bottom: 24px;\n  padding: 16px 16px;\n  letter-spacing: 1px;\n  align-self: center;\n  width: 280px;\n}\n.value-props__cta:hover {\n  background-color: #356b48;\n}\n\n@media (min-width: 600px) {\n  .value-props {\n    padding: 32px 64px;\n  }\n  .value-props-item {\n    width: 50%;\n    flex-shrink: 0;\n  }\n}\n@media (min-width: 750px) {\n  .value-props {\n    padding: 32px 64px;\n    max-width: 750px;\n    left: calc(50% - 375px);\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.rate-selections__header {\n  font-weight: 600;\n  font-size: 32px;\n  margin: 0 auto 24px;\n  max-width: 1100px;\n}\n.rate-selections__sub-header {\n  font-size: 18px;\n  margin: auto;\n  max-width: 1100px;\n}\n.rate-selections__update-wrapper {\n  display: flex;\n  flex-direction: column;\n  margin: 24px auto;\n  margin-bottom: 0;\n  align-items: center;\n  max-width: 1100px;\n}\n.rate-selections__update-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  overflow-x: scroll;\n  width: 100%;\n}\n.rate-selections__update-container-terms {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n.rate-selections__update-container-terms-buttons {\n  display: flex;\n  flex-direction: row;\n  overflow-x: scroll;\n}\n.rate-selections__terms-definition {\n  display: none;\n}\n.rate-selections__question-mark-icon {\n  margin: 8px;\n  display: inline;\n  align-self: center;\n}\n.rate-selections__refresh-info-wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin: auto;\n}\n.rate-selections__flex-gap {\n  display: flex;\n  gap: 12px;\n}\n.rate-selections__refresh-info-block {\n  display: flex;\n  flex-direction: row;\n  padding: 16px;\n  border-radius: 8px;\n  font-size: 18px;\n  align-items: flex-start;\n  color: #1a1e22;\n  background-color: #f1f9f1;\n}\n.rate-selections__refresh-info-block img {\n  margin: 0 8px 0 16px;\n  width: 16px;\n  cursor: pointer;\n}\n.rate-selections .rate-terms {\n  display: flex;\n  flex-direction: row;\n  text-align: center;\n  overflow: scroll;\n}\n.rate-selections .rate-terms__term {\n  font-size: 12px;\n  margin: 16px 4px;\n  padding: 12px 24px;\n  border-radius: 4px;\n  align-self: center;\n  background-color: #f4f4f4;\n  color: #1a1e22;\n  flex: none;\n  justify-content: center;\n  -webkit-appearance: button;\n  max-width: 130px;\n}\n.rate-selections .rate-terms__term:first-child {\n  margin-left: 0;\n}\n.rate-selections .rate-terms__term.\\--active {\n  background-color: #246464;\n  color: #fff;\n}\n.rate-selections .rate-terms__term.\\--pricing-recommendation {\n  border-radius: 32px;\n}\n.rate-selections__options-list {\n  display: flex;\n  flex-direction: column;\n  margin-top: 32px;\n  align-items: center;\n}\n.rate-selections__options-list.\\--row {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n  margin: 0;\n}\n.rate-selections__options-list.\\--align-center {\n  align-items: center;\n}\n.rate-selections__options-list.\\--wrap-content {\n  flex-wrap: wrap;\n}\n.rate-selections__info {\n  font-size: 12px;\n  margin-top: 32px;\n  color: #5d5d5e;\n}\n.rate-selections__info-block {\n  margin-bottom: 16px;\n}\n.rate-selections__info-block-heading {\n  font-weight: 600;\n}\n.rate-selections.\\--compare {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.rate-selections.\\--compare .rate-selections__header {\n  font-weight: 600;\n  font-size: 28px;\n  color: #3d7c54;\n  text-align: center;\n  max-width: 700px;\n}\n.rate-selections.\\--compare .rate-selections__sub-header {\n  font-weight: 600;\n  font-size: 32px;\n  text-align: center;\n}\n.rate-selections.\\--compare .rate-selections__options-list {\n  display: flex;\n  flex-direction: column-reverse;\n}\n.rate-selections.\\--compare .rate-selections__options-list.\\--bankrate {\n  display: flex;\n  flex-direction: column;\n}\n.rate-selections__robinhood-banner-container {\n  max-width: 700px;\n  margin: 24px auto;\n  padding: 0 16px;\n}\n@media (min-width: 950px) {\n  .rate-selections__robinhood-banner-container {\n    padding: 0;\n    max-width: none;\n    margin: 32px auto 24px;\n  }\n}\n\n@media (min-width: 950px) {\n  .rate-selections__sub-header {\n    margin-bottom: 48px;\n  }\n  .rate-selections.\\--compare .rate-selections__header {\n    font-weight: 600;\n    font-size: 32px;\n    color: #3d7c54;\n  }\n  .rate-selections.\\--compare .rate-selections__sub-header {\n    font-weight: 600;\n    font-size: 48px;\n  }\n  .rate-selections.\\--compare .rate-selections__options-list {\n    display: flex;\n    flex-direction: row;\n  }\n  .rate-selections.\\--compare .rate-selections__options-list.\\--bankrate {\n    display: flex;\n    flex-direction: row;\n  }\n  .rate-selections.\\--ojo-demo {\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 600px;\n  }\n}\n@media (min-width: 1100px) {\n  .rate-selections {\n    align-items: flex-start;\n  }\n  .rate-selections__options-list {\n    width: 100%;\n  }\n}\n@media (min-width: 1300px) {\n  .rate-selections__button-wrapper {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    max-width: 1100px;\n  }\n  .rate-selections__button-container {\n    display: unset;\n    width: unset;\n  }\n  .rate-selections__terms-definition {\n    display: flex;\n    color: #3d7c54;\n    cursor: pointer;\n    align-items: center;\n    margin-right: 17px;\n  }\n  .rate-selections__refresh-info-block {\n    align-items: center;\n  }\n  .rate-selections__update-container-terms {\n    justify-content: space-between;\n  }\n}\n@media (min-width: 1650px) {\n  .rate-selections__options-list {\n    width: 91.6666666667%;\n  }\n}\n@media (min-width: 1900px) {\n  .rate-selections__info {\n    max-width: 1100px;\n    margin: 32px auto 0;\n  }\n}\n.rate-selection-value-props {\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n  width: 100%;\n  max-width: 1100px;\n  margin: 24px auto;\n  align-items: center;\n  border-top: 1px solid #dddddd;\n  border-bottom: 1px solid #dddddd;\n}\n.rate-selection-value-props__title {\n  width: 60%;\n  font-weight: 600;\n  font-size: 28px;\n  text-align: center;\n  padding-bottom: 8px;\n}\n@media (min-width: 950px) {\n  .rate-selection-value-props__title {\n    padding: 64px;\n    font-weight: 600;\n    font-size: 48px;\n  }\n}\n.rate-selection-value-props__props {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  justify-content: space-around;\n}\n@media (min-width: 950px) {\n  .rate-selection-value-props__props {\n    display: flex;\n    flex-direction: row;\n    width: 60%;\n  }\n}\n.rate-selection-value-props__prop-box {\n  display: flex;\n  flex-direction: column;\n  margin: 16px 0;\n  padding: 24px 32px;\n  border-radius: 8px;\n  align-items: center;\n  width: 100%;\n}\n.rate-selection-value-props__prop-box.\\--dark {\n  background-color: #1c4546;\n}\n.rate-selection-value-props__prop-box.\\--light {\n  background-color: #316a69;\n}\n@media (min-width: 950px) {\n  .rate-selection-value-props__prop-box {\n    margin: 16px;\n  }\n}\n.rate-selection-value-props__prop-subtitle {\n  color: #fff;\n  font-weight: 600;\n  font-size: 32px;\n  letter-spacing: 0.75px;\n}\n.rate-selection-value-props__prop-callout {\n  color: #fff;\n  font-size: 14px;\n  letter-spacing: 1px;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.talk-to-expert {\n  font-size: 18px;\n  display: flex;\n  flex-direction: column;\n  margin: 24px 0;\n  padding: 32px 24px;\n  align-items: center;\n  border-bottom: 1px solid #dadada;\n  font-weight: 400;\n  justify-content: center;\n  gap: 8px;\n}\n.talk-to-expert__img {\n  margin-bottom: 8px;\n  max-width: 48px;\n  max-height: 48px;\n}\n.talk-to-expert__copy {\n  margin-bottom: 24px;\n  font-size: 16px;\n  max-width: 430px;\n  text-align: center;\n}\n.talk-to-expert__btn {\n  padding: 12px 24px;\n  border-radius: 96px;\n  border: 1px solid #000;\n  font-size: 13px;\n}\n.talk-to-expert__btn:hover {\n  background-color: #000;\n  color: #fff;\n}\n\n@media (min-width: 950px) {\n  .talk-to-expert {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    max-width: 1100px;\n    margin: auto;\n  }\n  .talk-to-expert__img {\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 0;\n    border-radius: 50%;\n    flex-basis: 6%;\n    justify-content: center;\n    object-fit: cover;\n    object-position: 0 0;\n  }\n  .talk-to-expert__copy {\n    margin-bottom: 0;\n    flex-basis: 77%;\n    font-size: 18px;\n    max-width: unset;\n    text-align: left;\n  }\n  .talk-to-expert__btn {\n    flex-basis: 19%;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.tooltip__button {\n  vertical-align: middle;\n  display: inline-block;\n}\n.tooltip__button.\\--value-props {\n  margin-left: 8px;\n  margin-top: -4px;\n  vertical-align: top;\n}\n.tooltip__body.\\--value-props {\n  padding: 16px;\n}\n.tooltip__body.\\--value-props .tooltip__description {\n  font-weight: 400;\n  font-size: 12px;\n}\n.tooltip__button {\n  vertical-align: middle;\n  display: inline-block;\n}\n.tooltip__icon {\n  vertical-align: middle;\n  display: inline;\n}\n.tooltip__icon.--bankrate {\n  filter: invert(28%) sepia(100%) saturate(6926%) hue-rotate(219deg) brightness(106%) contrast(105%);\n}\n.tooltip__body {\n  z-index: 20;\n  padding: 24px 16px;\n  border-radius: 8px;\n  color: #fff;\n  background: #1a1e22;\n  max-width: 230px;\n}\n.tooltip__close-button-wrapper {\n  padding-right: 16px;\n  line-height: 1;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding-top: 12px;\n}\n.tooltip__close-button {\n  color: #fff;\n  cursor: pointer;\n}\n.tooltip__title {\n  font-weight: 600;\n  font-size: 18px;\n  margin-bottom: 8px;\n}\n.tooltip__description {\n  font-weight: 400;\n  font-size: 14px;\n  white-space: normal;\n}\n\n@media (min-width: 950px) {\n  .tooltip__body {\n    max-width: 350px;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.loan-officer-modal {\n  display: flex;\n  flex-direction: column;\n  padding: 32px;\n  padding-top: 0;\n  justify-content: center;\n  align-items: center;\n  color: #1a1e22;\n  width: 100vw;\n}\n.loan-officer-modal__header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #3d7c54;\n}\n.loan-officer-modal__tagline {\n  margin: 64px;\n  font-weight: 600;\n  font-size: 16px;\n  color: #fff;\n  position: absolute;\n}\n.loan-officer-modal__phone-icon-svg {\n  margin: 16px;\n  padding: 4px;\n  background-color: #fff;\n  display: flex;\n  align-self: flex-end;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1px solid #dddddd;\n}\n.loan-officer-modal__close-button {\n  text-align: right;\n  padding-right: 16px;\n  padding-top: 16px;\n}\n.loan-officer-modal__close-button-icon {\n  right: 16px;\n  top: 16px;\n  width: 24px;\n  padding: 4px;\n  background-color: #e5e5e5;\n  border-radius: 50%;\n}\n.loan-officer-modal__close-button-icon:hover {\n  background-color: #1a1e22;\n}\n.loan-officer-modal__caret-icon {\n  margin-bottom: 6px;\n}\n.loan-officer-modal__introduction {\n  font-weight: 600;\n  font-size: 18px;\n  margin-bottom: 6px;\n  max-width: 260px;\n  text-align: center;\n}\n.loan-officer-modal__title {\n  font-weight: 400;\n  font-size: 14px;\n  margin-bottom: 4px;\n  max-width: 370px;\n  text-align: center;\n  line-height: 1.45;\n}\n.loan-officer-modal__headshot {\n  margin: 16px;\n  border-radius: 50%;\n  height: 48px;\n  object-fit: cover;\n  object-position: 0 0;\n  width: 48px;\n}\n.loan-officer-modal__nmls {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.45;\n}\n.loan-officer-modal__phone, .loan-officer-modal__email {\n  letter-spacing: 2.5px;\n  border-radius: 4px;\n  display: inline-block;\n  padding: 16px 32px;\n  background-color: #fff;\n  color: #1a1e22;\n  border: none;\n  margin-top: 20px;\n  font-size: 14px;\n  letter-spacing: 1px;\n  border: 1px solid #3d7c54;\n  color: #3d7c54;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 200px;\n  border-radius: 32px;\n}\n.loan-officer-modal__phone:hover, .loan-officer-modal__email:hover {\n  background-color: #f2f2f2;\n}\n.loan-officer-modal__phone-icon, .loan-officer-modal__email-icon {\n  margin-right: 12px;\n}\n.loan-officer-modal__schedule-a-call {\n  font-size: 14px;\n  margin: 20px;\n  padding: 16px;\n  border-radius: 64px;\n  text-align: center;\n  width: 200px;\n  height: 55px;\n  border: 1px solid #1a1e22;\n  background-color: #3d7c54;\n  color: #fff;\n  cursor: pointer;\n}\n\n.lo-pricing__container {\n  display: flex;\n  flex-direction: column;\n  margin: 24px;\n  align-items: center;\n}\n.lo-pricing__back-to-rates {\n  margin-bottom: 16px;\n  font-weight: 600;\n  font-size: 18px;\n  letter-spacing: 1.5px;\n  align-self: flex-start;\n  cursor: pointer;\n  text-transform: uppercase;\n}\n.lo-pricing__back-icon {\n  margin-right: 2px;\n  position: relative;\n  top: -2px;\n  display: inline-block;\n  transform: rotate(90deg);\n}\n.lo-pricing__heading {\n  font-weight: 600;\n  font-size: 28px;\n  margin: 8px 0;\n}\n.lo-pricing__cards {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.lo-pricing__cards > * {\n  display: flex;\n  flex-direction: column;\n  margin: 24px 0;\n  padding: 32px;\n  border-radius: 4px;\n  align-items: center;\n  justify-content: space-around;\n  gap: 16px;\n  max-width: 470px;\n  text-align: center;\n  border: 1px solid #dddddd;\n}\n.lo-pricing__headshot {\n  border-radius: 50%;\n  height: 64px;\n  object-fit: cover;\n  width: 64px;\n}\n.lo-pricing__name {\n  font-weight: 600;\n  font-size: 22px;\n}\n.lo-pricing__email {\n  padding-bottom: 16px;\n  border-bottom: 1px solid #dddddd;\n  width: 100%;\n}\n.lo-pricing__email-icon, .lo-pricing__phone-icon {\n  margin-right: 8px;\n  display: inline-block;\n  width: 20px;\n}\n.lo-pricing__steps-heading {\n  font-weight: 600;\n  font-size: 22px;\n}\n.lo-pricing__steps-icon {\n  padding: 8px;\n  border-radius: 50%;\n  font-weight: 600;\n  font-size: 18px;\n  width: 44px;\n  border: 1px solid #9ec9b6;\n  background-color: #c6eadb;\n  color: #3d7c54;\n}\n\n@media (min-width: 1100px) {\n  .lo-pricing__cards {\n    flex-direction: row;\n    align-items: normal;\n  }\n  .lo-pricing__cards > * {\n    margin: 24px;\n  }\n  .lo-pricing__cards-lo {\n    margin-left: 0;\n  }\n}\n.property-value-modal {\n  display: flex;\n  flex-direction: column;\n  padding: 32px;\n  background-color: #fff;\n  position: absolute;\n  top: 50px;\n  margin-left: calc(50vw - 185px);\n  max-height: 80vh;\n  overflow-y: scroll;\n  gap: 2px;\n  max-width: 310px;\n  text-align: center;\n}\n.property-value-modal__heading {\n  font-weight: 600;\n  font-size: 28px;\n}\n.property-value-modal__sub-heading {\n  font-size: 18px;\n}\n.property-value-modal__input-container {\n  display: flex;\n  flex-direction: column;\n  margin: 8px 0;\n}\n.property-value-modal__label {\n  letter-spacing: 0.75px;\n  margin-bottom: 8px;\n  font-size: 12px;\n  display: block;\n  color: #5d5d5e;\n  line-height: 1.15;\n  text-align: left;\n}\n.property-value-modal__error {\n  margin-bottom: 4px;\n  font-size: 12px;\n  color: #c53d31;\n}\n.property-value-modal__lock-button {\n  width: 100%;\n  margin-right: 0;\n}\n.property-value-modal__footer-container {\n  padding: 16px 0;\n  display: flex;\n  flex-direction: column;\n  border-top: 1px solid #dddddd;\n  align-items: center;\n}\n.property-value-modal__footer-description {\n  margin-top: 16px;\n  font-size: 14px;\n}\n\n@media (min-width: 400px) {\n  .property-value-modal {\n    max-width: 350px;\n    margin-left: calc(50vw - 212px);\n  }\n}\n@media (min-width: 600px) {\n  .property-value-modal {\n    max-width: 500px;\n    margin-left: calc(50vw - 275px);\n  }\n}\n@media (min-width: 950px) {\n  .property-value-modal {\n    max-width: 550px;\n    gap: 8px;\n    top: 100px;\n    margin-left: calc(50vw - 550px);\n  }\n  .property-value-modal__input-container {\n    margin: 24px 0;\n  }\n}\n.ssn-modal {\n  display: flex;\n  flex-direction: column;\n  padding: 32px;\n  background-color: #fff;\n  border-radius: 20px;\n  position: absolute;\n  top: 50px;\n  left: 50%;\n  transform: translateX(-50%);\n  max-height: 80vh;\n  overflow-y: auto;\n  gap: 8px;\n  width: 100%;\n  max-width: 310px;\n}\n.ssn-modal__heading {\n  font-weight: 600;\n  font-size: 28px;\n  margin-bottom: 4px;\n  line-height: 38px;\n  text-align: center;\n}\n.ssn-modal__borrower-name {\n  font-size: 22px;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  text-transform: none;\n  color: #1a1e22;\n}\n.ssn-modal__security-blurb {\n  font-size: 14px;\n  margin-bottom: 16px;\n  color: #1a1e22;\n}\n.ssn-modal__shield-icon {\n  width: 16px;\n  margin-right: 8px;\n  display: inline;\n  height: 18px;\n  vertical-align: text-top;\n}\n.ssn-modal__disclosure {\n  margin-bottom: 16px;\n  font-size: 11px;\n  line-height: 16px;\n}\n.ssn-modal__lock-button {\n  margin: 8px 0 16px 0;\n  width: 100%;\n}\n.ssn-modal__back-button {\n  margin: 0 auto !important;\n  width: auto;\n}\n.ssn-modal .checkbox__wrapper.--tight {\n  margin-bottom: 0;\n}\n.ssn-modal .checkbox__wrapper .checkbox__label {\n  font-size: 11px;\n}\n.ssn-modal__success {\n  display: flex;\n  flex-direction: column;\n  padding: 32px;\n  text-align: center;\n  align-items: center;\n  gap: 8px;\n}\n.ssn-modal__success-heading {\n  font-weight: 600;\n  font-size: 28px;\n}\n.ssn-modal__success-text {\n  font-size: 14px;\n  color: #1a1e22;\n}\n.ssn-modal.mini-modal {\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100vw;\n  max-width: 100vw;\n  height: 100vh;\n  max-height: 100vh;\n  transform: none;\n  border-radius: 0px;\n  margin: 0px;\n}\n\n@media (min-width: 300px) {\n  .ssn-modal {\n    left: 42.5%;\n  }\n}\n@media (min-width: 400px) {\n  .ssn-modal {\n    max-width: 350px;\n    left: 45%;\n  }\n}\n@media (min-width: 600px) {\n  .ssn-modal {\n    max-width: 500px;\n  }\n}\n@media (min-width: 950px) {\n  .ssn-modal {\n    padding: 36px 54px;\n    max-width: 520px;\n    gap: 20px;\n    top: 100px;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.ntl-rate-selection__update-wrapper {\n  display: flex;\n  flex-direction: column;\n  margin: 24px auto;\n  margin-bottom: 0;\n  align-items: center;\n  max-width: 1100px;\n}\n.ntl-rate-selection__update-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  overflow-x: scroll;\n  width: 100%;\n}\n.ntl-rate-selection__update-container-terms {\n  display: flex;\n  justify-content: center;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n.ntl-rate-selection__update-container-terms-buttons {\n  display: flex;\n  flex-direction: row;\n  overflow-x: scroll;\n  text-align: center;\n}\n.ntl-rate-selection__terms-definition {\n  display: none;\n}\n.ntl-rate-selection__question-mark-icon {\n  margin: 8px;\n  display: inline;\n  align-self: center;\n}\n.ntl-rate-selection__button {\n  font-weight: 400;\n  font-size: 12px;\n  border-radius: 24px;\n  padding: 8px 24px;\n  margin: 16px 4px;\n  max-width: 130px;\n  background-color: #f4f4f4;\n  color: #1a1e22;\n  flex-shrink: 0;\n}\n.ntl-rate-selection__button:hover {\n  background-color: #246464;\n  color: #fff;\n}\n.ntl-rate-selection__button:focus {\n  outline: 0;\n}\n.ntl-rate-selection__button.\\--selected {\n  background-color: #246464;\n  color: #fff;\n}\n.ntl-rate-selection__refresh-info-wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n.ntl-rate-selection__refresh-info-block {\n  display: flex;\n  flex-direction: row;\n  padding: 16px;\n  border-radius: 8px;\n  font-size: 18px;\n  align-items: flex-start;\n  color: #1a1e22;\n  background-color: #f1f9f1;\n}\n.ntl-rate-selection__refresh-info-block img {\n  margin: 0 8px 0 16px;\n  width: 16px;\n  cursor: pointer;\n}\n\n@media (min-width: 1300px) {\n  .ntl-rate-selection__button-wrapper {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    max-width: 1100px;\n  }\n  .ntl-rate-selection__button-container {\n    display: unset;\n    width: 100%;\n  }\n  .ntl-rate-selection__terms-definition {\n    display: flex;\n    color: #3d7c54;\n    cursor: pointer;\n    align-items: center;\n    margin-right: 17px;\n  }\n  .ntl-rate-selection__refresh-info-block {\n    align-items: center;\n  }\n  .ntl-rate-selection__update-container-terms {\n    justify-content: space-between;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.accordion__container {\n  margin-bottom: 64px;\n  border-top: 1px solid #dddddd;\n}\n.accordion__item {\n  display: flex;\n  flex-direction: column;\n}\n.accordion__title {\n  margin: 16px 0;\n  font-weight: 600;\n  font-size: 22px;\n  display: flex;\n  cursor: pointer;\n  color: #1a1e22;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n.accordion__title:after {\n  content: \"\";\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIgMTMuMjM3Mkw4IDcuMjM3MTVMMiAxLjIzNzE1IiBzdHJva2U9IiM0RTdCNTciIHN0cm9rZS13aWR0aD0iMi4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==\");\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  display: block;\n  width: 30px;\n  height: 30px;\n  margin-left: 12px;\n  transition: margin 700ms;\n  transform: rotate(90deg);\n}\n.accordion__title.\\--open:after {\n  transform: rotate(270deg);\n}\n.accordion__collapse-box {\n  border-bottom: 1px solid #dddddd;\n  overflow: hidden;\n  transition: max-height 0.3s cubic-bezier(1, 0, 1, 0);\n  height: auto;\n  max-height: 9999px;\n}\n.accordion__collapse-box.\\--collapsed {\n  max-height: 0;\n  transition: max-height 0.3s cubic-bezier(0, 1, 0, 1);\n}\n.accordion__content {\n  margin-bottom: 16px;\n  margin-right: 32px;\n  font-size: 14px;\n}\n.accordion__content > p {\n  margin-bottom: 16px;\n}\n.accordion__content > ul {\n  margin: 0 0 32px 32px;\n  list-style: disc;\n}\n.accordion__content > ul > li {\n  margin-bottom: 4px;\n}\n.accordion__content > ul > li::marker {\n  color: #3d7c54;\n}\n.accordion__content > ul > li > ul {\n  margin-left: 32px;\n  margin-top: 4px;\n  list-style: circle;\n}\n.accordion__content > ol {\n  margin: 0 0 32px 32px;\n  list-style: decimal;\n}\n.accordion__content > ol > li {\n  margin-bottom: 4px;\n}\n.accordion__content > ol > li::marker {\n  color: #3d7c54;\n  margin: 0 auto;\n}\n\n@media (min-width: 950px) {\n  .accordion__container {\n    display: flex;\n    flex-direction: column;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.pricing-accordion-container {\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.pricing-label {\n  font-weight: 600;\n  font-size: 28px;\n  padding: 32px 0;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  text-align: center;\n  justify-content: center;\n  color: #1a1e22;\n  line-height: 48px;\n}\n.pricing-label__mobile-container {\n  padding: 0 8px;\n}\n\n.pricing-section {\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: center;\n  flex-wrap: wrap;\n  align-items: center;\n  min-height: 40vh;\n}\n.pricing-section__text-container {\n  display: flex;\n  flex-direction: column;\n  padding-left: 4px;\n  align-items: center;\n  flex: 1;\n  cursor: pointer;\n}\n.pricing-section__screen {\n  max-width: 30%;\n  padding: 2%;\n  max-width: calc(100% - 20px);\n  max-height: calc(100% - 50px);\n}\n\n@media (min-width: 950px) {\n  .pricing-label {\n    display: flex;\n    font-size: 28px;\n    justify-content: flex-start;\n  }\n  .pricing-section__text-container {\n    cursor: unset;\n    align-items: flex-end;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.info-accordion-container {\n  max-width: 460px;\n  margin: 0 auto;\n}\n\n.info-accordion-label {\n  font-weight: 600;\n  font-size: 28px;\n  padding: 32px 0;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  text-align: center;\n  justify-content: center;\n  color: #1a1e22;\n  line-height: 48px;\n}\n\n.info-accordion-section {\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: center;\n  flex-wrap: wrap;\n  align-items: center;\n  min-height: 40vh;\n}\n.info-accordion-section__text-container {\n  display: flex;\n  flex-direction: column;\n  padding-left: 4px;\n  align-items: center;\n  flex: 1;\n  cursor: pointer;\n}\n.info-accordion-section__screen {\n  max-width: 30%;\n  padding: 2%;\n  max-width: calc(100% - 20px);\n  max-height: calc(100% - 50px);\n}\n\n@media (min-width: 950px) {\n  .info-accordion-container {\n    max-width: 1000px;\n  }\n  .info-accordion-label {\n    display: flex;\n    font-size: 28px;\n    justify-content: flex-start;\n  }\n  .info-accordion-section__text-container {\n    cursor: unset;\n    align-items: flex-end;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.complete-application {\n  max-width: 480px;\n}\n.complete-application__img {\n  height: 92px;\n  margin-bottom: 32px;\n}\n.complete-application__heading-group {\n  border: none;\n  color: #1a1e22;\n}\n.complete-application__button-group {\n  display: flex;\n  flex-direction: column;\n}\n.complete-application__button {\n  flex-grow: 3;\n  margin-left: 0;\n  margin-right: 0;\n  padding: 16px 30px;\n  width: 100%;\n}\n.complete-application__button.\\--logout {\n  letter-spacing: 2.5px;\n  border-radius: 4px;\n  display: inline-block;\n  padding: 16px 32px;\n  background-color: transparent;\n  color: #000;\n  border: 2px solid #000;\n  flex-grow: 1;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  border-radius: 32px;\n}\n.complete-application__button.\\--logout:hover {\n  background-color: #000;\n  color: #fff;\n}\n\n@media (min-width: 750px) {\n  .complete-application__button-group {\n    display: flex;\n    flex-direction: row;\n  }\n  .complete-application__button {\n    margin-left: 8px;\n    margin-right: 8px;\n    width: auto;\n  }\n  .complete-application__button:first-of-type {\n    margin-left: 0;\n  }\n  .complete-application__button:last-of-type {\n    margin-right: 0;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.info-modal {\n  display: flex;\n  flex-direction: column;\n  padding: 32px;\n  padding-top: 0;\n  color: #1a1e22;\n  max-height: 80vh;\n  max-width: 350px;\n  overflow-y: scroll;\n}\n.info-modal__close-button {\n  padding-right: 8px;\n  padding-top: 8px;\n  text-align: right;\n  cursor: pointer;\n}\n.info-modal__close-button-icon {\n  right: 16px;\n  top: 16px;\n  width: 24px;\n  padding: 4px;\n  background-color: #e5e5e5;\n  border-radius: 50%;\n}\n.info-modal__close-button-icon:hover {\n  background-color: #1a1e22;\n}\n.info-modal__heading {\n  font-weight: 600;\n  font-size: 22px;\n  margin-bottom: 4px;\n}\n.info-modal__blurb {\n  margin-bottom: 24px;\n}\n.info-modal__details {\n  font-size: 14px;\n  margin-bottom: 8px;\n}\n\n@media (min-width: 750px) {\n  .info-modal {\n    max-width: 450px;\n  }\n}\n@media (min-width: 950px) {\n  .info-modal {\n    max-width: 550px;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.address-fields-auto-complete__title {\n  font-weight: 600;\n  font-size: 28px;\n  margin-bottom: 24px;\n  color: #1a1e22;\n}\n.address-fields-auto-complete__input {\n  position: relative;\n}\n.address-fields-auto-complete__close-icon {\n  position: absolute;\n  right: 8px;\n  bottom: 5px;\n  right: 28px;\n  width: 40px;\n  background: url(\"@mortgage-pos/ui/assets/black-x.svg\") no-repeat center;\n  height: 40px;\n  cursor: pointer;\n}\n.address-fields-auto-complete__address-not-found {\n  margin-bottom: 16px;\n}\n.address-fields-auto-complete__error-text {\n  color: #c53d31;\n  font-style: italic;\n  margin-bottom: 8px;\n}\n.address-fields-auto-complete__footer {\n  font-size: 14px;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 8px;\n  color: #5d5d5e;\n  justify-content: flex-end;\n}\n.address-fields-auto-complete__google-logo {\n  display: inline;\n  height: 20px;\n  margin-left: 4px;\n}\n.address-fields-auto-complete__cant-find-address-button {\n  font-weight: 600;\n  font-size: 14px;\n  text-decoration: underline;\n}\n.address-fields-auto-complete__cant-find-address-button:hover {\n  color: #ffeaea;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.acknowledgement-disclosure {\n  padding: 32px 0 32px 0;\n  margin-bottom: 32px;\n  border-bottom: 1px solid #dadada;\n}\n.acknowledgement-disclosure p {\n  font-size: 12px;\n  line-height: 1.65;\n}\n\n@media (min-width: 1900px) {\n  .acknowledgement-disclosure {\n    max-width: 1100px;\n    margin: 0 auto 32px;\n  }\n}\n.amazon-benefits {\n  margin-bottom: 32px;\n}\n.amazon-benefits__trait-container {\n  margin-bottom: 24px;\n}\n.amazon-benefits__trait-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.amazon-benefits__trait-item {\n  display: flex;\n  gap: 16px;\n}\n.amazon-benefits__cta-container {\n  display: inline-flex;\n}\n.amazon-benefits__trait-icon {\n  height: 24px;\n}\n.amazon-benefits__trait-label {\n  font-size: 14px;\n  line-height: 1.5;\n}\n.amazon-benefits__cta-button {\n  display: inline-flex;\n  text-transform: none;\n  width: unset;\n  font-size: 14px;\n  padding: 16px;\n}\n.amazon-benefits__skip-button {\n  display: inline-flex;\n  text-transform: none;\n  width: unset;\n  font-size: 14px;\n  padding: 16px;\n  margin-left: 0px;\n}\n.amazon-benefits__disclaimer {\n  font-size: 12px;\n  line-height: 1.5;\n}\n.amazon-benefits__horizontal-divider {\n  border-bottom: 1px solid #dddddd;\n  margin: 32px 0;\n}\n\n.amazon-to-sage-loader {\n  margin-top: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.amazon-to-sage-loader__container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 16px;\n  position: relative;\n}\n.amazon-to-sage-loader__logo {\n  width: 128px;\n  height: auto;\n  opacity: 0.7;\n  transition: opacity 0.3s ease;\n  position: relative;\n  z-index: 2;\n}\n.is-animating .amazon-to-sage-loader__logo--amazon {\n  opacity: 1;\n  animation: pulse 1s ease-in-out infinite;\n}\n.amazon-to-sage-loader__logo--sage {\n  margin-top: auto;\n}\n.is-animating .amazon-to-sage-loader__logo--sage {\n  opacity: 1;\n  animation: pulse 1s ease-in-out infinite;\n}\n.amazon-to-sage-loader__transfer-dots {\n  width: 4px;\n  height: 48px;\n  position: relative;\n  margin: 0 auto;\n}\n.is-animating .amazon-to-sage-loader__transfer-dots::after {\n  content: \"\";\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  animation: transferDot 1.5s ease-in-out infinite;\n}\n.is-animating .amazon-to-sage-loader__transfer-dots.\\--first::after {\n  opacity: 0;\n}\n.is-animating .amazon-to-sage-loader__transfer-dots.\\--second::after {\n  animation-delay: 0.3s;\n  opacity: 0;\n}\n.is-animating .amazon-to-sage-loader__transfer-dots.\\--third::after {\n  animation-delay: 0.5s;\n  opacity: 0;\n}\n.is-animating .amazon-to-sage-loader__transfer-dots.\\--fourth::after {\n  animation-delay: 0.8s;\n  opacity: 0;\n}\n.is-animating .amazon-to-sage-loader__transfer-dots.\\--fifth::after {\n  animation-delay: 0.1s;\n  opacity: 0;\n}\n\n@keyframes transferDot {\n  0% {\n    top: 0;\n    opacity: 0;\n    background-color: #1270a1;\n  }\n  20% {\n    opacity: 1;\n  }\n  80% {\n    opacity: 0.8;\n  }\n  100% {\n    top: 100%;\n    background-color: #3d7c54;\n    opacity: 0.1;\n  }\n}\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.amazon-demo-header {\n  padding: 24px;\n  margin-bottom: 32px;\n  background-color: #f0f9f1;\n  border-radius: 24px;\n}\n.amazon-demo-header__content {\n  max-width: 800px;\n  margin: 0 auto;\n  text-align: center;\n}\n.amazon-demo-header__logos {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n.amazon-demo-header__sage-logo {\n  height: 60px;\n}\n.amazon-demo-header__amazon-logo {\n  margin-top: 4px;\n  height: 48px;\n}\n.amazon-demo-header__plus {\n  font-size: 28px;\n  color: #518965;\n}\n.amazon-demo-header__description {\n  font-size: 12px;\n  margin-top: 24px;\n  color: #5d5d5e;\n  line-height: 1.6;\n  text-align: justify;\n}\n.amazon-demo-header__separator {\n  display: none;\n}\n@media (min-width: 1100px) {\n  .amazon-demo-header__separator {\n    border-right: 2px solid #5d5d5e;\n    height: 24px;\n    margin: 0 8px;\n    display: inline-block;\n    vertical-align: middle;\n    border-radius: 8px;\n  }\n}\n.amazon-demo-header__savings {\n  font-size: 14px;\n  margin: 0;\n}\n.amazon-demo-header__savings-amount {\n  font-weight: 700;\n  font-size: 22px;\n  display: inline;\n  color: #1270a1;\n}\n.amazon-demo-header--no-card {\n  background-color: transparent;\n  padding: 0;\n  margin: 0;\n  border-radius: 0;\n}\n.amazon-demo-header--compact .amazon-demo-header__content {\n  flex-direction: column;\n  gap: 24px;\n  margin-bottom: 32px;\n}\n@media (min-width: 1100px) {\n  .amazon-demo-header--compact .amazon-demo-header__content {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    text-align: left;\n    gap: 8px;\n  }\n}\n.amazon-demo-header--compact .amazon-demo-header__logos {\n  margin-bottom: 0;\n}\n.amazon-demo-header--compact .amazon-demo-header__logos--compact {\n  margin-bottom: 8px;\n}\n.amazon-demo-header--compact .amazon-demo-header__savings {\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n/* Replace the specific ID selector with an attribute selector that matches all iframe IDs */\n[id^=plaid-link-iframe-] {\n  left: 130px !important;\n}\n@media (max-width: 767px) {\n  [id^=plaid-link-iframe-] {\n    top: -80px !important;\n    left: 0px !important;\n  }\n}\n\n.plaid-assets {\n  min-height: 500px;\n}\n@media (min-width: 768px) {\n  .plaid-assets {\n    min-width: unset;\n  }\n}\n.plaid-assets__divider {\n  height: 1px;\n  background-color: #3d7c54;\n  margin: 48px 0 32px 0;\n}\n.plaid-assets__header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n.plaid-assets__logo {\n  justify-items: center;\n  margin-bottom: 36px;\n}\n.plaid-assets__title {\n  font-size: 14px;\n  color: #246464;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.15em;\n}\n.plaid-assets__center {\n  text-align: center;\n  align-self: center;\n}\n.plaid-assets__subtitle {\n  font-size: 16px;\n  font-weight: 600;\n}\n.plaid-assets__bullet-item {\n  font-size: 16px;\n  font-weight: 500;\n  list-style-type: disc;\n  margin-left: 16px;\n  margin-bottom: 16px;\n}\n.plaid-assets__heading {\n  font-size: 26px;\n  font-weight: 600;\n}\n.plaid-assets__description {\n  font-size: 16px;\n  font-weight: 200;\n}\n.plaid-assets__benefits {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 32px;\n}\n.plaid-assets__benefit {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.plaid-assets__benefit img {\n  height: 24px;\n  width: 24px;\n}\n.plaid-assets__cta-start-plaid, .plaid-assets__cta-button {\n  width: 100%;\n  text-transform: none;\n}\n.plaid-assets__cta-start-plaid:hover, .plaid-assets__cta-button:hover {\n  cursor: pointer;\n}\n.plaid-assets__cta-start-plaid:disabled, .plaid-assets__cta-button:disabled {\n  cursor: not-allowed;\n}\n.plaid-assets__cta-link {\n  color: #3d7c54;\n}\n.plaid-assets__cta-link:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.plaid-assets__cta-link:focus {\n  outline-color: transparent;\n  text-decoration: underline;\n}\n.plaid-assets__cta-link:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n  text-decoration: none;\n}\n.plaid-assets__disclaimer {\n  font-size: 12px;\n  font-weight: 200;\n}\n.plaid-assets__page-continue-hidden .button.--continue {\n  display: none;\n}\n.plaid-assets__mt-16 {\n  margin-top: 16px;\n}\n.plaid-assets__mt-24 {\n  margin-top: 24px;\n}\n.plaid-assets__mb-16 {\n  margin-bottom: 16px;\n}\n.plaid-assets__mb-24 {\n  margin-bottom: 24px;\n}\n.plaid-assets__primary-color {\n  color: #3d7c54;\n}\n.plaid-assets__accounts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 32px;\n}\n.plaid-assets__account {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.plaid-assets__success-finish {\n  min-width: 260px;\n  text-transform: none;\n}\n.plaid-assets__success-finish:hover {\n  cursor: pointer;\n}\n.plaid-assets__success-finish:disabled {\n  cursor: not-allowed;\n}\n.plaid-assets__flex-column {\n  display: flex;\n  flex-direction: column;\n}\n.plaid-assets__loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n.plaid-assets__loading-spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-left-color: #3d7c54;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  animation: spin 1s linear infinite;\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.plaid-assets__hidden {\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s, opacity 0.5s linear;\n}\n.plaid-assets__failure-cta-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 16px;\n  align-items: baseline;\n}\n@media (min-width: 768px) {\n  .plaid-assets__failure-cta-container {\n    flex-direction: row;\n  }\n}\n.plaid-assets__retry-btn {\n  min-width: 180px;\n  text-align: center;\n}\n@media (max-width: 768px) {\n  .plaid-assets__retry-btn {\n    width: 100%;\n  }\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.rate-card-container {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: center;\n  align-content: space-evenly;\n  align-items: center;\n  margin: 16px auto;\n  margin-top: 6px;\n}\n@media (min-width: 750px) {\n  .rate-card-container {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (min-width: 950px) {\n  .rate-card-container {\n    grid-template-columns: repeat(2, 1fr);\n    max-width: 800px;\n  }\n}\n@media (min-width: 1300px) {\n  .rate-card-container {\n    grid-template-columns: repeat(3, 1fr);\n    max-width: 1100px;\n  }\n}\n@media (min-width: 1900px) {\n  .rate-card-container {\n    max-width: 1200px;\n  }\n}\n.rate-card-container__show-more-container {\n  display: flex;\n  flex-direction: row;\n  margin: 8px 0 24px;\n  justify-content: center;\n  width: 100%;\n}\n.rate-card-container__show-more-btn {\n  margin: 0 auto;\n  background-color: transparent;\n  flex: unset;\n  text-transform: none;\n  outline: none;\n  color: #3d7c54;\n  border: 1px solid #3d7c54;\n}\n.rate-card-container__show-more-btn:hover {\n  color: #fff;\n}\n\n.rate-card-masonry {\n  font-weight: 400;\n  font-size: 18px;\n  margin: 16px 16px;\n  padding: 24px;\n  border-radius: 8px;\n  width: 300px;\n  border: 1px solid #dddddd;\n}\n.rate-card-masonry.\\--simple {\n  height: 350px;\n}\n.rate-card-masonry.\\--robinhood {\n  height: auto;\n}\n.rate-card-masonry__description {\n  color: #1a1e22;\n  font-weight: 400;\n  font-size: 12px;\n  margin-bottom: 16px;\n}\n.rate-card-masonry__description__header {\n  color: #246464;\n  text-transform: uppercase;\n}\n.rate-card-masonry__superlatives-container {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 16px;\n}\n.rate-card-masonry__superlatives-text {\n  font-weight: 600;\n  font-size: 14px;\n  text-transform: uppercase;\n  margin: auto 8px;\n}\n.rate-card-masonry__monthly-amount {\n  font-weight: 600;\n  font-size: 48px;\n  line-height: 1;\n}\n.rate-card-masonry__points-tooltip {\n  margin: auto 2px;\n}\n.rate-card-masonry__details-container {\n  margin: 16px 0;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #dddddd;\n}\n.rate-card-masonry__details {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.rate-card-masonry__rh-details {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  font-size: 16px;\n  padding: 10px 0 10px 0;\n}\n.rate-card-masonry__details-tooltip {\n  margin: 0 auto 0 4px;\n}\n.rate-card-masonry__details-value {\n  font-weight: 600;\n  font-size: 18px;\n}\n.rate-card-masonry__gold-rate {\n  font-weight: 600;\n  font-size: 18px;\n  color: #9d800a;\n}\n.rate-card-masonry__why-match-heading {\n  font-weight: 600;\n  font-size: 14px;\n  text-transform: uppercase;\n  color: #246464;\n}\n.rate-card-masonry__why-match-description {\n  margin-bottom: 16px;\n  font-weight: 400;\n  font-size: 14px;\n}\n.rate-card-masonry__why-match-description > span {\n  color: #246464;\n}\n.rate-card-masonry__lock-button {\n  background-color: #3d7c54;\n  width: 100%;\n  text-transform: unset;\n}\n.rate-card-masonry__fee-breakdown {\n  color: #3d7c54;\n  text-decoration: underline;\n  cursor: pointer;\n  text-align: center;\n  font-size: 14px;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.rate-card-compare {\n  font-weight: 400;\n  font-size: 18px;\n  margin: 16px;\n  padding: 24px;\n  border-radius: 8px;\n  width: 330px;\n  border: 1px solid #dddddd;\n}\n.rate-card-compare__logo-container {\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #dddddd;\n}\n.rate-card-compare__superlatives-container {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 16px;\n}\n.rate-card-compare__superlatives-text {\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  margin: auto 8px;\n}\n.rate-card-compare__superlatives-text .tooltip__body {\n  font-weight: 400;\n  font-size: 14px;\n  letter-spacing: normal;\n  text-transform: none;\n}\n.rate-card-compare__superlatives-icon {\n  height: 21px;\n}\n.rate-card-compare__monthly-amount {\n  font-weight: 600;\n  font-size: 48px;\n  line-height: 1;\n}\n.rate-card-compare__details-container {\n  margin: 16px 0;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #dddddd;\n}\n.rate-card-compare__rate-container, .rate-card-compare__apr-container, .rate-card-compare__points-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.rate-card-compare__details-tooltip {\n  margin: 0 auto 0 4px;\n}\n.rate-card-compare__details-value {\n  font-weight: 600;\n  font-size: 18px;\n}\n.rate-card-compare__why-match-heading {\n  font-weight: 600;\n  font-size: 18px;\n  text-transform: uppercase;\n  color: #3d7c54;\n}\n.rate-card-compare__why-match-description {\n  margin-bottom: 16px;\n  font-weight: 400;\n  font-size: 18px;\n}\n.rate-card-compare__why-match-description > span {\n  color: #246464;\n}\n.rate-card-compare__lock-button {\n  margin-bottom: 0;\n  background-color: #3d7c54;\n  width: 100%;\n  text-transform: unset;\n}\n.rate-card-compare__fee-breakdown {\n  color: #3d7c54;\n  text-decoration: underline;\n  cursor: pointer;\n  text-align: center;\n}\n.rate-card-compare.\\--other-lender {\n  color: #5d5d5e;\n}\n.rate-card-compare.\\--other-lender .rate-card-compare__details-container {\n  padding-bottom: 0;\n  border: none;\n}\n\n.br-compare.\\--other-lender {\n  background-color: #f3f4f8;\n}\n.br-compare__lock-button {\n  border-radius: 5px;\n}\n.br-compare__logo-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  min-height: 80px;\n}\n.br-compare__lender-logo {\n  width: 100px;\n}\n.br-compare__brand-border {\n  border-color: #3d7c54;\n  border-width: 2px;\n}\n.br-compare__nmls {\n  margin-top: 4px;\n  margin-left: 4px;\n  font-size: 12px;\n  letter-spacing: 1.1px;\n  color: #5d5d5e;\n}\n.br-compare__value-props-container {\n  margin: 16px 0;\n}\n.br-compare__value-props-heading {\n  font-weight: 600;\n  font-size: 18px;\n  color: #3d7c54;\n}\n.br-compare__value-props-list {\n  margin-left: 16px;\n  font-size: 14px;\n  list-style: initial;\n}\n.br-compare__value-props-item {\n  margin: 5px 0;\n}\n\n@media (min-width: 950px) {\n  .br-compare.\\--other-lender {\n    margin-top: 112px;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.file-upload {\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n  border-radius: 32px;\n  position: relative;\n  border: 1px dashed #1a1e22;\n  align-items: center;\n  align-content: center;\n  width: 100%;\n}\n@media (min-width: 950px) {\n  .file-upload {\n    padding: 32px 64px;\n  }\n}\n.file-upload.success {\n  border-color: #3d7c54;\n  background-color: #9ec9b6;\n}\n.file-upload.failure {\n  border-color: #c53d31;\n  background-color: #ffeaea;\n}\n.file-upload__body {\n  margin-top: 8px;\n  margin-bottom: 24px;\n  font-size: 18px;\n  letter-spacing: 0.25px;\n  color: #1a1e22;\n  text-align: center;\n}\n.file-upload__image {\n  width: 72px;\n}\n.file-upload__button {\n  letter-spacing: 2.5px;\n  border-radius: 4px;\n  display: inline-block;\n  padding: 16px 32px;\n  background-color: transparent;\n  color: #3d7c54;\n  border: 2px solid #3d7c54;\n  font-weight: 600;\n  font-size: 14px;\n  border-radius: 32px;\n  text-transform: uppercase;\n}\n.file-upload__button:hover {\n  background-color: #3d7c54;\n  color: #fff;\n}\n.file-upload__button.--margin-top {\n  margin-top: 32px;\n}\n.file-upload__fake-link {\n  cursor: pointer;\n  color: #3d7c54;\n  text-decoration: underline;\n}\n.file-upload input[type=file] {\n  height: 100%;\n  width: 100%;\n  visibility: hidden;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.loan-officer-popup__container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.loan-officer-popup__headshot {\n  margin-right: 16px;\n  border-radius: 50%;\n  height: 64px;\n  object-fit: cover;\n  width: 64px;\n}\n.loan-officer-popup__text-container {\n  font-weight: 400;\n  font-size: 14px;\n  color: #fff;\n}\n.loan-officer-popup__name {\n  font-weight: 600;\n  font-size: 18px;\n}\n.loan-officer-popup__phone {\n  font-weight: 600;\n  font-size: 14px;\n}\n.loan-officer-popup__hyperlink {\n  font-weight: 600;\n  font-size: 14px;\n  color: #fff;\n  text-decoration: underline;\n}\n\n.Toastify__toast {\n  background-color: #246464 !important;\n}\n.Toastify__toast-container--bottom-right {\n  right: 10em !important;\n}\n@media (min-width: 480px) {\n  .Toastify__toast {\n    border-radius: 10px !important;\n    width: 430px;\n  }\n}\n.Toastify__close-button--light {\n  color: #fff !important;\n  border: 1px solid #fff !important;\n  border-radius: 50%;\n  padding: 5px 5px 6px 6px !important;\n  opacity: 1 !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 25px;\n  height: 25px;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.br-file-upload__container.\\--desktop {\n  display: none;\n}\n.br-file-upload__container {\n  display: flex;\n  flex-direction: column;\n  margin: 32px 0;\n  align-items: center;\n}\n.br-file-upload__file-drop-container {\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n}\n.br-file-upload__cta {\n  display: flex;\n  flex-direction: column;\n  padding: 32px;\n  border-radius: 8px;\n  padding-left: 40px;\n  padding-right: 40px;\n  background-color: #eaf2fd;\n  align-items: center;\n  justify-content: center;\n  max-width: 460px;\n  box-shadow: 0px 0px 1px rgba(21, 21, 21, 0.1), 0px 2px 8px -1px rgba(21, 21, 21, 0.2);\n}\n.br-file-upload__cta.success {\n  border-color: #3d7c54;\n  background-color: #9ec9b6;\n}\n.br-file-upload__cta.failure {\n  border-color: #c53d31;\n  background-color: #ffeaea;\n}\n.br-file-upload__cta input[type=file] {\n  visibility: hidden;\n  height: 10px;\n}\n.br-file-upload__cta-title {\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 2.5px;\n  text-transform: uppercase;\n  color: #3d7c54;\n}\n.br-file-upload__cta-body {\n  margin-top: 8px;\n  margin-bottom: 16px;\n  font-weight: 600;\n  font-size: 18px;\n  letter-spacing: 0.25px;\n  font-size: 20px;\n  color: #1a1e22;\n  text-align: center;\n}\n.br-file-upload__cta-subtitle {\n  font-size: 14px;\n  margin-bottom: 24px;\n  text-align: center;\n}\n.br-file-upload__cta-button {\n  letter-spacing: 2.5px;\n  border-radius: 4px;\n  display: inline-block;\n  padding: 16px 32px;\n  background-color: #3d7c54;\n  color: #fff;\n  border: none;\n  font-weight: 600;\n  font-size: 18px;\n  padding: 16px 32px;\n  margin: 0 0 8px;\n  width: 100%;\n}\n.br-file-upload__cta-button:hover {\n  background-color: #356b48;\n}\n.br-file-upload__cta-next {\n  display: flex;\n  align-items: center;\n}\n.br-file-upload__cta-next-arrow {\n  margin-left: 8px;\n}\n.br-file-upload__file-types {\n  margin-bottom: 8px;\n  font-size: 12px;\n}\n.br-file-upload__or-separator {\n  margin-bottom: 8px;\n}\n@media (min-width: 950px) {\n  .br-file-upload__or-separator {\n    margin: 0 8px;\n  }\n}\n.br-file-upload__cta-button-inverted {\n  padding: 16px 32px;\n  letter-spacing: 2.5px;\n  border-radius: 4px;\n  display: inline-block;\n  padding: 16px 32px;\n  background-color: #fff;\n  color: #1a1e22;\n  border: none;\n  font-weight: 600;\n  font-size: 18px;\n  width: 100%;\n  border: 2px solid #3d7c54;\n  border-radius: 4px;\n  color: #3d7c54;\n}\n.br-file-upload__cta-button-inverted:hover {\n  background-color: #f2f2f2;\n}\n\n.br-compare-page__upload-wrapper {\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 900px;\n}\n.br-compare-page__heading-group {\n  margin-bottom: 32px;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n  max-width: 920px;\n}\n.br-compare-page__title {\n  margin-bottom: 16px;\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 1.3;\n  color: #1a1e22;\n}\n@media (min-width: 950px) {\n  .br-compare-page__title {\n    font-size: 42px;\n    letter-spacing: 1.3px;\n  }\n}\n.br-compare-page__button {\n  border-radius: 5px;\n}\n\n@media (min-width: 750px) {\n  .br-compare-page__heading-group {\n    padding: 0 32px;\n  }\n}\n@media (min-width: 950px) {\n  .br-compare-page__heading-group {\n    padding: 0 24px;\n  }\n  .br-file-upload__container.\\--mobile {\n    display: none;\n  }\n  .br-file-upload__container.\\--desktop {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n  .br-file-upload__container.\\--desktop .br-file-upload__cta {\n    min-height: 225px;\n    min-width: 415px;\n    justify-content: flex-start;\n    border: 1px dashed #868a9a;\n    background-color: transparent;\n    box-shadow: none;\n  }\n  .br-file-upload__container.\\--desktop .br-file-upload__cta.\\--manual-address {\n    border-style: solid;\n    border-radius: 10px;\n  }\n  .br-file-upload__container.\\--desktop .br-file-upload__cta-image {\n    max-height: 32px;\n  }\n  .br-file-upload__container.\\--desktop .br-file-upload__cta-button {\n    font-weight: 600;\n    font-size: 14px;\n  }\n  .br-file-upload__container.\\--desktop .br-file-upload__file-types {\n    margin-bottom: 0;\n  }\n}\n@media (min-width: 1100px) {\n  .br-file-upload__container.\\--desktop .br-file-upload__cta {\n    padding: 32px 64px;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.bankrate-social-footer {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 8px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #dddddd;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n.bankrate-social-footer__title {\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 1.5px;\n  padding-right: 16px;\n  color: #1a1e22;\n  text-transform: uppercase;\n}\n.bankrate-social-footer__icon {\n  max-width: 36px;\n  height: auto;\n  object-fit: contain;\n  padding-right: 16px;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.br-value-props__wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px;\n  text-align: center;\n  max-width: 1100px;\n}\n.br-value-props__heading {\n  font-weight: 600;\n  font-size: 32px;\n  margin-bottom: 64px;\n}\n.br-value-props__list {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n.br-value-props__item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 32px;\n}\n.br-value-props__item:last-of-type {\n  margin-bottom: 0;\n}\n.br-value-props__item-heading {\n  font-weight: 600;\n  font-size: 22px;\n  margin-bottom: 24px;\n}\n.br-value-props__item-blurb {\n  padding: 24px;\n}\n.br-value-props__icon-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 75px;\n  margin-bottom: 32px;\n  width: 100%;\n}\n.br-value-props__icon {\n  display: block;\n  height: 100%;\n}\n\n@media (min-width: 400px) {\n  .br-value-props__wrapper {\n    padding: 32px;\n  }\n  .br-value-props__item {\n    margin-bottom: 64px;\n  }\n  .br-value-props__item-blurb {\n    padding: 0 64px;\n  }\n}\n@media (min-width: 750px) {\n  .br-value-props__list {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n  }\n  .br-value-props__item {\n    margin-left: 32px;\n    margin-right: 32px;\n    margin-bottom: 0;\n  }\n  .br-value-props__item:first-of-type {\n    margin-left: 0;\n  }\n  .br-value-props__item:last-of-type {\n    margin-right: 0;\n  }\n  .br-value-props__item-blurb {\n    padding: 0;\n  }\n}\n@media (min-width: 1100px) {\n  .br-value-props__wrapper {\n    padding: 32px 96px 64px 96px;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.br-rates-variation__container {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 24px;\n  align-items: center;\n  justify-content: center;\n  max-width: 1100px;\n}\n.br-rates-variation__icon {\n  margin-bottom: 24px;\n  height: 50px;\n}\n.br-rates-variation__title {\n  font-size: 28px;\n  text-align: center;\n}\n.br-rates-variation__description-container {\n  margin-bottom: 32px;\n  max-width: 400px;\n}\n.br-rates-variation__description-container p {\n  text-align: center;\n}\n.br-rates-variation__button-wrapper {\n  min-width: 200px;\n}\n.br-rates-variation__cashout-heading {\n  font-weight: 600;\n  font-size: 18px;\n  color: #3d7c54;\n}\n.br-rates-variation__cashout-amount {\n  margin: 24px 0;\n  font-size: 22px;\n  text-align: center;\n}\n.br-rates-variation__cashout-amount span {\n  color: #3d7c54;\n}\n\n@media (min-width: 600px) {\n  .br-norates__description-container {\n    max-width: 600px;\n  }\n  .br-norates__description-container p span {\n    display: block;\n  }\n}\n@media (min-width: 750px) {\n  .br-norates__container {\n    min-height: 400px;\n  }\n  .br-norates__title {\n    font-size: 32px;\n  }\n}\n@media (min-width: 950px) {\n  .br-norates__container {\n    min-height: 500px;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.br-checks-vp__container {\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n  font-weight: 600;\n  font-size: 14px;\n  justify-content: space-between;\n  margin: 24px auto;\n  max-width: 320px;\n  border: 1px solid #b2b2b2;\n  border-radius: 10px;\n}\n.br-checks-vp__checks-container {\n  display: flex;\n  margin: 16px 0;\n  padding-left: 8px;\n}\n.br-checks-vp__image {\n  margin-right: 16px;\n  width: 18px;\n}\n.br-checks-vp__vertical-line {\n  display: none;\n}\n\n@media (min-width: 950px) {\n  .br-checks-vp__container {\n    display: flex;\n    flex-direction: row;\n    padding: 16px 24px;\n    margin-top: 32px;\n    font-size: 18px;\n    max-width: 1000px;\n  }\n  .br-checks-vp__vertical-line {\n    display: block;\n    width: 2px;\n    background-color: #dadada;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.br-how-it-works__container {\n  display: flex;\n  flex-direction: column;\n  margin: 24px;\n  text-align: center;\n  align-items: center;\n}\n@media (min-width: 950px) {\n  .br-how-it-works__container {\n    margin: 32px;\n    flex-direction: row;\n    text-align: left;\n    align-items: unset;\n    justify-content: center;\n  }\n}\n@media (min-width: 950px) {\n  .br-how-it-works__blurb-container {\n    max-width: 600px;\n  }\n}\n.br-how-it-works__heading {\n  margin-bottom: 16px;\n  font-weight: 600;\n  font-size: 22px;\n}\n.br-how-it-works__description {\n  font-size: 14px;\n}\n@media (min-width: 950px) {\n  .br-how-it-works__description {\n    margin-right: 64px;\n  }\n}\n.br-how-it-works__sub-heading {\n  font-size: 18px;\n  margin-bottom: 16px;\n}\n@media (min-width: 950px) {\n  .br-how-it-works__sub-heading {\n    margin-bottom: 0;\n  }\n}\n.br-how-it-works__rate-table-image {\n  width: 100%;\n  max-width: 400px;\n}\n.br-how-it-works__promise-heading {\n  font-weight: 600;\n  font-size: 18px;\n  color: #3d7c54;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.br-cards-vp__container {\n  margin: 64px 4px;\n  text-align: center;\n}\n@media (min-width: 950px) {\n  .br-cards-vp__bg-container {\n    display: flex;\n    justify-content: center;\n    background: url(\"@mortgage-pos/ui/assets/bankrate/BR_Dashed_Line.svg\") no-repeat;\n    background-size: contain;\n    background-position: center;\n  }\n}\n@media (min-width: 950px) {\n  .br-cards-vp__cards-container {\n    display: flex;\n    justify-content: space-between;\n    max-width: 1000px;\n    width: 100%;\n  }\n}\n.br-cards-vp__heading {\n  font-weight: 600;\n  font-size: 22px;\n  margin-bottom: 16px;\n}\n.br-cards-vp__card-container {\n  display: flex;\n  flex-direction: column;\n  margin: 32px 0;\n  background-color: #fff;\n  align-items: center;\n}\n@media (min-width: 950px) {\n  .br-cards-vp__card-container {\n    margin: 16px 16px 0;\n    padding: 16px;\n    gap: 8px;\n    width: 300px;\n    min-height: 165px;\n    justify-content: center;\n    border-radius: 8px;\n    box-shadow: 0px 0px 3px rgba(21, 21, 21, 0.1), 0px 8px 16px -3px rgba(21, 21, 21, 0.2);\n  }\n  .br-cards-vp__card-container:first-of-type {\n    margin-left: 0;\n  }\n  .br-cards-vp__card-container:last-of-type {\n    margin-right: 0;\n  }\n}\n.br-cards-vp__card-image {\n  width: 32px;\n}\n@media (min-width: 950px) {\n  .br-cards-vp__card-image {\n    width: 48px;\n  }\n}\n.br-cards-vp__card-heading {\n  font-weight: 600;\n  font-size: 14px;\n}\n@media (min-width: 950px) {\n  .br-cards-vp__card-description {\n    max-width: 88%;\n  }\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.review-page__container {\n  margin: 32px 0;\n  display: grid;\n  grid-template-areas: \"text\" \"rate\" \"button\";\n}\n@media (min-width: 950px) {\n  .review-page__container {\n    margin: 32px 24px;\n    grid-template-areas: \"text text rate\" \"button . rate\";\n  }\n  .review-page__container.\\--no-grid {\n    display: unset;\n  }\n}\n.review-page__container .loan-officer-popup__container {\n  padding: 16px;\n  margin: 16px 0 8px;\n  border: 1px solid #3d7c54;\n  border-radius: 8px;\n}\n.review-page__container .loan-officer-popup__text-container,\n.review-page__container .loan-officer-popup__hyperlink {\n  color: #1a1e22;\n  cursor: pointer;\n}\n.review-page__details-container {\n  grid-area: text;\n}\n.review-page__details-step-heading {\n  margin-bottom: 8px;\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 1.5px;\n  color: #3d7c54;\n  text-transform: uppercase;\n}\n.review-page__details-section-container {\n  margin-bottom: 32px;\n}\n.review-page__details-section-title {\n  padding: 8px 0;\n  margin: 16px 0;\n  font-weight: 600;\n  font-size: 22px;\n  letter-spacing: 1px;\n  border-bottom: 1px solid #b2b2b2;\n  word-break: break-word;\n}\n.review-page__details-section-content {\n  margin: 16px 0;\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  grid-gap: 16px 32px;\n}\n.review-page__details-section-content-heading {\n  font-weight: 600;\n  font-size: 14px;\n  text-transform: uppercase;\n}\n@media (min-width: 750px) {\n  .review-page__details-section-content-heading {\n    font-size: 18px;\n  }\n}\n.review-page__details-section-content-body {\n  font-size: 14px;\n  overflow-wrap: anywhere;\n  white-space: pre-wrap;\n}\n@media (min-width: 750px) {\n  .review-page__details-section-content-body {\n    font-size: 18px;\n  }\n}\n.review-page__rate-lo-info-container {\n  grid-area: rate;\n}\n.review-page__rate-lo-info-container.\\--phone-app {\n  max-width: 400px;\n  margin: 32px auto 0;\n}\n@media (min-width: 950px) {\n  .review-page__rate-lo-info-container {\n    margin: 0 0 24px 32px;\n  }\n}\n@media (min-width: 1100px) {\n  .review-page__rate-lo-info-container {\n    margin: 0 0 24px 64px;\n  }\n}\n.review-page__rate-container {\n  margin: 24px auto;\n  max-width: 300px;\n  background-color: #246464;\n  border-radius: 8px;\n}\n.review-page__rate-screenshot {\n  padding: 2px 16px 16px;\n}\n.review-page__rate-screenshot .rate-card-masonry {\n  padding: 16px;\n  margin: 8px auto;\n  background-color: #fff;\n  width: 265px;\n}\n.review-page__rate-heading {\n  font-size: 22px;\n  padding: 16px 24px 2px;\n  color: #fff;\n}\n.review-page__continue-button {\n  grid-area: button;\n  margin: 24px 0;\n}\n.review-page__continue-button button {\n  padding: 16px 32px;\n  width: 100%;\n}\n.review-page__continue-link {\n  margin-bottom: 24px;\n  font-weight: 600;\n  font-size: 18px;\n  text-align: center;\n  display: block;\n}\n.review-page__continue-description {\n  margin: 24px 0 16px;\n  max-width: 600px;\n}\n.review-page__continue-list {\n  display: flex;\n  flex-direction: row;\n  margin: 16px 0;\n  gap: 16px;\n}\n.review-page__continue-list-image {\n  width: 20px;\n  height: 22px;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.update-rates__form {\n  margin: 24px;\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  justify-content: space-around;\n  flex-flow: wrap;\n  min-width: 200px;\n  max-width: 300px;\n  border-bottom: 1px solid #dddddd;\n}\n.update-rates__form.\\--modal {\n  flex-flow: wrap;\n  justify-content: space-around;\n}\n.update-rates__button-container {\n  margin: 24px;\n}\n.update-rates__button-wrapper {\n  display: flex;\n  flex-direction: row;\n  padding: 0;\n  font-weight: 600;\n  font-size: 12px;\n  cursor: pointer;\n  width: 183px;\n  height: 50px;\n}\n.update-rates__submit-button {\n  border-radius: 24px;\n  padding: 16px;\n  text-transform: none;\n  height: 50px;\n  max-width: 300px;\n  color: #fff;\n  background-color: #3d7c54;\n}\n.update-rates__submit-button:disabled {\n  background-color: #dddddd;\n  color: #fff;\n}\n\n@media (min-width: 450px) {\n  .update-rates__form {\n    min-width: 400px;\n    max-width: 550px;\n  }\n  .update-rates__button-wrapper {\n    width: 300px;\n  }\n}\n@media (min-width: 1300px) {\n  .update-rates__form {\n    display: flex;\n    flex-direction: row;\n    border: none;\n    max-width: 100%;\n    flex-flow: nowrap;\n  }\n  .update-rates__submit-button {\n    min-width: 165px;\n    max-width: 165px;\n    margin-top: 22px !important;\n  }\n  .update-rates__button-container {\n    margin: 8px;\n  }\n  .update-rates__button-wrapper {\n    width: 188px;\n  }\n}\n.success-confetti-screen__container {\n  display: flex;\n  flex-direction: column;\n  margin: 0 24px 24px 24px;\n  justify-content: center;\n  align-items: center;\n  flex-grow: 1;\n  text-align: center;\n  background-color: #f1f9f1;\n  border-radius: 50%;\n  min-height: 480px;\n  width: calc(100% + 64px);\n  max-width: 500px;\n}\n@media (min-width: 950px) {\n  .success-confetti-screen__container {\n    max-width: 800px;\n  }\n}\n.success-confetti-screen__title {\n  font-weight: 600;\n  font-size: 28px;\n}\n@media (min-width: 950px) {\n  .success-confetti-screen__title {\n    font-size: 32px;\n  }\n}\n.success-confetti-screen__subtitle {\n  margin: 8px 0;\n  font-size: 18px;\n  max-width: 80%;\n}\n@media (min-width: 950px) {\n  .success-confetti-screen__subtitle {\n    font-size: 22px;\n  }\n}\n.success-confetti-screen__description {\n  margin: 8px 0;\n  max-width: 90%;\n}\n.success-confetti-screen__button {\n  margin: 24px 0;\n  text-transform: inherit;\n  flex-grow: 0;\n  width: 75%;\n}\n@media (min-width: 950px) {\n  .success-confetti-screen__button {\n    width: 50%;\n  }\n}\n.success-confetti-screen__animation {\n  position: fixed;\n  pointer-events: none;\n  width: 100%;\n  height: 100%;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.list-content__title {\n  font-weight: 600;\n  font-size: 16px;\n  margin-bottom: 4px;\n}\n.list-content__option {\n  display: flex;\n  flex-direction: row;\n  padding: 4px;\n}\n.list-content__option-checkmark-wrapper {\n  display: flex;\n  align-items: center;\n}\n.list-content__option-text {\n  font-weight: 400;\n  font-size: 12px;\n  margin-left: 8px;\n}\n\n.bankrate-modal {\n  text-align: center;\n  padding: 32px;\n}\n@media (min-width: 950px) {\n  .bankrate-modal {\n    width: 600px;\n  }\n}\n.bankrate-modal__pre-header {\n  font-weight: 600;\n  font-size: 18px;\n  margin-bottom: 8px;\n  color: #3d7c54;\n}\n.bankrate-modal__header {\n  font-weight: 600;\n  font-size: 28px;\n  margin-bottom: 16px;\n}\n.bankrate-modal__body {\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.robinhood-banner {\n  width: 100%;\n  max-width: 425px;\n  background: #fffbee;\n  border-radius: 8px;\n  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);\n  padding: 16px;\n  margin-bottom: 16px;\n  margin-top: -20px;\n}\n.robinhood-banner__content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.robinhood-banner__title {\n  color: var(--Secondary-Slate, #5d5d5e);\n  font-family: \"Rh-phonic\";\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n.robinhood-banner__icon {\n  width: 14px;\n  height: 18px;\n  margin-left: 0;\n  vertical-align: middle;\n  position: relative;\n  top: -1px;\n}\n.robinhood-banner__gold {\n  color: #000000;\n}\n.robinhood-banner__description {\n  font-size: 14px;\n  line-height: 1.4;\n  color: #333333;\n  font-family: \"poppins\", -apple-system, BlinkMacSystemFont, sans-serif;\n  margin-top: 2px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n  letter-spacing: -0.1px;\n}\n.robinhood-banner__highlight {\n  font-weight: 600;\n}\n.robinhood-banner__learn-more {\n  font-size: 14px;\n  font-weight: 600;\n  color: #000;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-decoration: underline;\n  padding-left: 6px;\n}\n.robinhood-banner__learn-more:hover {\n  text-decoration: underline;\n}\n.robinhood-banner__learn-more:focus {\n  outline: none;\n}\n.robinhood-banner__arrow {\n  margin-left: 4px;\n  font-size: 18px;\n}\n\n@media (min-width: 950px) {\n  .robinhood-banner {\n    padding: 20px;\n    max-width: none;\n  }\n  .robinhood-banner__content {\n    gap: 12px;\n  }\n  .robinhood-banner__title {\n    font-size: 14px;\n    line-height: 24px;\n  }\n  .robinhood-banner__gold {\n    font-size: 14px;\n  }\n  .robinhood-banner__icon {\n    width: 16px;\n    height: 20px;\n  }\n  .robinhood-banner__description {\n    font-size: 16px;\n    letter-spacing: -0.2px;\n  }\n}\n@media (min-width: 1100px) {\n  .robinhood-banner {\n    padding: 24px;\n  }\n  .robinhood-banner__content {\n    gap: 14px;\n  }\n  .robinhood-banner__title {\n    font-size: 15px;\n  }\n  .robinhood-banner__gold {\n    font-size: 15px;\n  }\n  .robinhood-banner__description {\n    font-size: 18px;\n    line-height: 170%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
